<template>
  <nav
    ref="mainNav"
    :id="[pathUrl == 'FullStream' ? 'Fusion_nav_FullStream' : '']"
    v-if="
      (pathUrl == 'FullStream' && Status_Error == false) &&
      pathUrl != 'Snippet'
    ">
    <v-skeleton-loader
      :loading="!flagNav"
      transition="scale-transition"
      max-height="64px"
      class="pa-0"
      type="card">
      <v-app-bar
        :elevation="0"
        :class="pathUrl == 'FullStream' ? 'fullstream-header-cover' : 'header-cover'"
        :id="[pathUrl == 'FullStream' ? 'Fusion_toolbar_FullStream' : '']"
        style="
          box-shadow: none !important;
          background-color: #ffffff !important;
          height: 64px !important;
          padding-right: 8px;
        ">
        <!-- Logo สำหรับ FullStream บน Desktop -->
        <img
          v-if="pathUrl == 'FullStream' && mdAndUp"
          id="Fusion_Logo_FullStream"
          alt="Fusion Logo"
          class="logo-left-fixed logo-symmetric"
          :src="images.logo"
          :style="{ 
            width: smAndUp ? '150px' : '100px', 
            height: '54px',
            objectFit: 'contain',
            objectPosition: 'center',
            cursor: 'unset'
          }" />

        <!-- Logo สำหรับหน้าอื่นๆ -->
        <img
          v-if="pathUrl != 'FullStream'"
          id="Fusion_Logo_Header"
          alt="Fusion Logo"
          class="logo-left-fixed clickable logo-symmetric"
          :src="images.logo"
          @click="$router.currentRoute.name != 'dashboard' ? homepage() : ''"
          :style="{ 
            width: smAndUp ? '150px' : '110px', 
            height: '54px',
            objectFit: 'contain',
            objectPosition: 'center'
          }" />

        <v-btn
          v-if="pathUrl == 'FullStream' && !mdAndUp"
          @click.stop="drawerMobile = !drawerMobile"
          icon
          variant="text"
          class="fullstream-mobile-sidebar-btn"
          title="drawerMobile"
          :disabled="(!Snippet_Username && Snippet_Status == true) ||
            (!Snippet_Username == '' && !Snippet_Status)
            "
          :style="fullstreamActionButtonStyle">
          <Icon icon="lucide:panel-left-open" class="fullstream-nav-icon" />
        </v-btn>
        <v-app-bar-nav-icon
          v-if="pathUrl != 'FullStream'"
          @click.stop="drawer = !drawer"
          title="drawer"
          color="#1f211f"
          :style="!smAndUp ? 'margin-left: 0px;' : 'margin-left: 3rem;'
            "></v-app-bar-nav-icon>
        <v-spacer></v-spacer>

        <span
          v-if="smAndUp && pathUrl != 'FullStream'"
          :style="'color: #' +
            (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined
              ? NavbarTxtColorTheme
              : 'FFFFFF')
            "
          style="
            font-size: 12px;
            margin-right: 12px;
            margin-bottom: 0px;
            margin-top: 30px;
          ">
          {{ versioning != null && versioning != "" ? "Version" : "" }}
          {{ "R" + versioning }}
        </span>
        <v-menu v-if="pathUrl != 'FullStream'" location="bottom">
          <template v-slot:activator="{ props }">
            <v-btn
              icon
              variant="text"
              size="small"
              v-bind="props"
              class="mr-4"
              :style="'background: #' +
                (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined
                  ? NavbarBtnColorTheme
                  : '5179ef')
                ">
              <flag :iso="currentflag" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="entry in languages" :key="entry.title"
              @click="changeLocale(entry.language, entry.flag)">
              <template v-slot:prepend>
                <flag :iso="entry.flag" v-bind:squared="false" />
              </template>
              <v-list-item-title>{{ entry.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- add button  Turn sound on/off -->
        <v-btn
          v-if="pathUrl != 'FullStream'"
          icon
          variant="text"
          size="small"
          class="mr-4"
          @click="toggleSound"
          :style="'background: #' +
            (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined
              ? NavbarBtnColorTheme
              : '5179ef')
            ">
          <v-icon :color="'white'" size="20">
            {{ soundEnabled ? 'mdi-volume-high' : 'mdi-volume-off' }}
          </v-icon>
        </v-btn>

        <v-menu v-if="pathUrl != 'FullStream'" location="bottom" :close-on-content-click="false"
          transition="slide-y-transition"
          :offset="10" rounded="lg" min-width="220">
          <template v-slot:activator="{ props }">
            <v-btn
              id="button-username-navbar"
              v-bind="props"
              class="user-profile-button"
              elevation="1"
              :color="NavbarBtnColorTheme || '5179ef'"
              :ripple="false"
              :style="'background: #' +
                (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined
                  ? NavbarBtnColorTheme
                  : '5179ef')
                ">
              <div class="d-flex align-center">
                <v-avatar size="28" class="mr-2" color="white" variant="flat">
                  <span
                    class="text-caption font-weight-medium"
                    :style="`color: #${NavbarBtnColorTheme || '5179ef'}`"
                    >
                    {{
                      username ? username.substring(0, 1).toUpperCase() : "U"
                    }}
                  </span>
                </v-avatar>
                <span
                  class="user-name"
                  :style="`color: #${NavbarTxtColorTheme || 'FFFFFF'}`">
                  {{ username }}
                </span>
                <v-icon
                  size="small"
                  :color="NavbarTxtColorTheme || 'FFFFFF'"
                  class="ml-1">
                  mdi-chevron-down
                </v-icon>
              </div>
            </v-btn>
          </template>

          <v-card class="user-menu-card" elevation="3">
            <!-- User profile header -->
            <v-card-item class="user-menu-header pa-4">
              <template v-slot:prepend>
                <v-avatar
                  size="42"
                  :color="NavbarBtnColorTheme || '5179ef'"
                  class="mr-3">
                  <span class="text-h6 font-weight-medium white--text">
                    {{ shotName }}
                  </span>
                </v-avatar>
              </template>

              <v-card-title class="pa-0">
                <div>
                  <div class="text-body-1 font-weight-medium mb-0">
                    {{ fullName }}
                  </div>
                  <div class="text-caption text-medium-emphasis">
                    {{ role }}
                  </div>
                </div>
              </v-card-title>
            </v-card-item>

            <v-divider></v-divider>

            <!-- Menu items -->
            <v-list class="pa-2" nav density="comfortable">
              <v-list-item v-for="v in ddProfile" :key="v.no" :value="v.title" @click="v.action" :to="v.route"
                class="menu-list-item mb-1 rounded" :ripple="true">
                <template v-slot:prepend>
                  <v-icon
                    :color="v.no === 4 ? 'error' : 'primary'"
                    size="small"
                    class="mr-2">{{ v.icon }}</v-icon>
                </template>
                <v-list-item-title class="menu-item-title" :class="{ 'text-error': v.no === 4 }">
                  {{ localize(v.title) }}
                </v-list-item-title>
              </v-list-item>
            </v-list>

            <v-card-text class="pt-2 pb-3 px-4 text-center">
              <div class="text-caption text-medium-emphasis">
                {{ "Version R" + versioning }}
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
        <span v-if="Snippet_Username != ''" style="
            color: black;
            padding-top: 4px;
            text-align: center;
            font-weight: bold;
            height: 25px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          ">
          {{ Snippet_Username }}
        </span>
        <!-- {{$route.name}}LoginSnippet -->
        <button type="button" id="login-fullsnippet-btn" v-if="
          showBTNLogin &&
          isSnippet &&
          $route.name != 'LoginSnippet' &&
          (Snippet_Username == '' ||
            Snippet_Username == null ||
            Snippet_Username == undefined)
        " style="
            border: none;
            font: inherit;
            box-sizing: content-box;
            background-color: #333;
            margin-top: 3px;
            margin-right: 15px;
            padding: 5px;
            font-size: 12px;
            width: 70px;
            height: 25px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
            z-index: 9999;
          " v-on:click="OpenTabLogin()">
          <span style="color: white; text-align: center"> LOGIN </span>
        </button>
        <button type="button" id="logout-fullsnippet-btn" v-else-if="Snippet_Username != ''" style="
            border: none;
            font: inherit;
            box-sizing: content-box;
            background-color: #333;
            margin-top: 8px;
            margin-left: 8px;
            padding: 5px;
            font-size: 12px;
            width: 70px;
            height: 25px;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
            z-index: 9999;
          " v-on:click="chatLogout()">
          <span style="color: white; text-align: center"> LOGOUT </span>
        </button>

        <!-- {{ Fullstream USER_ID }} -->
        <div v-if="
          pathUrl == 'FullStream' &&
          !isSnippet &&
          User_Id_Show != null &&
          User_Id_Show != '' &&
          User_Id_Show != undefined &&
          mdAndUp
        ">
          <span>{{
            User_Id_Show != null &&
              User_Id_Show != "" &&
              User_Id_Show != undefined
              ? User_Id_Show
              : ""
          }}</span>
          <v-btn size="small" icon text style="
              font-size: 16px;
              font-family: inter, sans-serif;
              font-style: normal;
              margin-left: 14px;
            " :style="'background: #' +
              (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined
                ? NavbarBtnColorTheme
                : 'D96666')
              " disabled fab>
            <span :style="'color: #' +
              (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined
                ? NavbarTxtColorTheme
                : 'FFFFFF')
              ">{{
                User_Id_Show != null &&
                  User_Id_Show != "" &&
                  User_Id_Show != undefined &&
                  User_Id_Show.length > 1
                  ? User_Id_Show.substring(0, 2)
                  : ""
              }}</span>
          </v-btn>
        </div>
        <!-- {{ Fullstream USER_ID Mobile }} -->
      </v-app-bar>
    </v-skeleton-loader>
    <v-tooltip location="bottom" v-model="showSidebarTooltip">
      <template v-slot:activator="{ props }">
        <div
          v-if="pathUrl == 'FullStream' && mdAndUp && !drawerFull"
          class="floating-nav-button-div"
          style="left: 15px"
          @click="sidebarClickHandle"
          v-bind="props">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="fullstream-nav-icon" :style="fullstreamActionIconStyle">
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M2 12c0-3.69 0-5.534.814-6.841a4.8 4.8 0 0 1 1.105-1.243C5.08 3 6.72 3 10 3h4c3.28 0 4.919 0 6.081.916c.43.338.804.759 1.105 1.243C22 6.466 22 8.31 22 12s0 5.534-.814 6.841a4.8 4.8 0 0 1-1.105 1.243C18.92 21 17.28 21 14 21h-4c-3.28 0-4.919 0-6.081-.916a4.8 4.8 0 0 1-1.105-1.243C2 17.534 2 15.69 2 12Z" />
              <path stroke-linejoin="round" d="M9.5 3v18" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 7h1m-1 3h1" />
            </g>
          </svg>
        </div>
      </template>
      <span>Open sidebar</span>
    </v-tooltip>

    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <div
          v-if="pathUrl == 'FullStream' && mdAndUp && !drawerFull"
          class="floating-nav-button-div"
          style="left: 15px; top: 118px"
          @click="newChat()"
          v-bind="props">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="fullstream-nav-icon" :style="fullstreamActionIconStyle">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM12 8v6m-3-3h6" />
          </svg>
        </div>
      </template>
      <span>New Chat</span>
    </v-tooltip>

    <v-menu
      v-if="isAllowLLMChange && pathUrl == 'FullStream' && mdAndUp && !drawerFull"
      v-model="showFloatingLLMMenu"
      location="end"
      offset="12"
      :close-on-content-click="false"
      transition="slide-x-transition">
      <template v-slot:activator="{ props: menuProps }">
        <div
          class="floating-nav-button-div"
          style="left: 15px; top: 166px"
          v-bind="menuProps"
          :title="'Select LLM Model'">
          <Icon icon="lucide:sparkles" class="fullstream-nav-icon" :style="fullstreamActionIconStyle" />
        </div>
      </template>
      <v-card class="custom-model-card floating-llm-menu-card">
        <div class="custom-model-header">Select LLM Model</div>
        <div class="custom-model-content">
          <v-expansion-panels v-model="expandedPanel" variant="accordion" class="minimal-panels" flat>
            <v-expansion-panel v-for="provider in providers" :key="provider.id" class="minimal-panel">
              <v-expansion-panel-title class="py-2 minimal-header">
                <div class="d-flex align-center">
                  <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                  <span class="provider-name">{{ provider.name }}</span>
                  <v-chip size="x-small" class="ml-2 minimal-chip" :color="`${provider.color}15`"
                    :text-color="provider.color">
                    {{ getModelsByProvider(provider.id).length }}
                  </v-chip>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pt-0 pb-0 minimal-content">
                <v-list density="compact" class="model-list py-0 minimal-list">
                  <v-list-item v-for="model in getModelsByProvider(provider.id)" :key="model.id"
                    @click="SelectLLMMdel(model); showFloatingLLMMenu = false" class="minimal-list-item"
                    :class="{ 'selected-model': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }">
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                      <v-list-item-subtitle class="caption text--secondary">{{ model.modelName }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                      <v-list-item-action>
                        <v-icon size="16" color="primary">mdi-check</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card>
    </v-menu>

    <v-btn fab small color="transparent" elevation="0" style="transition: transform 0.3s cubic-bezier(0.2, 0, 0.4, 1)">
    </v-btn>
    <!-- Fullstream -->
    <v-navigation-drawer id="NavFullStream" v-if="pathUrl == 'FullStream' && mdAndUp"
      v-show="$route.name == 'FullStream'"
      style="
        top: 64px;
        max-height: calc(-64px + 100dvh);
        height: calc(-64px + 100dvh);
        border-radius: 0%;
        box-shadow: none !important;
        border-style: none !important;
        padding-bottom: calc(0px + env(safe-area-inset-bottom));
        z-index: 10;
      " :style="mini ? 'background-color: #FFFFFF' : 'background-color: #ECF0F4'" v-model="drawerFull"
      overlay-opacity="0.2" app left v-model:mini-variant="checkMini">
      <v-col class="drawer-header-sticky" :class="{ scrolled: isScrolled }">
        <!-- USER ID -->
        <v-row v-show="!mini" style="
            scale: 0.9;
            margin-top: -6px;
            margin-left: -15px;
            width: 120px !important;
          ">
          <v-col style="padding: 0px">
            <div class="user-id-badge">
              <div class="user-id-icon">
                <v-icon size="15" color="white">mdi-account</v-icon>
              </div>
              <div class="user-id-content">
                <span class="user-id-label">User ID</span>
                <span class="user-id-value">{{
                  User_Id_Show || "Not assigned"
                }}</span>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-tooltip location="bottom">
          <template v-slot:activator="{ props }">
            <div
              class="floating-nav-button-div"
              @click="drawerFull = false"
              v-bind="props"
              style="top: 8px">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="fullstream-nav-icon" :style="fullstreamActionIconStyle">
                <g fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M2 12c0-3.69 0-5.534.814-6.841a4.8 4.8 0 0 1 1.105-1.243C5.08 3 6.72 3 10 3h4c3.28 0 4.919 0 6.081.916c.43.338.804.759 1.105 1.243C22 6.466 22 8.31 22 12s0 5.534-.814 6.841a4.8 4.8 0 0 1-1.105 1.243C18.92 21 17.28 21 14 21h-4c-3.28 0-4.919 0-6.081-.916a4.8 4.8 0 0 1-1.105-1.243C2 17.534 2 15.69 2 12Z" />
                  <path stroke-linejoin="round" d="M9.5 3v18" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 7h1m-1 3h1" />
                </g>
              </svg>
            </div>
          </template>
          <span>Close sidebar</span>
        </v-tooltip>
      </v-col>
      <v-col style="margin-top: 15px">
        <!-- LLM Model -->
        <v-row v-show="!mini" v-if="isAllowLLMChange && pathUrl == 'FullStream'">
          <v-col class="pb-2">
            <span style="font-weight: bold; font-size: 18px; color: #71717A;">LLM Model</span>
          </v-col>
        </v-row>
        <v-row v-show="!mini" v-if="isAllowLLMChange && pathUrl == 'FullStream'" style="margin-top: 0px; margin-bottom: 8px;">
          <v-col style="padding-top: 0px; padding-bottom: 0px;" class="px-4">
            <div class="model-selector sidebar-llm-selector">
              <div class="dropdown-container">
                <div class="model-dropdown d-flex align-center" @click="toggleModelDropdown">
                  <span class="model-name">{{ selectedLLMModel ? selectedLLMModel.modelDisplay : "LLMs (default)" }}</span>
                  <v-btn v-if="selectedLLMModel" variant="text" icon x-small class="ml-3 clear-model-btn"
                    @click.stop="clearSelectedModel($event)">
                    <v-icon size="14" color="grey">mdi-close-circle</v-icon>
                  </v-btn>
                  <v-icon size="18" class="ml-1 text--secondary">mdi-chevron-down</v-icon>
                </div>
                <div v-if="showModelDropdown" class="custom-dropdown-menu" v-click-outside="closeModelDropdown">
                  <div class="custom-model-card">
                    <div class="custom-model-header">Select LLM Model</div>
                    <div class="custom-model-content">
                      <v-expansion-panels v-model="expandedPanel" variant="accordion" class="minimal-panels" flat>
                        <v-expansion-panel v-for="provider in providers" :key="provider.id" class="minimal-panel">
                          <v-expansion-panel-title class="py-2 minimal-header">
                            <div class="d-flex align-center">
                              <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                              <span class="provider-name">{{ provider.name }}</span>
                              <v-chip size="x-small" class="ml-2 minimal-chip" :color="`${provider.color}15`"
                                :text-color="provider.color">
                                {{ getModelsByProvider(provider.id).length }}
                              </v-chip>
                            </div>
                          </v-expansion-panel-title>
                          <v-expansion-panel-text class="pt-0 pb-0 minimal-content">
                            <v-list density="compact" class="model-list py-0 minimal-list">
                              <v-list-item v-for="model in getModelsByProvider(provider.id)" :key="model.id"
                                @click="SelectLLMMdel(model); closeModelDropdown()" class="minimal-list-item"
                                :class="{ 'selected-model': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }">
                                <v-list-item-content class="py-1">
                                  <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                                  <v-list-item-subtitle class="caption text--secondary">{{ model.modelName
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                                  <v-list-item-action>
                                    <v-icon size="16" color="primary">mdi-check</v-icon>
                                  </v-list-item-action>
                                </template>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Parameter -->
        <v-row v-show="!mini">
          <v-col class="pb-0">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Parameters</span>
          </v-col>
          <v-col v-show="!mini">
            <div style="
                  position: absolute;
                  font-size: 12px;
                  left: 0px;
                  bottom: -1px;
                  background-color: rgb(236, 240, 244);
                  height: 20px;
                  width: 95px;
                  z-index: 9999;
                  border-radius: 0 12px 0 0;
                ">
              <span style="
                  font-size: 12px;
                  color: #5f5f5f;
                  margin-left: 8px;
                ">
                {{ versioning != "" || versioning != null ? "Version" : "" }}
                {{ "R" + versioning }}
              </span>
            </div>
          </v-col>
        </v-row>
        <!-- Time delay -->
        <v-row v-show="!mini">
          <v-col style="padding-top: 0px" class="px-4">
            <span style="font-size: 14px">Time Delay</span>
          </v-col>
        </v-row>
        <v-row v-show="!mini" style="margin-top: 0px">
          <v-col style="padding-top: 0px; padding-bottom: 0px" class="px-4">
            <v-text-field v-model="Time_Delay" type="number" variant="outlined" density="compact" hide-details min="0"
              max="1000" suffix="ms" prepend-inner-icon="mdi-timer-outline" class="time-delay-input" rounded="lg"
              color="primary" bg-color="white" :rules="[
                (v) => (v >= 0 && v <= 1000) || 'Value must be between 0-1000',
              ]">
            </v-text-field>
          </v-col>
        </v-row>

        <!-- Folder -->
        <v-row v-show="!mini" style="padding-top: 21px;">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717A;">Folder</span>
          </v-col>
          
          <v-col class="col-7" style="
              background-color: transparent;
              padding-top: 0px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            ">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
              <div class="new-chat-fab" style="margin-right: 7px;" :color="selectedColor" v-bind="props" @click="createFolder">
                <Icon icon="lucide:folder-plus" class="fullstream-nav-icon" :style="fullstreamActionIconStyle" />
              </div>
              </template>
              <span>Create new folder</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-skeleton-loader style="margin-top: 5px; margin-bottom: 15px; background-color: transparent;"
          :loading="flagLoadingFolders" transition="scale-transition" type="list-item">
          <v-row v-show="!mini" id="folder_list_id" style="margin-top: 0px; display: block;">
            <v-col class="col-12" style="padding: 0;">
              <div id="folder-list" class="folder-list-container">
                <draggable
                  :disabled="true" :group="{ name: 'folder', pull: false, put: false }" :sort="false"
                  v-model="folders"
                  item-key="id">
                  <template #item="{ element: folder, index: idx }">
                    <div class="folder-item">
                      <div class="folder-view" :class="{
                        'drop-target': isDroppingOnFolder === folder.id,
                        'folder-updated-success': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success',
                        'folder-updated-error': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'
                      }" elevation="0" @click="toggleFolder(folder)"
                      @dragover="onDragOverFolder($event, folder)"
                      @dragleave.prevent="onDragLeaveFolder(folder.id)"
                      @drop.stop.prevent="handleDropForNone($event)">
                        <div class="folder-view-content">
                          <v-icon
                            size="24"
                            class="mr-2 fullstream-folder-list-icon"
                            :style="{ color: fullstreamChatAccentColor, opacity: folder.expanded ? 1 : 0.78 }"
                          >
                            {{ folder.expanded ? 'mdi-folder-open' : 'mdi-folder' }}
                          </v-icon>
                          <span class="folder-name" :class="{ 'folder-name-active': folder.expanded }">{{ folder.name
                            }}</span>
                          <!-- Success indicator -->
                          <transition name="fade">
                            <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success'"
                              color="success" size="20" class="folder-status-icon success-bounce">
                              mdi-check-circle
                            </v-icon>
                          </transition>
                          <!-- Error indicator -->
                          <transition name="fade">
                            <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'"
                              color="error" size="20" class="folder-status-icon error-shake">
                              mdi-alert-circle
                            </v-icon>
                          </transition>
                          <v-menu bottom right transition="slide-y-transition" :close-on-content-click="true" offset-y
                            min-width="180" content-class="folder-menu-container">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon
                                v-bind="props"
                                variant="text"
                                size="large"
                                :color="selectedColor"
                                class="topic-menu-button"
                                style="width: 35px !important;height: 35px !important;">
                                <v-icon size="small">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-card class="folder-menu-card">
                              <div class="folder-menu-list">
                                <div
                                  class="folder-menu-item mb-1 px-2"
                                  @click="startEditFolder(folder, idx)"
                                  style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease;"
                                >
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2">Rename</span>
                                  </div>
                                </div>
                                <div
                                  style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;">
                                </div>
                                <div
                                  class="folder-menu-item mt-1 px-2"
                                  @click="openDeleteDialog(folder, idx)"
                                  style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease;"
                                >
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2 error--text" style="color: #ff5252 !important;">Delete</span>
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </v-menu>
                        </div>
                      </div>
                      <!-- {{ Subtopic }} -->
                      <div v-if="folder.expanded" class="folder-subtopics" style="padding: 8px 0px 0px 6px !important;">
                          <div :id="'topic-list-' + folder.id" class="topic-list-container" >
                          <div v-show="folder.topics">
                            <draggable
                              :list="folder.topics"
                              :group="{ name: 'topics', pull: true, put: false }"
                              :sort="false"
                              :animation="150"
                              item-key="topicID"
                              ghost-class="sortable-ghost"
                              @start="onDragStart($event, folder), onDragStartFromOutside(false)"
                              @end="onDragEnd($event, folder)"
                              class="no-select"
                            >
                              <template #item="{ element: item, index }">
                                <div :key="item.topicID" class="topic-item" :class=" item.topicID === Log_History_TopicID ? 'highlighted-topic' : ''">
                                  <!-- Editing State -->
                                  <div v-if="item.status == true" class="topic-item--editing">
                                    <div class="d-flex align-center w-100">
                                      <div class="flex-grow-1 mr-2">
                                        <v-text-field 
                                          class="Cls_Text_field_TopicName" 
                                          :id="'TopicId_' + item.topicID"
                                          variant="outlined" 
                                          density="compact" 
                                          hide-details 
                                          v-model="item.topicName"
                                          rounded="lg"
                                          style="width: 100%;background-color: #ffffff;font-family: 'Inter', sans-serif;"
                                          @blur="() => { item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token); }"
                                          @keyup="keyupKeyRename()" 
                                          @keyup.enter="
                                            item.status = false;
                                            RenameTopicStream(
                                              item.topicID,
                                              item.keyTopic,
                                              item.topicName,
                                              index,
                                              auth_token
                                            );
                                          " 
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  
                                  <!-- Normal State -->
                                  <div v-else class="topic-item--clickable" @click="selectTopic(item)">
                                    <div class="d-flex align-center w-100">
                                      <div class="topic-icon-wrapper fullstream-topic-icon-wrapper mr-3" :style="{ color: fullstreamChatAccentColor, opacity: item.topicID === Log_History_TopicID ? 1 : 0.78 }">
                                        <Icon icon="lucide:message-square-text" class="fullstream-topic-list-icon" />
                                      </div>
                                      <div class="topic-content flex-grow-1 mr-2">
                                        <v-tooltip location="top" open-delay="300" max-width="300">
                                          <template v-slot:activator="{ props }">
                                            <div v-bind="props" class="topic-title-wrapper" style="max-width: 100%;">
                                              <span class="topic-title text-truncate">
                                                {{ item.topicName }}
                                              </span>
                                            </div>
                                          </template>
                                          <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                                        </v-tooltip>
                                      </div>
                                      
                                      <!-- เมนูของ topic ใน folder -->
                                      <v-menu location="right top" transition="slide-y-transition"
                                        :close-on-content-click="true" offset-y min-width="200"
                                        content-class="topic-menu-container">
                                        <template v-slot:activator="{ props }">
                                          <v-btn
                                            icon
                                            v-bind="props"
                                            variant="text"
                                            size="large"
                                            :color="selectedColor"
                                            class="topic-menu-button">
                                            <v-icon size="small">mdi-dots-vertical</v-icon>
                                          </v-btn>
                                        </template>
                                        <v-card class="topic-menu-card" style="width: 200px; max-width: 100%;">
                                          <div class="topic-menu-list pa-2"
                                            style="border-radius: 12px; border: none; overflow: hidden; background: white;">
                                            <div class="topic-menu-item mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                              @click="openMoveToFolderDialog(item)">
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                              </div>
                                              <div class="d-flex align-center">
                                                <span class="body-2">Move to folder</span>
                                              </div>
                                            </div>
                                            <div class="topic-menu-item mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                              @click="removeTopicFromFolder(folder.id, item.topicID, index)">
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" color="warning">mdi-folder-remove</v-icon>
                                              </div>
                                              <div class="d-flex align-center">
                                                <span class="body-2">Remove from folder</span>
                                              </div>
                                            </div>
                                            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;"></div>
                                            <div class="topic-menu-item mt-1 mb-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                              @click="RenameChat(item); focusInput('TopicId_' + item.topicID)">
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                              </div>
                                              <div>
                                                <span class="body-2">Rename</span>
                                              </div>
                                            </div>
                                            <div class="topic-menu-item mt-1 d-flex align-center"
                                              style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                              @click="openDeleteTopicDialog(item)">
                                              <div class="mr-2 d-flex align-center justify-center">
                                                <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                              </div>
                                              <div>
                                                <span class="body-2 error--text" style="color: #ff5252 !important;">Delete chat</span>
                                              </div>
                                            </div>
                                          </div>
                                        </v-card>
                                      </v-menu>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </draggable>
                          </div>
                          <div v-if="!folder.topics || folder.topics.length === 0" class="empty-folder-state">
                            <v-icon color="grey lighten-1" size="20">mdi-chat-outline</v-icon>
                            <span class="empty-folder-text ml-2">No chats in this folder</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
              </div>
            </v-col>
          </v-row>
        </v-skeleton-loader>
        <!-- Topic -->
        <v-row v-show="!mini" style="padding-top: 21px"  @dragover="onDragOverOutsideDragArea($event)">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Topics</span>
          </v-col>
          <!-- NEW CHAT -->
          <v-col class="col-7" style="
              background-color: transparent;
              padding-top: 0px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            ">
            <button type="button" :color="selectedColor" style="margin-right: 5px; " depressed rounded hide-details class="new-chat-fab" v-on:click="newChat()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="fullstream-topic-action-icon" :style="fullstreamActionIconStyle">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM12 8v6m-3-3h6" />
              </svg>
            </button>
          </v-col>
        </v-row>
        <!-- Topic List -->
        <v-row v-show="!mini" id="toppic_list_id" style="margin-top: 21px; display: block">
          <v-col class="col-12" style="padding-top: 0px; padding-bottom: 10px"
          :class="targetToOutsideArea && !isStartFromOutside ? 'drop-target-outside' : ''"  @dragover="onDragOverOutsideTopic($event)">
            <div class="topic-scroll-container">
                <draggable
                  :list="topicsNotInFolders"
                  :group="{ name: 'topics', pull: true, put: false }" 
                  :sort="false"
                  :animation="150"
                  item-key="topicID"
                  ghost-class="sortable-ghost"
                  @start="onDragStart($event), onDragStartFromOutside(true)"
                  @end="onDragEnd"
                  class="no-select"
                >
                  <template #item="{ element, index }">
                    <div :key="element.topicID" class="topic-item" @click="selectTopicOutside(element)" :class="highlightTopic(element)">
                      <!-- Editing State -->
                      <div v-if="element.status == true" class="topic-item--editing">
                        <div class="d-flex align-center w-100">
                          <div class="flex-grow-1">
                            <v-text-field class="Cls_Text_field_TopicName" :id="'TopicId_' + element.topicID" variant="outlined"
                              density="compact" hide-details v-model="element.topicName" rounded="lg"
                              style="width: 100%;background-color: #ffffff;font-family: 'Inter', sans-serif;"
                              @blur="() => { element.status = false; RenameTopicStream(element.topicID, element.keyTopic, element.topicName, index, auth_token); }"
                              @keyup="keyupKeyRename()" @keyup.enter="
                                element.status = false;
                              RenameTopicStream(
                                element.topicID,
                                element.keyTopic,
                                element.topicName,
                                index,
                                auth_token
                              );
                              " />
                          </div>
                        </div>
                      </div>

                      <!-- Normal State -->
                      <div v-else class="topic-item--clickable" @click="selectTopicOutside(element)">
                        <div class="d-flex align-center w-100">
                          <div class="topic-icon-wrapper fullstream-topic-icon-wrapper mr-3" :style="{ color: fullstreamChatAccentColor, opacity: element.topicID === Log_History_TopicID ? 1 : 0.78 }">
                            <Icon icon="lucide:message-square-text" class="fullstream-topic-list-icon" />
                          </div>

                          <div class="topic-content flex-grow-1 mr-2">
                            <v-tooltip location="top" open-delay="300" max-width="300">
                              <template v-slot:activator="{ props }">
                                <div v-bind="props" class="topic-title-wrapper">
                                  <span class="topic-title text-truncate">
                                    {{ element.topicName }}
                                  </span>
                                </div>
                              </template>
                                <span>{{ element.topicName.length > 100 ? element.topicName.substring(0, 100) + '...' : element.topicName }}</span>
                            </v-tooltip>
                          </div>
                          <v-menu location="right top" transition="slide-y-transition" :close-on-content-click="true" offset-y
                            min-width="200" content-class="topic-menu-container">
                            <template v-slot:activator="{ props }">
                              <v-btn
                                icon
                                v-bind="props"
                                variant="text"
                                size="large"
                                :color="selectedColor"
                                class="topic-menu-button">
                                <v-icon size="small">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-card class="topic-menu-card" style="width: 200px;">
                              <div class="topic-menu-list pa-2"
                                style="border-radius: 12px; border: none; overflow: hidden; background: white;">
                                <div class="topic-menu-item mb-1 d-flex align-center"
                                  style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                  @click="openMoveToFolderDialog(element)">
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                  </div>
                                  <div class="d-flex align-center">
                                    <span class="body-2">Move to folder</span>
                                  </div>
                                </div>

                                <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;">
                                </div>

                                <div class="topic-menu-item mt-1 mb-1"
                                  style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                  @click="RenameClick(element, 'TopicId_' + element.topicID); focusInput('TopicId_' + element.topicID)">
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2">Rename</span>
                                  </div>
                                </div>

                                <div class="topic-menu-item mt-1"
                                  style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                  @click="openDeleteTopicDialog(element)">
                                  <div class="mr-2 d-flex align-center justify-center">
                                    <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                  </div>
                                  <div>
                                    <span class="body-2 error--text" style="color: #ff5252 !important;">Delete chat</span>
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </v-menu>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-navigation-drawer>

    <!-- MOBILE -->
    <v-navigation-drawer v-else-if="
      (pathUrl == 'FullStream' && !mdAndUp && drawerMobile) ||
      (pathUrl == 'FullStream' && !mdAndUp && drawerMobile && LeftNavBar)
    " v-model="drawerMobile" style="
        background-color: #ecf0f4;
        padding-bottom: calc(0px + env(safe-area-inset-bottom));
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      " :scrim="true" temporary left app clipped :width="280" touchless>
      <v-col class="drawer-header-sticky">
        <!-- LOGO -->
        <v-row>
          <v-img id="Fusion_Logo_FullStream_Mobile" alt="Fusion Logo" class="shrink mr-4 app" contain :src="images.logo"
            width="120" max-height="54" style="cursor: unset" />
        </v-row>
      </v-col>

      <v-col style="margin-top: 15px; padding: 0 12px">
        <!-- USER ID Badge -->
        <v-row style="margin-top: 19px; margin-left: -5px; width: 100% !important">
          <v-col style="padding: 0px">
            <div class="user-id-badge">
              <div class="user-id-icon">
                <v-icon size="15" color="white">mdi-account</v-icon>
              </div>
              <div class="user-id-content">
                <span class="user-id-label">User ID</span>
                <span class="user-id-value" style="max-width: 200px">{{
                  User_Id_Show || "Not assigned"
                }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
        <div style="
              position: absolute;
              font-size: 12px;
              left: 0px;
              bottom: -1px;
              background-color: rgb(236, 240, 244);
              height: 20px;
              width: 95px;
              z-index: 9999;
              border-radius: 0 12px 0 0;
            ">
          <span style="
              font-size: 12px;
              color: #5f5f5f;
              margin-left: 8px;
            ">
            {{ versioning != "" || versioning != null ? "Version" : "" }}
            {{ "R" + versioning }}
          </span>
        </div>

        <!-- Parameter -->
        <v-row>
          <v-col class="pb-0">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Parameters</span>
          </v-col>
        </v-row>

        <!-- Time delay -->
        <v-row>
          <v-col style="padding-top: 0px" class="px-4">
            <span style="font-size: 14px">Time Delay</span>
          </v-col>
        </v-row>
        <v-row style="margin-top: 0px">
          <v-col style="padding-top: 0px; padding-bottom: 0px" class="px-4">
            <v-text-field v-model="Time_Delay" type="number" variant="outlined" density="compact" hide-details min="0"
              max="1000" suffix="ms" prepend-inner-icon="mdi-timer-outline" class="time-delay-input" rounded="lg"
              color="primary" bg-color="white" :rules="[
                (v) => (v >= 0 && v <= 1000) || 'Value must be between 0-1000',
              ]">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isAllowLLMChange && pathUrl == 'FullStream' && !mdAndUp">
          <v-col class="pb-2">
            <span style="font-weight: bold; font-size: 18px; color: #71717A;">LLM Model</span>
          </v-col>
        </v-row>
        <v-row v-if="isAllowLLMChange && pathUrl == 'FullStream' && !mdAndUp" style="margin-top: 0px; margin-bottom: 8px;">
          <v-col style="padding-top: 0px; padding-bottom: 0px;" class="px-4">
            <div class="model-selector sidebar-llm-selector">
              <div class="dropdown-container">
                <div class="model-dropdown d-flex align-center" @click="toggleModelDropdown">
                  <span class="model-name">{{ selectedLLMModel ? selectedLLMModel.modelDisplay : "LLMs (default)" }}</span>
                  <v-btn v-if="selectedLLMModel" variant="text" icon x-small class="ml-3 clear-model-btn"
                    @click.stop="clearSelectedModel($event)">
                    <v-icon size="14" color="grey">mdi-close-circle</v-icon>
                  </v-btn>
                  <v-icon size="18" class="ml-1 text--secondary">mdi-chevron-down</v-icon>
                </div>
                <div v-if="showModelDropdown" class="custom-dropdown-menu" v-click-outside="closeModelDropdown">
                  <div class="custom-model-card">
                    <div class="custom-model-header">Select LLM Model</div>
                    <div class="custom-model-content">
                      <v-expansion-panels v-model="expandedPanel" variant="accordion" class="minimal-panels" flat>
                        <v-expansion-panel v-for="provider in providers" :key="provider.id" class="minimal-panel">
                          <v-expansion-panel-title class="py-2 minimal-header">
                            <div class="d-flex align-center">
                              <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                              <span class="provider-name">{{ provider.name }}</span>
                              <v-chip size="x-small" class="ml-2 minimal-chip" :color="`${provider.color}15`"
                                :text-color="provider.color">
                                {{ getModelsByProvider(provider.id).length }}
                              </v-chip>
                            </div>
                          </v-expansion-panel-title>
                          <v-expansion-panel-text class="pt-0 pb-0 minimal-content">
                            <v-list density="compact" class="model-list py-0 minimal-list">
                              <v-list-item v-for="model in getModelsByProvider(provider.id)" :key="model.id"
                                @click="SelectLLMMdel(model); closeModelDropdown()" class="minimal-list-item"
                                :class="{ 'selected-model': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }">
                                <v-list-item-content class="py-1">
                                  <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                                  <v-list-item-subtitle class="caption text--secondary">{{ model.modelName
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                                  <v-list-item-action>
                                    <v-icon size="16" color="primary">mdi-check</v-icon>
                                  </v-list-item-action>
                                </template>
                              </v-list-item>
                            </v-list>
                          </v-expansion-panel-text>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <!-- Folder -->
        <v-row style="padding-top: 10px;">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717A;">Folder</span>
          </v-col>
          
          <v-col class="col-7" style="
              background-color: transparent;
              padding-top: 0px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            ">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
              <div class="new-chat-fab" style="margin-right: 9px;" :color="selectedColor" v-bind="props" @click="createFolder">
                <Icon icon="lucide:folder-plus" class="fullstream-nav-icon" :style="fullstreamActionIconStyle" />
              </div>
              </template>
              <span>Create new folder</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-skeleton-loader style="margin-top: 0px; margin-bottom: 15px; background-color: transparent;"
          :loading="flagLoadingFolders" transition="scale-transition" type="list-item">
          <v-row id="folder_list_id_mobile" style="margin-top: 0px; display: block;">
            <v-col class="col-12" style="padding: 0;">
              <div id="folder-list-mobile" class="folder-list-container" style="max-width: 275px;">
                <div v-for="(folder, idx) in folders"
                  :key="folder.id" class="folder-item">
                  <div class="folder-view" :class="{
                    'drop-target': isDroppingOnFolder === folder.id,
                    'folder-updated-success': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success',
                    'folder-updated-error': recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'
                  }" elevation="0" @click="toggleFolder(folder)">
                    <div class="folder-view-content">
                      <v-icon
                        size="24"
                        class="mr-2 fullstream-folder-list-icon"
                        :style="{ color: fullstreamChatAccentColor, opacity: folder.expanded ? 1 : 0.78 }"
                      >
                        {{ folder.expanded ? 'mdi-folder-open' : 'mdi-folder' }}
                      </v-icon>
                      <span class="folder-name" :class="{ 'folder-name-active': folder.expanded }">{{ folder.name
                        }}</span>
                      <!-- Success indicator -->
                      <transition name="fade">
                        <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'success'"
                          color="success" size="20" class="folder-status-icon success-bounce">
                          mdi-check-circle
                        </v-icon>
                      </transition>
                      <!-- Error indicator -->
                      <transition name="fade">
                        <v-icon v-if="recentlyUpdatedFolderId === folder.id && folderUpdateStatus === 'error'"
                          color="error" size="20" class="folder-status-icon error-shake">
                          mdi-alert-circle
                        </v-icon>
                      </transition>
                      <v-menu bottom right transition="slide-y-transition" :close-on-content-click="true" offset-y
                        min-width="180" content-class="folder-menu-container">
                        <template v-slot:activator="{ props }">
                          <v-btn
                            icon
                            v-bind="props"
                            variant="text"
                            size="large"
                            :color="selectedColor"
                            class="topic-menu-button"
                            style="width: 35px !important;height: 35px !important;">
                            <v-icon size="small">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-card class="folder-menu-card">
                          <div class="folder-menu-list">
                            <div
                              class="folder-menu-item mb-1 px-2"
                              @click="startEditFolder(folder, idx)"
                              style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease;"
                            >
                              <div class="mr-2 d-flex align-center justify-center">
                                <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                              </div>
                              <div>
                                <span class="body-2">Rename</span>
                              </div>
                            </div>
                            <div
                              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;">
                            </div>
                            <div
                              class="folder-menu-item mt-1 px-2"
                              @click="openDeleteDialog(folder, idx)"
                              style="display: flex; align-items: center; border-radius: 8px; min-height: 40px; cursor: pointer; transition: background-color 0.2s ease;"
                            >
                              <div class="mr-2 d-flex align-center justify-center">
                                <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                              </div>
                              <div>
                                <span class="body-2 error--text" style="color: #ff5252 !important;">Delete</span>
                              </div>
                            </div>
                          </div>
                        </v-card>
                      </v-menu>
                    </div>
                  </div>
                  <!-- {{ Subtopic }} -->
                  <div v-if="folder.expanded" class="folder-subtopics" style="padding: 8px 0px 0px 6px !important;">
                    <div :id="'topic-list-mobile-' + folder.id" class="topic-list-container">
                      <div v-show="folder.topics">
                        <div v-for="(item, index) in folder.topics" :key="item.topicID" style="border-radius: 14px;" :class=" item.topicID === Log_History_TopicID ? 'highlighted-topic' : ''">
                          <!-- Editing State -->
                          <div v-if="item.status == true" class="topic-item topic-item--editing">
                            <div class="d-flex align-center w-100">
                              <div class="flex-grow-1 mr-2">
                                <v-text-field class="Cls_Text_field_TopicName" :id="'TopicId_' + item.topicID"
                                  variant="outlined" density="compact" hide-details v-model="item.topicName"
                                  rounded="lg"
                                  style="width: 100%;background-color: #ffffff;font-family: 'Inter', sans-serif;"
                                  @blur="() => { item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token); }"
                                  @keyup="keyupKeyRename()" @keyup.enter="
                                    item.status = false;
                                  RenameTopicStream(
                                    item.topicID,
                                    item.keyTopic,
                                    item.topicName,
                                    index,
                                    auth_token
                                  );
                                  " />
                              </div>
                            </div>
                          </div>
                          <!-- Normal State -->
                          <div v-else class="topic-item topic-item--clickable" @click="selectTopic(item)">
                            <div class="d-flex align-center w-100">
                              <div class="topic-icon-wrapper fullstream-topic-icon-wrapper mr-3" :style="{ color: fullstreamChatAccentColor, opacity: item.topicID === Log_History_TopicID ? 1 : 0.78 }">
                                <Icon icon="lucide:message-square-text" class="fullstream-topic-list-icon" />
                              </div>
                              <div class="topic-content flex-grow-1 mr-2">
                                <v-tooltip location="top" open-delay="300" max-width="300">
                                  <template v-slot:activator="{ props }">
                                    <div v-bind="props" class="topic-title-wrapper" style="max-width: 100%;">
                                      <span class="topic-title text-truncate">
                                        {{ item.topicName }}
                                      </span>
                                    </div>
                                  </template>
                                   <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                                </v-tooltip>
                              </div>
                              <v-menu location="bottom left" transition="slide-y-transition"
                                :close-on-content-click="true" offset-y min-width="200"
                                content-class="topic-menu-container">
                                <template v-slot:activator="{ props }">
                                  <v-btn
                                    icon
                                    v-bind="props"
                                    variant="text"
                                    size="large"
                                    :color="selectedColor"
                                    class="topic-menu-button">
                                    <v-icon size="small">mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <v-card class="topic-menu-card" style="width: 200px; max-width: 100%;">
                                  <div class="topic-menu-list pa-2"
                                    style="border-radius: 12px; border: none; overflow: hidden; background: white;">
                                    <div class="topic-menu-item mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                      @click="openMoveToFolderDialog(item)">
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                                      </div>
                                      <div class="d-flex align-center">
                                        <span class="body-2">Move to folder</span>
                                      </div>
                                    </div>
                                    <div class="topic-menu-item mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                      @click="removeTopicFromFolder(folder.id, item.topicID, index)">
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" color="warning">mdi-folder-remove</v-icon>
                                      </div>
                                      <div class="d-flex align-center">
                                        <span class="body-2">Remove from folder</span>
                                      </div>
                                    </div>
                                    <div
                                      style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;">
                                    </div>
                                    <div class="topic-menu-item mt-1 mb-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                      @click="RenameChat(item); focusInput('TopicId_' + item.topicID)">
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                                      </div>
                                      <div>
                                        <span class="body-2">Rename</span>
                                      </div>
                                    </div>
                                    <div class="topic-menu-item mt-1 d-flex align-center"
                                      style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                                      @click="openDeleteTopicDialog(item)">
                                      <div class="mr-2 d-flex align-center justify-center">
                                        <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                                      </div>
                                      <div>
                                        <span class="body-2 error--text" style="color: #ff5252 !important;">Delete chat</span>
                                      </div>
                                    </div>
                                  </div>
                                </v-card>
                              </v-menu>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!folder.topics || folder.topics.length === 0" class="empty-folder-state">
                        <v-icon color="grey lighten-1" size="20">mdi-chat-outline</v-icon>
                        <span class="empty-folder-text ml-2">No chats in this folder</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-skeleton-loader>

        <!-- Topics -->
        <v-row style="padding-top: 21px">
          <v-col class="col-5">
            <span style="font-weight: bold; font-size: 18px; color: #71717a">Topics</span>
          </v-col>
          <!-- NEW CHAT -->
          <v-col class="col-7" style="
              background-color: transparent;
              padding-top: 0px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            ">
            <button type="button" :color="selectedColor" depressed rounded hide-details class="new-chat-fab"
            style="margin-right: 5px; height: 26px !important;width: 26px !important; "
              v-on:click="newChat()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="fullstream-topic-action-icon" :style="fullstreamActionIconStyle">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zM12 8v6m-3-3h6" />
              </svg>
            </button>
          </v-col>
        </v-row>

        <!-- Topic List -->
        <v-row id="toppic_list_id_mobile" style="margin-top: 21px; display: block">
          <v-col class="col-12" style="padding-top: 0px; padding-bottom: 10px">
            <div class="topic-scroll-container">
              <div v-for="(item, index) in topicsNotInFolders" :key="item.topicID" style="border-radius: 14px;"  :class="highlightTopic(item)">
                <!-- Editing State -->
                <div v-if="item.status == true" class="topic-item topic-item--editing">
                  <div class="d-flex align-center w-100">
                    <div class="flex-grow-1 mr-2">
                      <v-text-field class="Cls_Text_field_TopicName" :id="'TopicId_' + item.topicID" variant="outlined"
                        density="compact" hide-details v-model="item.topicName" rounded="lg" style="
                          width: 100%;
                          background-color: #ffffff;
                          font-family: 'Inter', sans-serif;
                        " @blur="
                          item.status = false;
                        RenameTopicStream(
                          item.topicID,
                          item.keyTopic,
                          item.topicName,
                          index,
                          auth_token
                        );
                        " @keyup="keyupKeyRename()" @keyup.enter="
                          item.status = false;
                        RenameTopicStream(
                          item.topicID,
                          item.keyTopic,
                          item.topicName,
                          index,
                          auth_token
                        );
                        " />
                    </div>
                  </div>
                </div>

                <!-- Normal State -->
                <div v-else class="topic-item topic-item--clickable" @click="selectTopicOutside(item)">
                  <div class="d-flex align-center w-100">
                    <div class="topic-icon-wrapper fullstream-topic-icon-wrapper mr-3" :style="{ color: fullstreamChatAccentColor, opacity: item.topicID === Log_History_TopicID ? 1 : 0.78 }">
                      <Icon icon="lucide:message-square-text" class="fullstream-topic-list-icon" />
                    </div>

                    <div class="topic-content flex-grow-1 mr-2">
                      <v-tooltip location="top" open-delay="300" max-width="300">
                        <template v-slot:activator="{ props }">
                          <div v-bind="props" class="topic-title-wrapper">
                            <span class="topic-title text-truncate">
                              {{ item.topicName }}
                            </span>
                          </div>
                        </template>
                        <span>{{ item.topicName.length > 100 ? item.topicName.substring(0, 100) + '...' : item.topicName }}</span>
                      </v-tooltip>
                    </div>

                    <v-menu location="right top" transition="slide-y-transition" :close-on-content-click="true"
                      min-width="200" content-class="topic-menu-container">
                      <template v-slot:activator="{ props }">
                        <v-btn
                          icon
                          v-bind="props"
                          variant="text"
                          size="large"
                          :color="selectedColor"
                          class="topic-menu-button opacity-60">
                          <v-icon size="small">mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-card class="topic-menu-card" style="width: 200px;">
                        <div class="topic-menu-list pa-2"
                          style="border-radius: 12px; border: none; overflow: hidden; background: white;">
                          <div class="topic-menu-item mb-1 d-flex align-center"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                            @click="openMoveToFolderDialog(item)">
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" :color="selectedColor">mdi-folder-move</v-icon>
                            </div>
                            <div class="d-flex align-center">
                              <span class="body-2">Move to folder</span>
                            </div>
                          </div>

                          <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); margin: 8px 0; border-radius: 1px;">
                          </div>

                          <div class="topic-menu-item mt-1 mb-1"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                            @click="RenameClick(item, 'TopicId_' + item.topicID); focusInput('TopicId_' + item.topicID)">
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" :color="selectedColor">mdi-pencil</v-icon>
                            </div>
                            <div>
                              <span class="body-2">Rename</span>
                            </div>
                          </div>

                          <div class="topic-menu-item mt-1"
                            style="display: flex; border-radius: 8px; min-height: 40px; transition: background-color 0.2s ease; align-items: center; cursor: pointer;"
                            @click="openDeleteTopicDialog(item)">
                            <div class="mr-2 d-flex align-center justify-center">
                              <v-icon size="20" color="#ff5252">mdi-delete</v-icon>
                            </div>
                            <div>
                              <span class="body-2 error--text" style="color: #ff5252 !important;">Delete chat</span>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-menu>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-navigation-drawer>

    <div v-if="pathUrl != 'FullStream'" transition="scale-transition"
      :class="showScrollButton ? 'scroll-to-top' : 'scroll-to-top-close'" @click="scrollToTop">
      <v-btn color="primary" fab>
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </div>
    <v-breadcrumbs v-if="pathUrl != 'FullStream' && pathUrl != 'FlowCreator'" :items="breadcrumbsList" class="fixed-breadcrumbs"
      :style="{ paddingLeft: paddingLeft }">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="item.query == true && queryID != undefined && queryID != null
            ? item.href + '?id=' + queryID
            : item.href
            "
          :text="item.href"
          :disabled="item.disabled">
          {{ localize(item.title) }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>


  </nav>

  <nav v-if="pathUrl != 'FullStream' && pathUrl != '' && pathUrl != 'Snippet'"
  style="z-index: 55;position: fixed; top: 0; left: 0; right: 0; background-color: white; display: flex; align-items: center; padding: 0 16px;">
    <v-navigation-drawer v-if="pathUrl != 'FullStream' && pathUrl != ''" style="
        overflow-y: auto;
        background-image: linear-gradient(
          to bottom,
          #ffffff,
          #ffffff,
          #FFF5F2,
          #FFF5F2
        );
        padding-bottom: calc(0px + env(safe-area-inset-bottom));
        border-radius: 0px 0px 5px 0px;
        border: none !important;
        z-index: 1300;
        box-shadow: 0px 0 15px rgba(0, 0, 0, .1);
      " 
      v-model="drawer" 
      :rail="rail && smAndUp" 
      :rail-width="70" 
      :temporary="!smAndUp" 
      location="left" 
      app>
      <v-list-item style="padding: 0px; padding-left: 8px; padding-right: 8px;">
        <v-list-item-content>
          <div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 10px;">
            <!-- Logo -->
            <img
              v-if="pathUrl != 'FullStream'  && !rail"
              id="Fusion_Logo_Sidebar"
              alt="Fusion Logo"
              class="logo-left-fixed clickable logo-symmetric"
              :src="images.logo"
              @click="$router.currentRoute.name != 'dashboard' ? homepage() : ''"
              :style="{ 
                width: smAndUp ? '150px' : '110px', 
                height: '54px',
                objectFit: 'contain',
                objectPosition: 'center'
              }" />
              
            <!-- Drawer Button -->
            <v-app-bar-nav-icon
              v-if="smAndUp"
              @click.stop="rail = !rail"
              title="drawer"
              color="#1f211f"
              :style="(!smAndUp || !drawer) ? 'margin-left: 2px;' : 'margin-left: 0px;'">
            </v-app-bar-nav-icon>
          </div>

          <!-- User Profile Section -->
          <div class="user-profile-section d-flex align-center mt-4 mb-4">
            <v-avatar color="#55555540" size="40" >
              <span class="white--text text-h5">{{ shotName }}</span>
            </v-avatar>

            <div v-show="!rail" class="profile-info">
              <h3 class="profile-name">{{ fullName }}</h3>
              <v-chip size="x-small" label variant="flat" :ripple="false"
                style="border-radius: 12px; background: linear-gradient(90deg, #b85948 0%, #9C1F21 100%); color: #ffffff;">
                <span class="role-text">{{ role }}</span>
              </v-chip>
            </div>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-list class="modern-menu px-2" nav>
        <div v-for="(item, id) in filteredItems" :key="id">
          <!-- รายการเมนูที่ไม่มีเมนูย่อย -->
          <v-list-item 
            v-if="item.childstatus == true" 
            :to="{ path: item.route, replace: false }"
            :class="[{ 'menu-active': isMenuActive(item) }, 'menu-item', 'my-1', 'rounded-lg']"
            v-show="item.Check == true"
            :ripple="{ class: 'primary--text' }">
            <template v-slot:prepend>
              <div class="icon-container d-flex align-center justify-center me-3" 
              :style="{ paddingLeft: (rail && smAndUp) ? '10px' : '0px' }">
                <v-badge v-if="item.route == '/ChatService' && chatServiceUnreadCount > 0" color="error" :content="chatServiceUnreadCount" :value="chatServiceUnreadCount" offset-x="3" offset-y="3">
                  <img v-if="item.imgIcon" :src="item.imgIcon" alt="icon" width="24" height="24" class="mr-2"/>
                  <v-icon v-else size="24" class="mr-2">{{ item.icon || 'mdi-circle' }}</v-icon>
                </v-badge>
                <template v-else>
                  <img v-if="item.imgIcon" :src="item.imgIcon" alt="icon" width="24" height="24" class="mr-2"/>
                  <v-icon v-else size="24" class="mr-2">{{ item.icon || 'mdi-circle' }}</v-icon>
                </template>
              </div>
            </template>

            <v-tooltip location="right" open-delay="500">
              <template v-slot:activator="{ props }">
                <div v-bind="props" class="menu-item-content">
                  <v-list-item-title class="menu-title" v-show="!rail">
                    {{ localize(substring(item.title)) }} 
                  </v-list-item-title>
                </div>
              </template>
              <span>{{ $t(item.title) }}</span>
            </v-tooltip>
          </v-list-item>

          <!-- รายการเมนูที่มีเมนูย่อย -->
          <template v-else-if="item.childstatus == false && (rail && smAndUp)">
            <!-- Rail mode: แสดงเฉพาะ icon พร้อม menu ที่มี submenu -->
            <v-menu location="end" open-on-hover :close-delay="200" :open-delay="300">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" v-show="item.Check == true" 
                  class="menu-item my-1 rounded-lg" 
                  :class="{ 'menu-active': isMenuItemActiveRecursive(item) }"
                  :ripple="{ class: 'primary--text' }">
                  <template v-slot:prepend>
                    <div class="icon-container d-flex align-center justify-center me-3"
                    :style="{ paddingLeft: (rail && smAndUp) ? '10px' : '0px' }">
                      <img :src="item.imgIcon" alt="icon" width="24" height="24" class="mr-2"/>
                    </div>
                  </template>
                </v-list-item>
              </template>
              
              <v-card class="submenu-card" elevation="3" min-width="200">
                <v-card-title class="submenu-card-title py-2">
                  <img :src="item.imgIcon" alt="icon" width="20" height="20" class="mr-2 mt-1"/>
                  {{ localize(item.title) }}
                </v-card-title>
                
                <v-divider></v-divider>
                
                <v-list nav density="compact" class="py-0">
                  <v-list-item 
                    v-for="(childrenItem, childrenId) in item.children" 
                    :key="childrenId"
                    v-show="childrenItem.Check == true" 
                    :to="childrenItem.route"
                    active-class="submenu-card-item-active"
                    class="submenu-card-item"
                    :ripple="{ class: 'primary--text' }">
                    <template v-slot:prepend>
                      <div v-if="childrenItem.imgIcon" class="icon-container d-flex align-center justify-center me-3">
                        <img :src="childrenItem.imgIcon" alt="icon" width="22" height="22" class="mr-2"/>
                      </div>
                      <div v-else-if="childrenItem.icon" class="icon-container d-flex align-center justify-center me-3">
                        <v-icon :color="childrenItem.iconColor" size="22">{{ childrenItem.icon }}</v-icon>
                      </div>
                    </template>
                    <v-list-item-title class="text-body-2">{{
                      localize(substring(childrenItem.title))
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </template>
          <template v-else-if="item.childstatus == false && (!rail || !smAndUp)">
            <!-- Full mode: แสดงแบบปกติ -->
            <v-list-group v-model="openMenus[id]" active-class="menu-group-active" v-show="item.Check == true"
              class="menu-group my-1" :ripple="false">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" class="rounded-lg menu-group-header"
                :class="{ 'menu-active': isMenuItemActiveRecursive(item) }">
                  <template v-slot:prepend>
                    <div class="icon-container d-flex align-center justify-center me-3">
                      <img :src="item.imgIcon" alt="icon" width="24" height="24" class="mr-2"/>
                    </div>
                  </template>
                  <v-list-item-title class="menu-title">{{
                    localize(item.title)
                  }}</v-list-item-title>
                </v-list-item>
              </template>

              <!-- รายการเมนูย่อย -->
              <div class="submenu-container ml-2">
                <v-list-item v-for="(childrenItem, childrenId) in item.children" :key="childrenId"
                  :to="childrenItem.route"
                  :class="{ 'submenu-active': isMenuItemActiveRecursive(childrenItem) }"
                  v-show="childrenItem.Check == true"
                  class="submenu-item rounded-lg my-1 ps-4"
                  :ripple="{ class: 'primary--text' }">
                  <template v-slot:prepend>
                    <div v-if="childrenItem.imgIcon" class="icon-container d-flex align-center justify-center me-3">
                      <img :src="childrenItem.imgIcon" alt="icon" width="22" height="22" class="mr-2"/>
                    </div>
                    <div v-else-if="childrenItem.icon" class="icon-container d-flex align-center justify-center me-3">
                      <v-icon :color="childrenItem.iconColor" size="22">{{ childrenItem.icon }}</v-icon>
                    </div>
                  </template>
                  <v-list-item-title class="submenu-title">{{
                    localize(substring(childrenItem.title))
                  }}</v-list-item-title>
                </v-list-item>
              </div>
            </v-list-group>
          </template>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      style="
        display: flex;
        align-items: center;
        box-shadow: none !important;
        background-color: #ffffff !important;
        height: 74px !important;
        padding-right: 8px;
        z-index: 1250 !important;
        padding-top: 15px;
      ">
      <!-- Page title and breadcrumb  start -->
      <div class="page-header-section d-flex align-center flex-grow-1 ml-5" :style="breadcrumbsList.length == 1 ? 'margin-top: 14px;' : ''">
        <!-- Page Title -->
        <div class="page-title-container">
          <h1 class="page-title text-h5 font-weight-medium mb-0" >
            {{ getPageTitle() }}
          </h1>
          <!-- Breadcrumb -->
          <v-breadcrumbs 
            v-if="breadcrumbsList && breadcrumbsList.length > 1"
            :items="breadcrumbsList" 
            class="page-breadcrumbs pa-0 ma-0"
            density="compact">
            <template v-slot:item="{ item, index }">
              <v-breadcrumbs-item
                :to="item.to"
                :disabled="item.disabled"
                :class="['text-body-2', { 'last-breadcrumb': index === breadcrumbsList.length - 1 }]"
                :style="index === breadcrumbsList.length - 1 ? 'cursor: default;' : 'cursor: pointer;'"
                @click="index === breadcrumbsList.length - 1 ? null : goback(item)">
                {{ localize(item.subtitle) }}
              </v-breadcrumbs-item>
            </template>
            <template v-slot:divider>
              <v-icon size="small" color="rgba(0,0,0,0.4)">mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </div>
      <!-- Page title and breadcrumb end -->

      <!-- Logo สำหรับหน้าอื่นๆ -->
      <v-app-bar-nav-icon v-if="!smAndUp"
        @click.stop="drawer = !drawer"
        title="drawer"
        color="#1f211f">
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <UserProfileMenu 
        v-if="pathUrl != 'FullStream'"
        :username="username"
        :fullName="fullName" 
        :shotName="shotName"
        :role="role"
        :versioning="versioning"
        :ddProfile="ddProfile"
        :currentflag="currentflag"
        :languages="languages"
        :soundEnabled="soundEnabled"
        :navbarTxtColorTheme="NavbarTxtColorTheme"
        :navbarBtnColorTheme="NavbarBtnColorTheme"
        :snippetUsername="Snippet_Username"
        :showVersionLabel="smAndUp"
        :showLanguageMenu="true"
        :showSoundToggle="true"
        :localizeFunction="localize"
        @change-locale="changeLocale"
        @toggle-sound="toggleSound"
      />
    </v-app-bar>

  </nav>
  <div>

    <!-- LLM Model Dropdown Dialog -->
    <v-dialog v-model="showModelDropdownDialog" max-width="500px" :close-on-content-click="false" :persistent="false"
      transition="dialog-transition">
      <!-- Dialog content -->
      <v-card class="llm-dialog-card-v2">
        <v-card-title class="llm-dialog-header-v2 d-flex justify-space-between align-center">
          <span>Select LLM Model</span>
          <v-btn icon size="small" variant="text" @click="closeModelDropdownDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="llm-dialog-content-v2">
          <v-expansion-panels v-model="expandedPanel" variant="accordion" class="llm-panels-v2" flat>
            <v-expansion-panel v-for="provider in providers" :key="provider.id" class="llm-panel-item-v2">
              <v-expansion-panel-title class="py-2 llm-panel-header-v2">
                <div class="d-flex align-center">
                  <v-icon size="16" :color="provider.color" class="mr-2">{{ provider.icon }}</v-icon>
                  <span class="llm-provider-name-v2">{{ provider.name }}</span>
                  <v-chip size="x-small" class="ml-2 llm-count-chip-v2" :color="`${provider.color}15`"
                    :text-color="provider.color">
                    {{ getModelsByProvider(provider.id).length }}
                  </v-chip>
                </div>
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pt-0 pb-0 llm-panel-content-v2">
                <v-list density="compact" class="llm-model-list-v2 py-0">
                  <v-list-item v-for="model in getModelsByProvider(provider.id)" :key="model.id"
                    @click="SelectLLMMdel(model); closeModelDropdown(); closeModelDropdownDialog()"
                    class="llm-model-item-v2"
                    :class="{ 'llm-model-selected-v2': selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay }">
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="subtitle-2">{{ model.modelDisplay }}</v-list-item-title>
                      <v-list-item-subtitle class="caption text--secondary">{{ model.modelName }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <template v-if="selectedLLMModel && selectedLLMModel.modelDisplay === model.modelDisplay">
                      <v-list-item-action>
                        <v-icon size="16" color="primary">mdi-check</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Consent PDPA-->
    <v-dialog v-if="flagUpdateVersion" v-model="consent_dialog" persistent max-width="800px" class="consent-dialog">
      <v-card class="consent-card" elevation="0">
        <!-- Header -->
        <v-card-title class="consent-header">
          <div class="header-content">
            <div class="header-text">
              <h2 class="consent-title">Personal Data Protection Act (PDPA)</h2>
              <p class="consent-subtitle">
                Please review and accept our privacy policy
              </p>
            </div>
          </div>
        </v-card-title>

        <!-- Language Selection - Top Right -->
        <div class="version-language-section">
          <div class="language-selector">
            <v-btn-toggle 
              v-model="selectedLanguage" 
              color="primary" 
              variant="outlined" 
              density="compact"
              class="language-toggle" 
              mandatory
              divided
            >
              <v-btn 
                value="th" 
                @click="dataConsent = dataConsentTH" 
                class="language-btn" 
                size="small"
              >
                <flag style="margin-right: 8px; border-radius: 50%; height: 20px; width: 20px;" iso="TH" :squared="false" />
                <span style="font-weight: bold!important;">Thailand</span>
              </v-btn>
              <v-btn 
                value="en" 
                @click="dataConsent = dataConsentEN" 
                class="language-btn" 
                size="small"
              >
                <flag style="margin-right: 8px; border-radius: 50%; height: 20px; width: 20px;" iso="GB" :squared="false" />
                <span style="font-weight: bold!important;">English</span>
              </v-btn>
            </v-btn-toggle>
          </div>

          <div class="version-info">
            <v-chip class="label-version" label>
              Version {{ dataVersion }}
            </v-chip>
          </div>
        </div>

        <!-- Content Area -->
        <v-card-text class="consent-content">
          <div class="content-wrapper">
            <div class="content-scroll-area">
              <a href="#" class="policy-link" @click.prevent="openPolicyLink">
                Cookies And Privacy Policy8
              </a>
              <div class="consent-text-content data-consent-text" v-html="dataConsent"></div>
            </div>
          </div>
        </v-card-text>

        <!-- Action Buttons -->
        <v-card-actions class="consent-actions">
          <v-spacer></v-spacer>
          <v-btn 
            id="button-disagreeconsent-navbar" 
            variant="outlined" 
            color="#C30000" 
            size="large"
            class="consent-action-btn decline-btn" 
            @click="DisAgreeConsent()"
          >
            <v-icon size="20" class="mr-2">mdi-close</v-icon>
            Decline
          </v-btn>
          <v-btn 
            id="button-agreeconsent-navbar" 
            variant="flat"
            size="large" 
            class="accept-btn"
            @click="AgreeConsent()"
          >
            Accept & Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Folder editor-->
    <v-dialog v-model="folderDialog.visible" max-width="400" transition="slide-y-transition"
      content-class="folder-dialog-wrapper" style="border-radius: 18px !important;">
      <v-card class="folder-dialog" :elevation="5">
        <v-card-title class="dialog-title">
          <v-icon left :color="selectedColor" class="folder-icon-animation mr-3" size="28">
            {{ folderDialog.isNew ? 'mdi-folder-plus' : 'mdi-folder-edit' }}
          </v-icon>
          <span class="headline">{{ folderDialog.isNew ? 'Create Folder' : 'Rename Folder' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="dialog-content pt-4">
          <p class="subtitle-2 text--secondary mb-2">
            {{ folderDialog.isNew ?
              'Create a new folder to organize your chats.' :
              'Update the name for this folder.'
            }}
          </p>
          <v-text-field 
            v-model="folderDialog.name" 
            label="Folder Name" 
            variant="outlined"
            density="comfortable"
            hide-details="auto" 
            autofocus
            @keyup.enter="confirmFolderDialog" 
            :color="selectedColor" 
            placeholder="Enter folder name" 
            counter="50"
            maxlength="50" 
            class="input-folder mt-3"
            rounded="lg"
            bg-color="white">
            <template v-slot:prepend-inner>
              <v-icon :color="selectedColor" class="folder-icon-pulse">mdi-folder-outline</v-icon>
            </template>
            <template v-slot:append-inner>
              <v-fade-transition>
                <v-icon v-if="folderDialog.name" 
                        size="small" 
                        :color="selectedColor" 
                        @click="folderDialog.name = ''"
                        class="clear-input-icon">
                  mdi-close-circle
                </v-icon>
              </v-fade-transition>
            </template>
          </v-text-field>
        </v-card-text>

        <v-card-actions class="dialog-actions pa-4">
          <v-spacer />
          <v-btn text class="cancel-btn" @click="closeFolderDialog" :disabled="folderDialogStatus.isLoading">
            <span class="text-capitalize">Cancel</span>
          </v-btn>
          <v-btn text
            :color="folderDialogStatus.isSuccess ? 'success' : (folderDialogStatus.isError ? 'error' : selectedColor)"
            class="save-btn" :class="{
              'loading-btn': folderDialogStatus.isLoading,
              'success-btn': folderDialogStatus.isSuccess,
              'error-btn': folderDialogStatus.isError
            }" :disabled="!folderDialog.name || folderDialogStatus.isLoading || folderDialogStatus.isSuccess"
            @click="confirmFolderDialog">
            <transition name="fade-btn" mode="out-in">
              <template v-if="folderDialogStatus.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"></v-progress-circular>
                  <span class="text-capitalize">Saving...</span>
                </div>
              </template>
              <template v-else-if="folderDialogStatus.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation mr-1">mdi-check-circle</v-icon>
                  <span class="text-capitalize">Done!</span>
                </div>
              </template>
              <template v-else-if="folderDialogStatus.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation mr-1">mdi-alert-circle</v-icon>
                  <span class="text-capitalize">Failed</span>
                </div>
              </template>
              <template v-else>
                <span class="text-capitalize">{{ folderDialog.isNew ? 'Create' : 'Save' }}</span>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteFolderDialog.visible" max-width="400" style="border-radius: 18px !important;">
      <v-card class="delete-folder-dialog" style="border-radius:18px; overflow:hidden;">
        <v-card-title class="dialog-header">
          <v-icon color="error" class="mr-2" size="28">mdi-alert-circle</v-icon>
          <span class="title">Delete folder?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
            <p class="folder-name-delete mb-3" style="white-space: normal; word-wrap: break-word;width: 100%;">
            "{{ deleteFolderDialog.name.substring(0, 28) + (deleteFolderDialog.name.length > 28 ? '...' : '') }}"
            </p>
          <p class="warning-text">
            This will permanently delete this folder and all its contents.
            <span class="font-weight-medium">This action cannot be undone.</span>
          </p>
          <p class="hint-text mt-4">
            To save topics, move them to your chat list or another folder before deleting.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-btn text class="cancel-btn" @click="closeDeleteDialog" :disabled="deleteFolderDialog.isLoading">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :color="deleteFolderDialog.isSuccess ? 'success' : (deleteFolderDialog.isError ? 'error' : 'error')"
            class="delete-btn" :class="{
              'loading-btn': deleteFolderDialog.isLoading,
              'success-btn': deleteFolderDialog.isSuccess,
              'error-btn': deleteFolderDialog.isError
            }" :disabled="deleteFolderDialog.isLoading || deleteFolderDialog.isSuccess" @click="confirmDeleteDialog">
            <transition name="fade-btn" mode="out-in">
              <template v-if="deleteFolderDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"></v-progress-circular>
                  <span>Deleting...</span>
                </div>
              </template>
              <template v-else-if="deleteFolderDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Deleted</span>
                </div>
              </template>
              <template v-else-if="deleteFolderDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-delete</v-icon>
                  <span>Delete</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="moveToFolderDialog.visible" max-width="400" transition="slide-y-transition"
      content-class="move-folder-dialog" style="border-radius: 18px !important;">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left :color="selectedColor" class="move-icon mr-2">mdi-folder-move</v-icon>
          <span class="headline">Move to Folder</span>
        </v-card-title>
        <v-card-text class="dialog-content">
          <p class="mb-2">Select destination folder for "<span class="topic-highlight">
            {{ moveToFolderDialog.topicName.substring(0, 28) + (moveToFolderDialog.topicName.length > 28 ? '...' : '') }}</span>"
          </p>

          <div class="folder-selector-container" :class="{ 'options-loading': moveToFolderDialog.isLoading }">
            <div v-for="folder in filteredFolders" :key="folder.id" class="folder-option" :class="{
              'folder-option-selected': moveToFolderDialog.selectedFolderId === folder.id,
              'folder-option-disabled': folder.id === moveToFolderDialog.currentFolderId
            }" @click="!isFolderDisabled(folder) && selectFolder(folder.id)">
              <div class="folder-option-icon">
                <v-icon :color="isFolderSelected(folder) ? selectedColor : 'grey darken-1'" size="24">
                  {{ isFolderSelected(folder) ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
              </div>
              <div class="folder-option-content">
                <div class="folder-option-name">{{ folder.name.substring(0, 20) +  (folder.name.length > 20 ? '...' : '')}}</div>
                <div class="folder-option-info" v-if="folder.topics && folder.topics.length > 0">
                  {{ folder.topics.length }} topic{{ folder.topics.length > 1 ? 's' : '' }}
                </div>
              </div>
              <div class="folder-option-action">
                <v-icon v-if="isFolderSelected(folder)" :color="selectedColor" size="20" class="check-animation">
                  mdi-check-circle
                </v-icon>
              </div>
            </div>

            <div v-if="!filteredFolders.length" class="text-center pa-4">
              <v-icon color="grey lighten-1" size="48">mdi-folder-outline</v-icon>
              <p class="text-subtitle-1 grey--text text--darken-1 mt-2">No folders available</p>
              <v-btn small color="primary" text class="mt-2" @click="createFolder">
                <v-icon left size="18">mdi-folder-plus</v-icon>
                Create a new folder
              </v-btn>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeMoveToFolderDialog"
            :disabled="moveToFolderDialog.isLoading">Cancel</v-btn>
          <v-btn text
            :color="moveToFolderDialog.isSuccess ? 'success' : (moveToFolderDialog.isError ? 'error' : selectedColor)"
            class="save-btn" :class="{
              'loading-btn': moveToFolderDialog.isLoading,
              'success-btn': moveToFolderDialog.isSuccess,
              'error-btn': moveToFolderDialog.isError
            }" :disabled="!moveToFolderDialog.selectedFolderId ||
              moveToFolderDialog.selectedFolderId === moveToFolderDialog.currentFolderId ||
              moveToFolderDialog.isLoading" @click="confirmMoveToFolder">
            <transition name="fade-btn" mode="out-in">
              <template v-if="moveToFolderDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"></v-progress-circular>
                  <span>Moving...</span>
                </div>
              </template>
              <template v-else-if="moveToFolderDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Done!</span>
                </div>
              </template>
              <template v-else-if="moveToFolderDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <span>Move</span>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="removeTopicDialog.visible" max-width="400" transition="slide-y-transition"
      content-class="remove-topic-dialog" style="border-radius: 18px !important;">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left color="warning" class="mr-2">mdi-folder-remove</v-icon>
          <span class="headline">Remove from folder?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <p class="mb-3">
            <span class="topic-highlight">"{{ removeTopicDialog.topicName.substring(0, 28) + (removeTopicDialog.topicName.length > 28 ? '...' : '') }}"</span>
            <br>
            will be moved to your main chat list.
          </p>

          <v-alert dense text color="info" border="left" class="mb-0 mt-4">
            <v-icon left small>mdi-information</v-icon>
            You can always add it back to this or another folder later.
          </v-alert>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeRemoveTopicDialog" :disabled="removeTopicDialog.isLoading">
            Cancel
          </v-btn>
          <v-btn text
            :color="removeTopicDialog.isSuccess ? 'success' : (removeTopicDialog.isError ? 'error' : 'warning')"
            class="remove-btn" :class="{
              'loading-btn': removeTopicDialog.isLoading,
              'success-btn': removeTopicDialog.isSuccess,
              'error-btn': removeTopicDialog.isError
            }" :disabled="removeTopicDialog.isLoading" @click="confirmRemoveTopic">
            <transition name="fade-btn" mode="out-in">
              <template v-if="removeTopicDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"></v-progress-circular>
                  <span>Removing...</span>
                </div>
              </template>
              <template v-else-if="removeTopicDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Removed</span>
                </div>
              </template>
              <template v-else-if="removeTopicDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-folder-remove</v-icon>
                  <span>Remove</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteTopicDialog.visible" max-width="400" transition="slide-y-transition"
      content-class="delete-topic-dialog" style="border-radius: 18px !important;">
      <v-card class="folder-dialog">
        <v-card-title class="dialog-title">
          <v-icon left color="error" class="mr-2">mdi-alert-circle</v-icon>
          <span class="headline">Delete this chat?</span>
        </v-card-title>

        <v-card-text class="dialog-content">
          <p class="mb-3">
            <span class="topic-highlight">"{{ deleteTopicDialog.topicName.substring(0, 28) + (deleteTopicDialog.topicName.length > 28 ? '...' : '') }}"</span>
            <br>
            will be permanently deleted.
          </p>

          <v-alert dense text color="error" border="left" class="mb-0 mt-4">
            <v-icon left small>mdi-information</v-icon>
            This action cannot be undone. All messages in this chat will be lost.
          </v-alert>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text class="cancel-btn" @click="closeDeleteTopicDialog" :disabled="deleteTopicDialog.isLoading">
            Cancel
          </v-btn>
          <v-btn color="error" class="delete-btn" :class="{
            'loading-btn': deleteTopicDialog.isLoading,
            'success-btn': deleteTopicDialog.isSuccess,
            'error-btn': deleteTopicDialog.isError
          }" :disabled="deleteTopicDialog.isLoading || deleteTopicDialog.isSuccess" @click="confirmDeleteTopic">
            <transition name="fade-btn" mode="out-in">
              <template v-if="deleteTopicDialog.isLoading">
                <div class="d-flex align-center">
                  <v-progress-circular
                    indeterminate
                    size="20"
                    width="2"
                    class="mr-2"></v-progress-circular>
                  <span>Deleting...</span>
                </div>
              </template>
              <template v-else-if="deleteTopicDialog.isSuccess">
                <div class="d-flex align-center success-animation">
                  <v-icon left small class="success-icon-animation">mdi-check</v-icon>
                  <span class="success-text-animation">Deleted</span>
                </div>
              </template>
              <template v-else-if="deleteTopicDialog.isError">
                <div class="d-flex align-center">
                  <v-icon left small class="error-icon-animation">mdi-alert-circle</v-icon>
                  <span>Failed</span>
                </div>
              </template>
              <template v-else>
                <div class="d-flex align-center">
                  <v-icon left small>mdi-delete</v-icon>
                  <span>Delete</span>
                </div>
              </template>
            </transition>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import axios from "axios";
import store from "../store";
import Cookies from "js-cookie";
import { useDisplay } from "vuetify";
import { version } from "../../package.json";
import logoRemovebg from "@/assets/images/logo-removebg-preview@3x.png";
import fullDrawerImg from "@/assets/images/NavMenu icon.png";
import notificationSound from "@/assets/sounds/notification-2-269292.mp3";
import chatTopicPlusIconImg from "@/assets/images/TopicPlus.svg";
import signalRService from "@/services/signalr-service";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import draggable from "vuedraggable";
import UserProfileMenu from "./UserProfileMenu.vue";
import { clearLineSsoSnippetStorage, getQueryWithoutLineSso } from '@/utils/lineSsoHandoff';
import DashboardIcon from "@/assets/Icons/icon-dashboard.svg";
import ModelCreateIcon from "@/assets/Icons/icon-model-create.svg";
import KManageIcon from "@/assets/Icons/icon-knowledge.svg";
import FlowIcon from "@/assets/Icons/icon-flow.svg";
import IntentIcon from "@/assets/Icons/icon-intent.svg";
import OptiTechIcon from "@/assets/Icons/icon-optimization.svg";
import ModelTestIcon from "@/assets/Icons/icon-model-test.svg";
import UserManageIcon from "@/assets/Icons/icon-user-manage.svg";
import UserManageIcon1 from "@/assets/Icons/UserManageIcon1.svg";
import UserManageIcon2 from "@/assets/Icons/UserManageIcon2.svg";
import UserManageIcon3 from "@/assets/Icons/UserManageIcon3.svg";
import UserManageIcon4 from "@/assets/Icons/UserManageIcon4.svg";
import ChatManageIcon from "@/assets/Icons/icon-chat-manage.svg";
import SettingIcon from "@/assets/Icons/icon-setting.svg";
import ReportIcon from "@/assets/Icons/icon-report.svg";
import ReportIcon1 from "@/assets/Icons/ReportIcon1.svg";
import ReportIcon2 from "@/assets/Icons/ReportIcon2.svg";
import ReportIcon3 from "@/assets/Icons/ReportIcon3.svg";
import ReportIcon4 from "@/assets/Icons/ReportIcon4.svg"; 
import ReportIcon5 from "@/assets/Icons/ReportIcon5.svg";
import LogsIcon from "@/assets/Icons/icon-logs.svg";
import ChatPlayIcon from "@/assets/Icons/icon-chat-playground.svg";
import DualChatPlayIcon from "@/assets/Icons/icon-dual-chat-playground.svg";
import ChatServiceIcon from "@/assets/Icons/icon-chat-service.svg";
import KManageIcon1 from "@/assets/Icons/icon-knowledge-doc.svg";
import KManageIcon2 from "@/assets/Icons/icon-knowledge-db.svg";
import KManageIcon3 from "@/assets/Icons/icon-knowledge-speech.svg";
import KManageIcon4 from "@/assets/Icons/icon-knowledge-product.svg";
import OptiTechIcon1 from "@/assets/Icons/icon-optimization-prompt.svg";
import OptiTechIcon2 from "@/assets/Icons/icon-optimization-text.svg";
import SettingIcon1 from "@/assets/Icons/icon-setting-core.svg";
import SettingIcon2 from "@/assets/Icons/icon-setting-external.svg";
import SettingIcon3 from "@/assets/Icons/icon-setting-llms.svg";
import SettingIcon4 from "@/assets/Icons/icon-setting-platform.svg";
import SettingIcon5 from "@/assets/Icons/icon-setting-setting.svg";
import SettingIcon6 from "@/assets/Icons/icon-setting-consent.svg";
import LogsIcon1 from "@/assets/Icons/icon-logs-chat.svg";
import LogsIcon2 from "@/assets/Icons/icon-logs-log.svg";
import LogsIcon3 from "@/assets/Icons/icon-logs-api.svg";
import CManageIcon1 from "@/assets/Icons/icon-chat1.svg";
import CManageIcon2 from "@/assets/Icons/icon-chat2.svg";
import CManageIcon3 from "@/assets/Icons/icon-chat3.svg";
import CManageIcon4 from "@/assets/Icons/icon-chat4.svg";
import MTestIcon1 from "@/assets/Icons/icon-question.svg";
import MTestIcon2 from "@/assets/Icons/icon-positive.svg";
import MTestIcon3 from "@/assets/Icons/icon-negative.svg";
import MTestIcon4 from "@/assets/Icons/icon-excute.svg";
import ToolManagementIcon from "@/assets/Icons/icon-tool-management.svg";


export default {
  name: "Navbar",
  inject: [
    "SetStatusKeyRename",
    "tabSocialType",
    "loadChannelTabs",
    "resetUnreadNotifications",
    "getStartUpImage",
    "flagNav",
    "Status_Error",
    "Snippet_Username",
    "Snippet_Status",
    "User_Id_Show",
    "User_Id",
    "User_Id_Status",
    "Time_Delay",
    "flagShowTopic",
    "LeftNavBar",
    "SetPopup",
    "flagGetAllTopic",
    "miniVariant",
    "NavbarTxtColorTheme",
    "NavbarBtnColorTheme",
    "FullstreamNavbarTxtColorTheme",
    "FullstreamNavbarIconColorTheme",
    "FullstreamChatColorTheme",
    "ModelFirst",
    "colorThemeChat",
    "TopicName",
    "listTopic",
    "Log_History_TopicID",
    "Click_History_List",
    "DeleteTopicStream",
    "RenameClick",
    "RenameTopicStream",
    "keyupKeyRename",
    "auth_token",
    "isAllowLLMChange",
    "FileUploadLimit",
    "IsChainMassage",
    "maximumChatInput",
    "IsAllowImage",
    "Time_Delay",
    "TopicModelID",
    "selectedLLMModelInChat",
    "setSelectedLLMModelInChat",
    "lastLLMID",
    "setLastLLMIDInChat",
    "NavbarIcon",
    "firstModel",
    "ResetTextToImageFlagF"
  ],
  components: { 
    draggable,
    UserProfileMenu
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const display = useDisplay();
    const { locale } = useI18n();
    const { t } = useI18n();
    return {
      display,
      route,
      router,
      locale,
      t,
    };
  },
  data() {
    const roleIdValue = Cookies.get("roleId");
    let roleLabel = "Operator";
    if (roleIdValue == "0") {
      roleLabel = "Super admin";
    } else if (roleIdValue == "1") {
      roleLabel = "Admin";
    } else if (roleIdValue == "2") {
      roleLabel = "User";
    }
    return {
      selectedLanguage: "en",
      expandedPanel: 0,
      allLLMModel: [],
      selectedLLMModel: null,
      showModelDropdown: false,
      showModelDropdownDialog: false,
      showFloatingLLMMenu: false,
      providers: [
        { id: 'azure', name: 'Azure', icon: 'mdi-microsoft', color: '#2563EB' },
        { id: 'google', name: 'Google', icon: 'mdi-google', color: '#EA4335' },
        { id: 'anthropic', name: 'Anthropic', icon: 'mdi-alpha-a-circle', color: '#7C3AED' },
        { id: 'others', name: 'Others', icon: 'mdi-dots-horizontal-circle', color: '#64748B' }
      ],
      isScrolled: false,
      showSidebarTooltip: false,
      chatTopicPlusIcon: chatTopicPlusIconImg,
      fullDrawerImg: fullDrawerImg,
      openMenus: {},
      urlApi: import.meta.env.VITE_APP_API,
      unreadCount: 0,
      pathUrl: "",
      show: false,
      recentlyUpdatedFolderId: null,
      folderUpdateStatus: null,
      isDeleting: false,
      isDroppingOnFolder: null,
      isStartFromOutside: false,
      draggedItem: null,
      targetFolder: null,
      targetToOutsideArea: false,
      drag: false,
      deleteTopicDialog: {
        visible: false,
        topicId: null,
        keyTopic: null,
        index: null,
        topicName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      },
      pendingDeleteTopicIds: [],
      folderDialogStatus: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      },
      removeTopicDialog: {
        visible: false,
        folderId: null,
        topicId: null,
        topicIndex: null,
        topicName: '',
        folderName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      },
      deleteFolderDialog: {
        visible: false,
        id: null,
        idx: null,
        name: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: '',
        topics: []
      },
      moveToFolderDialog: {
        visible: false,
        topicId: null,
        topicName: '',
        selectedFolderId: null,
        currentFolderId: null,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      },
      folders: [],
      flagLoadingFolders: false,
      showAllFolders: false,
      showFolderDialog: false,
      showFolderMenu: false,
      folderListSize: 999,
      folderDialog: {
        visible: false,
        isNew: false,
        id: null,
        name: ''
      },
      username: Cookies.get("username"),
      fullName: Cookies.get("fullName"),
      role: roleLabel,
      roleId: Cookies.get("roleId"),
      SuperAdminRights: [
        "dashboard",
        "Vector",
        "Validation",
        "FlowList",
        "User",
        "Setting",
        "Stream",
        "Replace",
        "Report",
        "release-notes",
        "userprofile",
        "Playground",
        "IntentGroup",
        "ChatManagement",
        "Logs",
        "LogEvent",
        "ChatService",
        "ShortcutMenu",
        "ProductGroup",
        "ToolManagement",
      ],
      adminRights: [
        "dashboard",
        "Vector",
        "Validation",
        "FlowList",
        "User",
        "Setting",
        "Stream",
        "Replace",
        "Report",
        "release-notes",
        "userprofile",
        "Playground",
        "IntentGroup",
        "ChatManagement",
        "ChatService",
        "ShortcutMenu",
        "ProductGroup",
        "ToolManagement",
      ],
      generalUsersRights: [
        "GPTModelManagement",
        "Vector",
        "DataIntegration",
        "Validation",
        "FlowList",
        "Stream",
        "Replace",
        "userprofile",
        "Playground",
        "IntentGroup",
        "ToolManagement",
      ],
      operatorRights: [
        "GPTModelManagement",
        "Vector",
        "DataIntegration",
        "Validation",
        "FlowList",
        "Stream",
        "Replace",
        "userprofile",
        "Playground",
        "IntentGroup",
        "ChatService",
        "ShortcutMenu",
        "ToolManagement",
      ],
      shotName: "",
      usertype: store.state.usertype,
      drawer: null,
      rail: false,
      images: {
        logo: logoRemovebg,
      },
      currentflag: "en",
      languages: [
        { flag: "us", language: "en", title: "English" },
        { flag: "th", language: "th", title: "ไทย" },
      ],
      items: [
        {
          // title: "Dashboard",
          title: "_Dashboard",
          subtitle: "_Dashboard",
          icon: "mdi-view-dashboard",
          imgIcon: DashboardIcon,
          route: "/dashboard",
          href: "dashboard",
          Check: false,
          disabled: false,
          childstatus: true,
          children: [],
        },
        {
          // title: "Model",
          title: "_ModelCreator",
          subtitle: "_ModelCreator",
          icon: "mdi-file-document",
          imgIcon: ModelCreateIcon,
          route: "/GPTModelManagement",
          href: "GPTModelManagement",
          Check: true,
          disabled: false,
          childstatus: true,
          mainstatus: true,
          children: [
            {
              // title: "LLMs Model Detail",
              title: "_ModelCreator",
              subtitle: "Create Model",
              icon: "mdi-file-document",
              route: "/GPTModelDetail",
              href: "GPTModelDetail",
              Check: true,
              disabled: true,
            },
          ],
        },
        {
          // title: "Vector",
          title: "_KnowledgeManagement",
          subtitle: "_KnowledgeManagement",
          icon: "mdi-cloud-upload",
          imgIcon: KManageIcon,
          route: "",
          href: "Vector",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Vector Management",
              title: "_Documents",
              subtitle: "_DocumentList",
              icon: "mdi-cloud-upload",
              imgIcon: KManageIcon1,
              route: "/VectorManagement",
              href: "VectorManagement",
              Check: true,
              disabled: false,
              childstatus: true,
              mainstatus: true,
              children: [
                {
                  // title: "Upload Vector",
                  title: "_DocTitle",
                  subtitle: "_DocTitle",
                  icon: "mdi-file-document",
                  route: "/UploadVector",
                  href: "UploadVector",
                  Check: true,
                  disabled: false,
                  childstatus: true,
                  children: [
                    {
                      // title: "Upload Vector",  
                      title: '_ReplaceAllDoc', // Default title, will be updated dynamically
                      subtitle: '_ReplaceAllDoc',
                      dynamicTitle: true, // Flag to indicate this title should be dynamic
                      icon: "mdi-file-document",
                      route: "/UploadVectorEdit",
                      href: "UploadVectorEdit",
                      Check: true,
                      disabled: false,
                      
                    },
                  ],
                },
              ],
            },
            {
              // กราฟความรู้ของ GraphRAG — อยู่ใต้ Knowledge Management เพราะเป็นแหล่งความรู้ชนิดหนึ่ง
              //
              // **วางเป็นลูกชั้นเดียวเท่านั้น** — NavBar เรนเดอร์เมนูแค่ 2 ชั้น
              // (item → item.children) ไม่มีการเรนเดอร์ childrenItem.children
              // ถ้าซ้อนลึกกว่านี้ เมนูจะหายไปเงียบ ๆ โดยไม่มี error อะไรเลย
              //
              // children ด้านล่างเป็น "breadcrumb-only" — ไม่ถูกเรนเดอร์เป็นเมนู
              // (Check: false + อยู่ชั้นที่ 3) มีไว้ให้ buildBreadcrumbs() จับคู่
              // href === $route.name ของหน้า detail เท่านั้น
              title: "graphRagTitle",
              subtitle: "graphRagTitle",
              icon: "mdi-graph",
              iconColor: "#171717",
              route: "/KnowledgeGraphs",
              href: "KnowledgeGraphs",
              Check: true,
              disabled: false,
              childstatus: true,
              mainstatus: true,
              children: [
                {
                  title: "graphRagGraphDetail",
                  subtitle: "graphRagGraphDetail",
                  icon: "mdi-graph",
                  route: "/KnowledgeGraphs",
                  href: "KnowledgeGraphDetail",
                  Check: false,
                  disabled: false,
                },
              ],
            },
            {
              // title: "Data Integration Management",
              title: "_DatabaseIntegration",
              subtitle: "_DatabaseIntegration",
              icon: "mdi-database-import",
              imgIcon: KManageIcon2,
              route: "/DataIntegration",
              href: "DataIntegration",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "_DatabaseIntegration",
                  subtitle: "Data Integration Detail",
                  icon: "mdi-file-document",
                  route: "/DataIntegrationDetail",
                  href: "DataIntegrationDetail",
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              title: "Speech to Document",
              subtitle: "Speech to Document",
              icon: "mdi-database-import",
              imgIcon: KManageIcon3,
              route: "/UploadSoundToDocument",
              href: "UploadSoundToDocument",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "Speech to Document",
                  subtitle: "Generate Question Set",
                  route: "/UploadSoundToDocumentDetail",
                  href: "UploadSoundToDocumentDetail",
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              title: "_Product",
              subtitle: "Product Group List",
              icon: "mdi-database-import",
              imgIcon: KManageIcon4,
              route: "/ProductGroup",
              href: "ProductGroup",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "_ProductDetail",
                  subtitle: "Product Group Information",
                  route: "/ProductDetail",
                  href: "ProductDetail",
                  Check: true,
                  disabled: false,
                },
              ],
            },
          ],
        },
        {
          title: "Flow",
          subtitle: "Flow",
          icon: "mdi-chart-timeline-variant-shimmer",
          imgIcon: FlowIcon,
          route: "/FlowList",
          href: "FlowList",
          Check: true,
          disabled: false,
          childstatus: true,
          mainstatus: true,
          children: [
            {
              title: "Flow",
              subtitle: "Flow Creator",
              icon: "mdi-file-document",
              route: "/FlowCreator",
              href: "FlowCreator",
              Check: true,
              disabled: true,
            },
          ],
        },
        {
          title: "_toolManagement",
          subtitle: "_toolManagement",
          icon: "mdi-tools",
          imgIcon: ToolManagementIcon,
          route: "/ToolManagement",
          href: "ToolManagement",
          Check: true,
          disabled: false,
          childstatus: true,
          mainstatus: true,
          children: [],
        },
        {
          title: "Intent",
          subtitle: "Intent",
          icon: "mdi-comment-processing-outline",
          imgIcon: IntentIcon,
          route: "/IntentGroup",
          href: "IntentGroup",
          Check: true,
          disabled: false,
          childstatus: true,
          mainstatus: true,
          children: [
            // {
            //   title: "IntentGroup",
            //   icon: "mdi-database-import",
            //   route: "/IntentGroup",
            //   href: "IntentGroup",
            //   Check: true,
            //   disabled: false,
            //   children: [],
            // },
            {
              title: "Intent",
              subtitle: "Intent Group Information",
              icon: "mdi-database-import",
              route: "/IntentSession",
              href: "IntentSession",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "Intent",
                  subtitle: "Intent Session Information",
                  icon: "mdi-file-document",
                  route: "/IntentSessionDetail",
                  href: "IntentSessionDetail",
                  Check: true,
                  disabled: false,
                },
              ],
            },
          ],
        },
        {
          // title: "Replace",
          title: "_OptimizationTechniques",
          subtitle: "_OptimizationTechniques",
          icon: "mdi-find-replace",
          imgIcon: OptiTechIcon,
          route: "",
          href: "Replace",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "GroupPromptTemplate",
              title: "Prompt Template",
              subtitle: "_PromptTemplate",
              icon: "mdi-database-outline",
              imgIcon: OptiTechIcon1,
              route: "/GroupPromptTemplate",
              href: "GroupPromptTemplate",
              Check: false,
              disabled: false,
              childstatus: true,
              children: [
                {
                  // title: "PromptTemplate",
                  title: "Prompt Template",
                  subtitle: "Prompt Template Detail",
                  icon: "mdi-database-outline",
                  route: "/PromptTemplate",
                  href: "PromptTemplate",
                  Check: false,
                  disabled: false,
                },
              ],
            },
            {
              // title: "Replace Text",
              title: "_TextReplacement",
              subtitle: "_TextReplacement",
              icon: "mdi-file-document",
              imgIcon: OptiTechIcon2,
              route: "/GroupReplacetext",
              href: "GroupReplacetext",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  // title: "replaceText",
                  title: "_OptimizationTechniques",
                  subtitle: "Add Text Group",
                  icon: "mdi-file-document",
                  route: "/ReplaceText",
                  href: "ReplaceText",
                  Check: true,
                  disabled: false,
                },
              ],
            },
          ],
        },
        {
          // title: "Validation",
          title: "_ModelTesting",
          subtitle: "_ModelTesting",
          icon: "mdi-folder",
          imgIcon: ModelTestIcon,
          route: "",
          href: "Validation",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Positive generate",
              title: "_GenerateTestQuestions",
              subtitle: "_GenerateTestQuestions",
              imgIcon: MTestIcon1,
              route: "/ValidationGenerate",
              href: "ValidationGenerate",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  // title: "Positive generate upload",
                  title: "_GenerateTestQuestions",
                  subtitle: "Generate Question Set",
                  icon: "mdi-cloud-upload",
                  route: "/ValidationGenerateUpload",
                  href: "ValidationGenerateUpload",
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              // title: "Positive Question set"
              title: "PositiveQuestionSet",
              subtitle: "PositiveQuestionSet",
              imgIcon: MTestIcon2,
              route: "/ValidationPositive",
              href: "ValidationPositive",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "PositiveQuestionSet",
                  subtitle: "Upload Positive Question Set",
                  icon: "mdi-cloud-upload",
                  route: "/ValidationPositiveDetail",
                  href: "ValidationPositiveDetail",
                  Check: true,
                  disabled: false,
                }
              ],
            },
            {
              // title: "Negative generate",
              title: "_NegativeQuestionSet",
              subtitle: "_NegativeQuestionSet",
              imgIcon: MTestIcon3,
              route: "/ValidationNegative",
              href: "ValidationNegative",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  // title: "Negative generate detail",
                  title: "_NegativeQuestionSet",
                  subtitle: "_UploadNegativeQuestionSet",
                  dynamicTitle: true,
                  icon: "mdi-cloud-upload",
                  route: "/ValidationNegativeDetail",
                  href: "ValidationNegativeDetail",
                  Check: true,
                  disabled: false,
                },
              ],
            },
            {
              // title: "Process",
              title: "_ExecuteTestRuns",
              subtitle: "_ExecuteTestRuns",
              imgIcon: MTestIcon4,
              route: "/ValidationProcess",
              href: "ValidationProcess",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  title: "_ExecuteTestRuns",
                  subtitle: "Dashboard score",
                  icon: "mdi-cloud-upload",
                  route: "/DashboardScore",
                  href: "DashboardScore",
                  Check: false,
                  disabled: false,
                },
              ],
            },
          ],
        },
        {
          // title: this.$t("user"),
          title: "_UserManagement",
          subtitle: "_UserManagement",
          icon: "mdi-account-multiple",
          imgIcon: UserManageIcon,
          route: "",
          href: "User",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "User Management",
              title: "_PortalUserManagement", //"_UserManagement"
              subtitle: "usermanagement",
              icon: "mdi-account-multiple",
              imgIcon: UserManageIcon1,
              route: "/UserManagement",
              href: "UserManagement",
              Check: true,
              disabled: false,
            },
            {
              // title: "User Chat Management",
              title: "_ChatUser",
              subtitle: "_ChatUserManagement",
              icon: "mdi-account-multiple",
              imgIcon: UserManageIcon2,
              route: "/UserChatManagement",
              href: "UserChatManagement",
              Check: true,
              disabled: false,
            },
            {
              // title: "User Group",
              title: "_UserGroup",
              subtitle: "_UserGroupManagement",
              icon: "mdi-account-multiple",
              imgIcon: UserManageIcon3,
              route: "/GroupUserManagement",
              href: "GroupUserManagement",
              Check: true,
              disabled: false,
              childstatus: true,
              children: [
                {
                  // title: "User Group Management",
                  title: "_GroupUserManagement",
                  subtitle: "_UserGroupDetail",
                  icon: "mdi-account-multiple",
                  route: "/UserGroupDetail",
                  href: "UserGroupDetail",
                  query: true,
                  Check: true,
                  disabled: false,
                  childstatus: true,
                  children: [
                    {
                      // title: "Setup User Group",
                      title: "_GroupUserManagement",
                      subtitle: "_SetupUserGroup",
                      icon: "mdi-account-multiple",
                      route: "/SetupUserGroup",
                      href: "SetupUserGroup",
                      query: true,
                      Check: true,
                      disabled: false,
                    },
                  ],
                },
              ],
            },
            {
              title: "_BlacklistChatUser",
              subtitle: "_BlacklistChatUserManagement",
              icon: "mdi-account-multiple",
              imgIcon: UserManageIcon4,
              route: "/BlacklistChatUserManagement",
              href: "BlacklistChatUserManagement",
              Check: true,
              disabled: false,
            },
          ],
        },
        {
          title: "_ChatManagement",
          subtitle: "_ChatManagement",
          icon: "mdi-message-settings",
          imgIcon: ChatManageIcon,
          route: "",
          href: "ChatManagement",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "groupModel",
              title: "_ModelGrouping",
              subtitle: "_ModelGrouping",
              icon: "mdi-wrench",
              imgIcon: CManageIcon1,
              route: "/SetupGroupModel",
              href: "SetupGroupModel",
              Check: true,
              disabled: false,
            },
            {
              // title: "Quick Model",
              title: "_ModelShortcut",
              subtitle: "_ModelShortcut",
              icon: "mdi-wrench",
              imgIcon: CManageIcon2,
              route: "/ModelShortcut",
              href: "ModelShortcut",
              Check: true,
              disabled: false,
            },
            {
              title: "Model Quick Reply",
              subtitle: "Model Quick Reply",
              icon: "mdi-account-multiple",
              imgIcon: CManageIcon3,
              route: "/ModelQuickReply",
              href: "ModelQuickReply",
              Check: true,
              disabled: false,
            },
            {
              title: "shortcutMenu",
              subtitle: "shortcutMenu",
              icon: "mdi-account-multiple",
              imgIcon: CManageIcon4,
              route: "/ShortcutMenu",
              href: "ShortcutMenu",
              Check: true,
              disabled: false,
            },
          ],
        },
        // {
        //   title: ('_FileManagement'),
        //   icon: "mdi-file-multiple",
        //   route: "/FileManagements",
        //   href: "FileManagements",
        //   Check: false,
        //   disabled: false,
        //   childstatus: true,
        //   children: [],
        // },
        {
          // title: "Setup",
          title: "_Setting",
          subtitle: "_Setting",
          icon: "mdi-wrench",
          imgIcon: SettingIcon,
          route: "Setting",
          href: "Setting",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              title: "_CoreConfigurations",
              subtitle: "_CoreConfigurations",
              icon: "mdi-wrench",
              imgIcon: SettingIcon1,
              route: "/setup",
              href: "Setup",
              Check: true,
              disabled: false,
            },
            {
              title: "_ExternalConnector",
              subtitle: "_ExternalConnector",
              icon: "mdi-wrench",
              imgIcon: SettingIcon2,
              route: "/SettingExternalConnector",
              href: "SettingExternalConnector",
              Check: true,
              disabled: false,
            },
            {
              title: "_LLMsManagement",
              subtitle: "_LLMsManagement",
              icon: "mdi-database-outline",
              imgIcon: SettingIcon3,
              route: "/modeldata",
              href: "ModelData",
              Check: true,
              disabled: false,
            },
            {
              title: "_PlatformIntegration",
              subtitle: "_PlatformIntegration",
              icon: "mdi-wrench",
              imgIcon: SettingIcon4,
              route: "/SetupSocial",
              href: "SetupSocial",
              Check: true,
              disabled: false,
            },
            {
              title: "serviceTheme",
              subtitle: "serviceTheme",
              icon: "mdi-wrench",
              imgIcon: SettingIcon5,
              route: "/ServiceTheme",
              href: "ServiceTheme",
              Check: true,
              disabled: false,
            },
            {
              title: "consentConfig",
              subtitle: "consentConfig",
              icon: "mdi-wrench",
              imgIcon: SettingIcon6,
              route: "/ConsentConfig",
              href: "ConsentConfig",
              Check: true,
              disabled: false,
            },
          ],
        },
        {
          // title: "Report",
          title: "_Reports",
          subtitle: "_Reports",
          icon: "mdi-chart-box-multiple",
          imgIcon: ReportIcon,
          route: "",
          href: "Report",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              // title: "Question",
              title: "_QuestionTrends",
              subtitle: "_QuestionTrends",
              icon: "mdi-chart-box-multiple",
              imgIcon: ReportIcon1,
              route: "/ReportQuestionTop10",
              href: "ReportQuestionTop10",
              Check: true,
              disabled: false,
            },
            {
              // title: "User",
              title: "_TopUsers",
              subtitle: "_TopUsers",
              icon: "mdi-chart-box-multiple",
              imgIcon: ReportIcon2,
              route: "/ReportUserTop10",
              href: "ReportUserTop10",
              Check: true,
              disabled: false,
            },
            {
              // title: "Total Question By User",
              title: "_TotalUsageInsights",
              subtitle: "_TotalUsageInsights",
              icon: "mdi-chart-box-multiple",
              imgIcon: ReportIcon3,
              route: "/ReportUserUse",
              href: "ReportUserUse",
              Check: true,
              disabled: false,
            },
            {
              title: "TokenSummation",
              subtitle: "TokenSummation",
              icon: "mdi-chart-box-multiple",
              imgIcon: ReportIcon4,
              route: "/ReportTokenSum",
              href: "ReportTokenSum",
              Check: true,
              disabled: false,
            },
            {
              title: "Report Feedback",
              subtitle: "Report Feedback",
              icon: "mdi-chart-box-multiple",
              imgIcon: ReportIcon5,
              route: "/ReportFeedback",
              href: "ReportFeedback",
              Check: true,
              disabled: false,
            },
          ],
        },
        {
          title: "Logs",
          subtitle: "Logs",
          icon: "mdi-clipboard-text",
          imgIcon: LogsIcon,
          route: "",
          href: "Logs",
          Check: false,
          disabled: true,
          childstatus: false,
          children: [
            {
              title: "_ChatLogs",
              subtitle: "_ChatLogs",
              icon: "mdi-clipboard-text",
              imgIcon: LogsIcon1,
              route: "/LogMessage",
              href: "LogMessage",
              Check: false,
              disabled: false,
            },
            {
              title: "logEvent",
              subtitle: "logEvent",
              icon: "mdi-clipboard-search-outline",
              imgIcon: LogsIcon2,
              route: "/LogEvent",
              href: "LogEvent",
              Check: true,
              disabled: false,
            },
            {
              title : "API External Log",
              subtitle : "API External Log",
              icon : "",
              imgIcon: LogsIcon3,
              route : "/LogAPIExternal",
              href: "LogAPIExternal",
              Check: true,
              disabled: false,
            }
          ],
        },
        {
          // title: "Chat Preview",
          // icon: "mdi-application-settings-outline",
          title: "_ChatPlayground",
          subtitle: "_ChatPlayground",
          icon: "mdi-monitor",
          imgIcon: ChatPlayIcon,
          route: "/Stream",
          href: "Stream",
          Check: false,
          disabled: true,
          childstatus: true,
          children: [],
        },
        {
          // title: "Playground",
          title: "_DualChatPlayground",
          subtitle: "_DualChatPlayground",
          // icon: "mdi-motion-play",
          icon: "mdi-monitor-multiple",
          imgIcon: DualChatPlayIcon,
          route: "/Playground",
          href: "Playground",
          Check: false,
          disabled: true,
          childstatus: true,
          children: [],
        },
        {
          // title: "ChatService",
          title: "_ChatService",
          subtitle: "_ChatService",
          icon: "mdi-forum",
          imgIcon: ChatServiceIcon,
          route: "/ChatService",
          href: "ChatService",
          Check: false,
          disabled: true,
          childstatus: true,
          children: [],
        },
      ],
      breadcrumbsItem: [],
      mini: true,
      miniDefault: true,
      drawerFull: false,
      drawerMobile: false,
      selectedColor: "#F7B34E",
      parameterURL: [],
      isSnippet: false,
      showBTNLogin: true,
      versioning: version,
      showScrollButton: false,
      queryID: null,
      consent_dialog: true,
      dataConsent: "",
      dataVersion: "",
      dataConsentTH: "",
      dataConsentEN: "",
      flagUpdateVersion: false,
      audioUnlocked: false,
      soundEnabled: false,
      sound: notificationSound,
      editorOptions: {
        readOnly: true,
        modules: {
          toolbar: false, // ซ่อน toolbar
        },
      },
      activeMenuMap: {},
    };
  },
  created() {
    // Initialize drawer state
    this.drawer = true;
    this.rail = false;
    
    // โหลดฝารตั้งค่าเสียงจาฝ localStorage
    const savedSoundSetting = localStorage.getItem("soundEnabled");
    if (savedSoundSetting !== null) {
      this.soundEnabled = savedSoundSetting === "true";
    }

    // โหลดสถานะฝารอนุฝาตเสียงจาฝ localStorage
    const savedAudioUnlocked = localStorage.getItem("audioUnlocked");
    if (savedAudioUnlocked === "true") {
      this.audioUnlocked = true;
    }
  },
  computed: {
    chatServiceUnreadCount() {
      return this.tabSocialType?.find((item) => item.value === "All")?.unreadCount || 0;
    },
    dynamicUploadTitle() {
      return this.$route?.query?.DocEdit == '1' ? '_AddMoreDoc' : '_ReplaceAllDoc';
    },
    currentRouter() {
      return this.$router;
    },
    currentRoute() {
      return this.$route;
    },
    currentRoutePath() {
      return this.$route?.path || '';
    },
    topicsNotInFolders() {
      const topicsInFolders = this.folders.reduce((ids, folder) => {
        if (folder.topics && folder.topics.length > 0) {
          folder.topics.forEach(topic => {
            ids.add(topic.topicID);
          });
        }
        return ids;
      }, new Set());
      return this.listTopic.filter(topic =>
        topic.topicID !== -1 && !topicsInFolders.has(topic.topicID)
      );
    },
    filteredFolders() {
      return this.folders.filter(folder => folder.id !== this.moveToFolderDialog.currentFolderId);
    },
    modelFirstComputed() {
      try {
          const temp = this.ModelFirst.split("(").map(item => item.trim());
        return temp[1].replace(")", " ") + "(" + temp[0] + ")";
      } catch (error) {
        console.error(error);
        // ModelFirst not in expected format, return placeholder
        return "-";
      }
    },
    currentRouteName() {
      return this.route?.name || this.$route?.name || "";
    },
    currentFullName() {
      return store.state.fullName;
    },
    checkMini() {
      let miniC =
        (!this.Snippet_Username && this.Snippet_Status) ||
          (!!this.Snippet_Username && !this.Snippet_Status)
          ? this.miniDefault
          : this.mini;
      return miniC;
    },
    paddingLeft() {
      if (this.pathUrl == "FullStream") {
        return this.SetPopup ? "273px" : "15px";
      } else {
        return this.drawer ? "273px" : "15px";
      }
    },
    breadcrumbsList() {
      const breadcrumbs = this.buildBreadcrumbs(this.$route.name);
      this.applyBreadcrumbs(breadcrumbs);
      return this.breadcrumbsItem;
    },
    headers() {
      return [
        { title: "no", align: "left", sortable: false },
        {
          title: "question",
          align: "left",
          sortable: true,
          value: "Question",
        },
        {
          title: "answer",
          align: "left",
          sortable: true,
          value: "Answer",
        },
        {
          title: "score",
          align: "left",
          sortable: true,
          value: "Score",
        },
      ];
    },
    ddProfile() {
      return [
        {
          no: 1,
          title: "userprofile",
          icon: "mdi-account-circle",
          route: "/userprofile",
          href: "userprofile",
          action: () => { },
          Check: true,
        },
        {
          no: 2,
          title: "releasesnotes",
          icon: "mdi-package-variant",
          route: "/release-notes",
          href: "release-notes",
          action: () => { },
          Check: true,
        },
        {
          no: 3,
          title: "usermanual",
          icon: "mdi-book-open-variant",
          action: () => {
            this.downloadLink();
          },
          Check: true,
        },
        {
          no: 4,
          title: "logout",
          icon: "mdi-logout",
          action: () => {
            this.logout();
          },
          Check: true,
        },
      ];
    },
    LeftNavBar() {
      return this.Snippet_Username;
    },
    navbarIcon() {
      return this.NavbarIcon;
    },
    ColorThemeChat() {
      return this.FullstreamChatColorTheme || this.colorThemeChat;
    },
    fullstreamChatAccentColor() {
      return this.normalizeThemeColor(this.ColorThemeChat, "#F7B34E");
    },
    fullstreamHeaderTextColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarTxtColorTheme || this.NavbarTxtColorTheme, "#FFFFFF");
    },
    fullstreamHeaderIconColor() {
      return this.normalizeThemeColor(this.FullstreamNavbarIconColorTheme || this.FullstreamNavbarTxtColorTheme || this.NavbarTxtColorTheme, "#FFFFFF");
    },
    fullstreamHeaderIconStyle() {
      return {
        color: this.fullstreamHeaderIconColor,
      };
    },
    fullstreamActionIconStyle() {
      return {
        color: this.fullstreamChatAccentColor,
      };
    },
    fullstreamActionButtonStyle() {
      return {
        color: this.fullstreamHeaderIconColor,
        marginLeft: "10px",
        zIndex: 5000,
      };
    },
    filteredItems() {
      let res = this.items.filter((item) => {
        if (!item.route) return item.route === "";
        const route = this.$router.resolve(item.route);
        if (item.children && item.children.length > 0) {
          item.children = item.children.filter((child) => {
            try {
              if (!child.route) return false;
              const resChild = this.$router.resolve(child.route);
              return this.hasAdminRights(resChild);
            } catch (err) {
              console.error("Error resolving child route:", err);
              return false;
            }
          });
        }
        return this.hasAdminRights(route) || item.route === "";
      });
      return res;
    },
    mdAndUp() {
      return this.display.mdAndUp.value;
    },
    smAndUp() {
      return this.display.smAndUp.value;
    },
  },
  watch: {
    drawerFull(newValue) {
      this.$store.commit("SET_DRAWER_OPEN", newValue); // สมมติว่ามี mutation ชื่อ SET_DRAWER_OPEN
    },
    navbarIcon(newVal) {
      this.images.logo = newVal || logoRemovebg;
    },
    currentFullName() {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.setFullname(); // เรียฝฟังฝ์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    ColorThemeChat(newVal) {
      this.selectedColor = this.normalizeThemeColor(newVal, "#F7B34E");
    },
    '$route.query.DocEdit': {
      handler(newValue) {
        this.updateDynamicTitle();
      },
      immediate: true
    },
    '$route.query.id': {
      handler(newValue) {
        this.updateDynamicTitle();
      },
      immediate: true
    },
    '$route.path': {
      handler(newPath, oldPath) {
        // Debug route changes and menu active states
        if (process.env.NODE_ENV === 'development' && newPath !== oldPath) {
          // Find which menu items should be active
          this.$nextTick(() => {
            const activeItems = this.items.filter((item, index) => {
              const isActive = this.isMenuItemActiveRecursive(item);
              if (isActive) {
                return true;
              }
              return isActive;
            });

            if (activeItems.length === 0) {
              return;
            }
          });
        }
        
        // Auto-expand menus when children are active
        this.autoExpandActiveMenus();
      },
      immediate: true
    },
    $route: {
      handler() {
        this.updateActiveMenuStates();
      },
      immediate: true,
    },
    mini(val) {
      if (!val) {
        if (!this.flagGetAllTopic) {
          this.flagShowTopic = true;
        }
        this.flagGetAllTopic = true;
      }
      this.miniVariant = val;
    },
    drawerMobile(val) {
      if (val) {
        if (!this.flagGetAllTopic) {
          this.flagShowTopic = true;
        }
        this.flagGetAllTopic = true;
      }
    },
    currentRouteName: {
      handler(newRouteName) {
        if (newRouteName) {
          this.pathUrl = newRouteName;
        }
      },
      immediate: true,
    },
    "$route.name": {
      handler(newName) {
        this.queryID = store.state.groupSecurityID;
        if (newName) {
          this.pathUrl = newName;
        }
      },
      immediate: true,
    },
    isAllowLLMChange(newValue) {
      if (this.pathUrl == 'FullStream' && this.unwrapInjectedValue(newValue) !== true) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
        this.showModelDropdown = false;
        this.showModelDropdownDialog = false;
      }
    },
    selectedLLMModelInChat: {
      handler(newValue) {
        this.selectedLLMModel = this.unwrapInjectedValue(newValue) || null;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    normalizeThemeColor(value, fallback = "#F7B34E") {
      if (value == null || value === "") {
        return fallback;
      }

      const color = String(value).trim();
      return color.startsWith("#") ? color : `#${color}`;
    },
    unwrapInjectedValue(value) {
      return value && typeof value === "object" && Object.hasOwn(value, "value")
        ? value.value
        : value;
    },
    getLLMModelId(model) {
      return model?.id ?? model?.ID ?? model?.Id ?? model?.iD ?? model?.modelDataID ?? model?.modelDataId ?? null;
    },
    updateSelectedLLMModel(model = null) {
      const selectedModel = model;
      this.selectedLLMModel = selectedModel;

      if (typeof this.setSelectedLLMModelInChat === 'function') {
        this.setSelectedLLMModelInChat(selectedModel);
        return;
      }

      if (this.selectedLLMModelInChat && typeof this.selectedLLMModelInChat === 'object' && Object.hasOwn(this.selectedLLMModelInChat, 'value')) {
        this.selectedLLMModelInChat.value = selectedModel;
        return;
      }

      this.selectedLLMModelInChat = selectedModel;
    },
    updateLastLLMID(id = null) {
      const llmID = id;

      if (typeof this.setLastLLMIDInChat === 'function') {
        this.setLastLLMIDInChat(llmID);
      } else if (this.lastLLMID && typeof this.lastLLMID === 'object' && Object.hasOwn(this.lastLLMID, 'value')) {
        this.lastLLMID.value = llmID;
      } else {
        this.lastLLMID = llmID;
      }
    },
    findBreadcrumbBranch(children, path, parents) {
      if (!Array.isArray(children) || children.length === 0) {
        return [];
      }

      for (const child of children) {
        if (child.href == path) {
          return [...parents, child];
        }

        const branch = this.findBreadcrumbBranch(child.children, path, [...parents, child]);
        if (branch.length > 0) {
          return branch;
        }
      }

      return [];
    },
    buildBreadcrumbs(path) {
      const breadcrumbs = [];

      for (let item of this.items) {
        if (item.href == path) {
          breadcrumbs.push(item);
          break;
        }

        const branch = this.findBreadcrumbBranch(item.children, path, [item]);
        if (branch.length > 0) {
          breadcrumbs.push(...branch);
        }
      }

      return breadcrumbs;
    },
    canAccessBreadcrumbs(breadcrumbs) {
      if (this.roleId == 2) {
        return this.generalUsersRights.includes(breadcrumbs[0].href);
      }

      if (this.roleId == 6) {
        return this.operatorRights.includes(breadcrumbs[0].href);
      }

      return true;
    },
    updateBreadcrumbDisabledStates() {
      for (let i = 0; i < this.breadcrumbsItem.length; i++) {
        if (i === this.breadcrumbsItem.length - 2) {
          if (this.breadcrumbsItem[i].childstatus) {
            this.breadcrumbsItem[i].disabled = false;
          }
        } else {
          this.breadcrumbsItem[i].disabled = true;
        }
      }
    },
    applyBreadcrumbs(breadcrumbs) {
      this.breadcrumbsItem = [];

      if (breadcrumbs.length === 0) {
        return;
      }

      if (!this.canAccessBreadcrumbs(breadcrumbs)) {
        this.AccessDenied();
        return;
      }

      this.breadcrumbsItem = breadcrumbs;
      this.updateBreadcrumbDisabledStates();
    },
    findMenuItemByHrefPath(hrefs) {
      let children = this.items;
      let menuItem = null;

      for (const href of hrefs) {
        menuItem = children?.find((item) => item.href === href) || null;
        if (!menuItem) {
          return null;
        }
        children = menuItem.children;
      }

      return menuItem;
    },
    updateDynamicMenuTitle(hrefs, newTitle) {
      const menuItem = this.findMenuItemByHrefPath(hrefs);
      const dynamicItem = menuItem?.children?.find((child) => child.dynamicTitle);

      if (dynamicItem) {
        dynamicItem.title = newTitle;
        dynamicItem.subtitle = newTitle;
      }
    },
    appendTopicToFolder(folderId, topic) {
      const folderIndex = this.folders.findIndex((folder) => folder.id === folderId);
      if (folderIndex === -1) {
        return;
      }

      if (!this.folders[folderIndex].topics) {
        this.folders[folderIndex].topics = [];
      }

      this.folders[folderIndex].topics.push(topic);
    },
    moveTopicBetweenFolders(topicId, fromFolderId, toFolderId) {
      const fromFolderIndex = this.folders.findIndex((folder) => folder.id === fromFolderId);
      const toFolderIndex = this.folders.findIndex((folder) => folder.id === toFolderId);

      if (fromFolderIndex === -1 || !this.folders[fromFolderIndex].topics) {
        return;
      }

      const topicIndex = this.folders[fromFolderIndex].topics.findIndex((topic) => topic.topicID === topicId);
      if (topicIndex === -1) {
        return;
      }

      const topicToMove = { ...this.folders[fromFolderIndex].topics[topicIndex] };
      this.folders[fromFolderIndex].topics.splice(topicIndex, 1);

      if (toFolderIndex !== -1) {
        this.appendTopicToFolder(toFolderId, topicToMove);
      }
    },
    showFolderUpdateStatus(folderId, status) {
      this.recentlyUpdatedFolderId = folderId;
      this.folderUpdateStatus = status;

      setTimeout(() => {
        this.recentlyUpdatedFolderId = null;
        this.folderUpdateStatus = null;
      }, 2000);
    },
    setMoveToFolderDialogLoading() {
      this.moveToFolderDialog.isLoading = true;
      this.moveToFolderDialog.isSuccess = false;
      this.moveToFolderDialog.isError = false;
      this.moveToFolderDialog.errorMessage = '';
    },
    closeMoveToFolderDialogSoon() {
      setTimeout(() => {
        this.closeMoveToFolderDialog();
      }, 600);
    },
    showMoveToFolderDialogError(message) {
      this.moveToFolderDialog.isLoading = false;
      this.moveToFolderDialog.isError = true;
      this.moveToFolderDialog.errorMessage = message;

      setTimeout(() => {
        this.moveToFolderDialog.isError = false;
      }, 1000);
    },
    createFolderTopic(topic) {
      return {
        topicID: topic.topicID,
        topicName: topic.topicName,
        topicModelID: topic.topicModelID || 1,
        topicModelID_long: topic.topicModelID_long || topic.topicID,
        keyTopic: topic.keyTopic || topic.topicID.toString(),
      };
    },
    moveExistingTopicFromDialog(topicId, currentFolderId, selectedFolderId) {
      const request = {
        topicID: topicId,
        fromFolderID: currentFolderId,
        toFolderID: selectedFolderId,
        userID: this.User_Id,
      };

      this.$call.MoveTopicToFolder(
        request,
        (response) => {
          this.moveToFolderDialog.isLoading = false;

          if (response.status === 0) {
            this.moveTopicBetweenFolders(topicId, currentFolderId, selectedFolderId);
            this.moveToFolderDialog.isSuccess = true;
            this.closeMoveToFolderDialogSoon();
          } else {
            this.showMoveToFolderDialogError(response.message || 'Failed to move topic');
          }
        },
        (error) => {
          console.error('Error moving topic:', error);
          this.showMoveToFolderDialogError('Cannot move topic');
        }
      );
    },
    addExistingTopicToDialog(topicId, selectedFolderId) {
      const topic = this.listTopic.find((item) => item.topicID === topicId);
      if (!topic) {
        return;
      }

      const request = {
        folderID: selectedFolderId,
        topicID: topic.topicID,
        userID: this.User_Id,
      };

      this.$call.AddTopicToFolder(
        request,
        (response) => {
          this.moveToFolderDialog.isLoading = false;

          if (response.status === 0) {
            this.moveToFolderDialog.isSuccess = true;
            this.appendTopicToFolder(selectedFolderId, this.createFolderTopic(topic));
            this.closeMoveToFolderDialogSoon();
          } else {
            this.showMoveToFolderDialogError(response.message || 'Failed to add topic to folder');
          }
        },
        (error) => {
          console.error('Error adding topic to folder:', error);
          this.showMoveToFolderDialogError('Cannot add topic to folder');
        }
      );
    },
    getRightsForRole(roleId) {
      if (roleId == 0) {
        return { rights: this.SuperAdminRights, includeChildren: true };
      }

      if (roleId == 1) {
        return { rights: this.adminRights, includeChildren: true };
      }

      if (roleId == 2) {
        return { rights: this.generalUsersRights, includeChildren: false };
      }

      if (roleId == 6) {
        return { rights: this.operatorRights, includeChildren: false };
      }

      return null;
    },
    applyRightsToItems(rights, includeChildren) {
      for (let item of this.items) {
        if (rights.includes(item.href)) {
          if (includeChildren && item.children) {
            item.children.forEach((element) => {
              element.Check = true;
            });
          }
          item.Check = true;
        }
      }
    },
    applyRightsToProfile(rights) {
      for (let item of this.ddProfile) {
        if (rights.includes(item.href)) {
          item.Check = true;
        }
      }
    },
    hasSnippetToken() {
      return sessionStorage.getItem("token_Snippet") != null || localStorage.getItem("token_Snippet") != null || Cookies.get("token_Snippet") != null;
    },
    setSnippetUserIdentity() {
      const identitySources = [sessionStorage, localStorage, Cookies];

      for (const source of identitySources) {
        const username = source.getItem ? source.getItem("username_Snippet") : source.get("username_Snippet");
        const email = source.getItem ? source.getItem("email_Snippet") : source.get("email_Snippet");

        if (username != null && email != null) {
          this.Snippet_Username = username;
          this.User_Id_Show = email;
          return;
        }
      }
    },
    addNavDrawerScrollListener() {
      this.$nextTick(() => {
        const drawerContent = document.querySelector(
          "#NavFullStream .v-navigation-drawer__content"
        );
        if (drawerContent) {
          drawerContent.addEventListener("scroll", this.handleDrawerScroll);
        }
      });
    },
    initializeFullStreamRoute() {
      this.addNavDrawerScrollListener();
      this.GetAllLLMModelData();

      if (!this.parameterURL.snippet) {
        i18n.locale = "th";
        this.currentflag = "th";
        return;
      }

      i18n.locale = "en";
      this.currentflag = "en";
      if (!this.hasSnippetToken()) {
        this.GetCheckAnonymous();
        this.Snippet_Username = "";
        this.Snippet_Status = false;
        return;
      }

      this.setSnippetUserIdentity();
      this.Snippet_Status = true;
    },
    initializeSnippetRoute() {
      this.addNavDrawerScrollListener();
      i18n.locale = "en";
      this.currentflag = "en";

      if (!this.hasSnippetToken()) {
        this.GetCheckAnonymous();
        this.Snippet_Username = "";
        this.Snippet_Status = true;
        return;
      }

      this.setSnippetUserIdentity();
      this.Snippet_Status = false;
    },
    initializeDefaultRoute() {
      this.currentflag = localStorage.getItem("flag");
      i18n.locale = localStorage.getItem("locale");
      if (this.username) {
        this.shotName =
          this.fullName != null &&
          this.fullName != undefined &&
          this.fullName.length > 1
            ? this.fullName.substring(0, 1).toUpperCase()
            : "";
      }
    },
    initializeCurrentRouteState() {
      if (this.pathUrl === "FullStream") {
        this.initializeFullStreamRoute();
      } else if (this.pathUrl === "Snippet") {
        this.initializeSnippetRoute();
      } else {
        this.initializeDefaultRoute();
      }
    },
    syncParameterURLFromRouteQuery() {
      for (let key in this.$route.query) {
        this.parameterURL[key.toLowerCase()] = this.$route.query[key];
      }
    },
    getTabSocialTypeWithUnread(item, countUnreads) {
      if (item.value === "All") {
        const total = countUnreads.reduce(
          (sum, curr) => sum + curr.unreadCount,
          0
        );
        return { ...item, unreadCount: total };
      }

      const match = countUnreads.find((countUnread) => countUnread.socialType === item.value);
      return { ...item, unreadCount: match ? match.unreadCount : 0 };
    },
    getAllUnreadCount() {
      return this.tabSocialType.find((item) => item.value === "All").unreadCount;
    },
    updateTabSocialUnreadCounts(countUnreads, notifyOnIncrease = false) {
      const updatedTabs = this.tabSocialType.map((item) => this.getTabSocialTypeWithUnread(item, countUnreads));
      this.tabSocialType.splice(0, this.tabSocialType.length, ...updatedTabs);
      const unreadCount = this.getAllUnreadCount();

      if (notifyOnIncrease && unreadCount > 0 && this.unreadCount < unreadCount) {
        this.playNotificationSound();
      }

      this.unreadCount = unreadCount;
    },
    updateActiveMenuStates() {
      try {
        this.activeMenuMap = {};
        const currentPath = this.$route.path;

        const traverse = (menuList) => {
          for (const item of menuList) {
            if (!item || typeof item !== "object") continue;

            let isActive = false;

            // Exact or prefix match (safe from nulls)
            if (
              item.route &&
              (currentPath === item.route ||
                currentPath.startsWith(item.route + "/"))
            ) {
              isActive = true;
            }

            // Recursive check for children if exist
            if (Array.isArray(item.children) && item.children.length > 0) {
              traverse(item.children);
              if (item.children.some((child) => this.activeMenuMap[child.route])) {
                isActive = true;
              }
            }

            if (item.route) {
              this.activeMenuMap[item.route] = isActive;
            }
          }
        };

        traverse(this.filteredItems);
      } catch (err) {
        console.warn("Error in updateActiveMenuStates:", err);
      }
    },

    // helper used in the template
    isMenuActive(item) {
      return this.activeMenuMap[item.route] || false;
    },
    // Recursively check if current route matches this item or any of its children
    isMenuItemActiveRecursive(item) {
      try {
        if (!item || !this.$route) {
          return false;
        }

        const currentPath = this.$route.path;
        
        // Check if this item's route matches current route
        if (item.route && currentPath === item.route) {
          return true;
        }

        // Additional check for route patterns (in case of query params)
        if (item.route && currentPath.startsWith(item.route) && 
            (currentPath === item.route || currentPath.charAt(item.route.length) === '/' || currentPath.charAt(item.route.length) === '?')) {
          return true;
        }

        // Check children recursively at all levels
        if (item.children && Array.isArray(item.children) && item.children.length > 0) {
          for (const child of item.children) {
            if (this.isMenuItemActiveRecursive(child)) {
              return true;
            }
          }
        }
        
        return false;
      } catch (error) {
        console.warn('Error in isMenuItemActiveRecursive:', error);
        return false;
      }
    },
    isMenuItemActive(item) {
      const currentPath = this.$route?.path;
      if (!currentPath) return false;

      // Check if the current route matches the item's route
      if (item.route === currentPath) {
        return true;
      }

      // Check if any child route matches the current path
      if (item.children && item.children.length > 0) {
        return this.hasActiveChild(item.children, currentPath);
      }

      return false;
    },
    hasActiveChild(children, currentPath) {
      for (const child of children) {
        // Check if current child route matches
        if (child.route === currentPath) {
          return true;
        }
        
        // Recursively check nested children
        if (child.children && child.children.length > 0) {
          if (this.hasActiveChild(child.children, currentPath)) {
            return true;
          }
        }
      }
      return false;
    },
    // Automatically expand menus when their children are active
    autoExpandActiveMenus() {
      this.$nextTick(() => {
        this.items.forEach((item, index) => {
          if (item.childstatus === false && this.isMenuItemActiveRecursive(item)) {
            // If the parent menu has active children, expand it
            if (!this.openMenus[index]) {
              // Use Vue.set or direct assignment for Vue 2/3 compatibility
              if (this.$set) {
                this.$set(this.openMenus, index, true);
              } else {
                this.openMenus[index] = true;
              }
            }
          }
        });
      });
    },
    goback(item) {
      if (item.mainstatus) {
        this.$router.push(item.route);
      } else if (globalThis.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push(item.route);
      }
    },
    updateDynamicTitle() {
      const documentTitle = this.$route?.query?.DocEdit === '1' ? '_AddMoreDoc' : '_ReplaceAllDoc';
      this.updateDynamicMenuTitle(['Vector', 'VectorManagement', 'UploadVector'], documentTitle);

      const negativeQuestionTitle = this.$route?.query?.id === undefined ? '_UploadNegativeQuestionSet' : 'Edit Negative Question Set';
      this.updateDynamicMenuTitle(['Validation', 'ValidationNegative'], negativeQuestionTitle);
    },
    truncateText(text) {
      const maxLength = 35; // กำหนดความยาวสูงสุดที่ต้องการ
      if (!text || text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    getCurrentPath() {
      return this.$route?.name || 
            this.$route?.path?.replace('/', '') || 
            'dashboard';
    },
    async AccessDenied() {
      this.$router.push(`/AccessDenied`);
    },
    focusInput(element) {
      this.$nextTick(() => { document.getElementById(element)?.focus(); })
    },

    // #region Drag & Drop functions
     handleDropForNone(event){
      event.preventDefault();
    },
    onDragLeaveFolder(leftFolderId) {
      if(this.isDroppingOnFolder == leftFolderId){
        return;
      }
      this.targetFolder = null;
      this.isDroppingOnFolder = null;
    },
    
    onDragOverFolder(event, folder) {
      event.preventDefault(); // จำเป็นต้องมี
      this.targetFolder = folder;
      if (!this.draggedItem) return;
      
      if (!this.draggedItem.sourceFolder || 
          this.draggedItem.sourceFolder.id !== folder.id) {
        this.isDroppingOnFolder = folder.id;
        // ระบุการดำเนินการ - copy แทน move
        event.dataTransfer.dropEffect = 'copy';
      }
    },
    onDragStart(evt, sourceFolder) {
      this.drag = true;
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
      // เก็บข้อมูลที่จำเป็นสำหรับการลาก
      const topic = sourceFolder 
        ? sourceFolder.topics[evt.oldIndex] 
        : this.topicsNotInFolders[evt.oldIndex];
        
      this.draggedItem = {
        index: evt.oldIndex,
        sourceFolder: sourceFolder,
        topic: topic
      };
      
      // เพิ่ม class เพื่อการแสดงผล CSS
      document.body.classList.add('dragging-topic');
    },
    onDragStartFromOutside(val) {
      this.isStartFromOutside = val;
    },
    onDragEnd() {
      this.handleDrop();
      this.drag = false;
      document.body.classList.remove('dragging-topic');
    },
    handleDrop() {
      try{
        if(!this.isStartFromOutside && this.targetToOutsideArea) {
          this.removeTopicFromFolderBypassDialog(this.draggedItem.sourceFolder.id, this.draggedItem.topic.topicID, this.draggedItem.index);
          this.targetToOutsideArea = false;
          return;
        }
        this.targetToOutsideArea = false;
        if (!this.draggedItem || !this.targetFolder) {
          return;
        }
        
        if(this.draggedItem.sourceFolder && this.targetFolder.id == this.draggedItem.sourceFolder.id) {
          return;
        }

        const topic = this.draggedItem.topic;
        
        this.isDroppingOnFolder = null;
        
        if (!this.draggedItem.sourceFolder) {
          this.addTopicToFolderAPI(this.targetFolder.id, topic.topicID);
        } 
        else if (this.draggedItem.sourceFolder && this.draggedItem.sourceFolder.id !== this.targetFolder.id) {
          this.moveTopicToFolderAPI(topic.topicID, this.draggedItem.sourceFolder.id, this.targetFolder.id);
        }
        
          setTimeout(() => {
            this.targetFolder.expanded = true;
          }, 500);
      }
      catch(e){
        console.log('Error in handleDrop:', e);
      }
    },
    onDragOverOutsideTopic(event) {
      // ป้องกัน default behavior
      event.preventDefault();
      console.log('Dragging over outside area');
      this.targetToOutsideArea = true;
      // ล้างค่า highlight และ target folder
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
    },
    onDragOverOutsideDragArea(event) {
      // ป้องกัน default behavior
      event.preventDefault();
      this.targetToOutsideArea = false;
      this.isDroppingOnFolder = null;
      this.targetFolder = null;
    },
    addTopicToFolderAPI(folderId, topicId) {
      const request = {
        folderID: folderId,
        topicID: topicId,
        userID: this.User_Id
      };
      
      this.$call.AddTopicToFolder(request, (response) => {
        if (response.status === 0) {
              
          this.recentlyUpdatedFolderId = folderId;
          this.folderUpdateStatus = 'success';
          
          const topic = this.topicsNotInFolders.find(t => t.topicID === topicId) || 
                        this.listTopic.find(t => t.topicID === topicId);
          
          if (topic) {
            const folderIndex = this.folders.findIndex(f => f.id === folderId);
            if (folderIndex !== -1) {
              if (!this.folders[folderIndex].topics) {
                this.$set(this.folders[folderIndex], 'topics', []);
              }
              this.folders[folderIndex].topics.push({
                topicID: topic.topicID,
                topicName: topic.topicName,
                topicModelID: topic.topicModelID || 1,
                topicModelID_long: topic.topicModelID_long || topic.topicID,
                keyTopic: topic.keyTopic || topic.topicID.toString(),
                status: false
              });
            }
          }
          
          setTimeout(() => {
            this.recentlyUpdatedFolderId = null;
            this.folderUpdateStatus = null;
          }, 2000);
        } else {
          console.error('Failed to add topic to folder:', response.message);
          this.recentlyUpdatedFolderId = folderId;
          this.folderUpdateStatus = 'error';
          
          setTimeout(() => {
            this.recentlyUpdatedFolderId = null;
            this.folderUpdateStatus = null;
          }, 2000);
        }
      }, (error) => {
          this.loadFolders();
        console.error('API error:', error);
        this.recentlyUpdatedFolderId = folderId;
        this.folderUpdateStatus = 'error';
        
        setTimeout(() => {
          this.recentlyUpdatedFolderId = null;
          this.folderUpdateStatus = null;
        }, 2000);
      });
    },
    moveTopicToFolderAPI(topicId, fromFolderId, toFolderId) {
      const request = {
        topicID: topicId,
        fromFolderID: fromFolderId,
        toFolderID: toFolderId,
        userID: this.User_Id
      };
      
      this.$call.MoveTopicToFolder(request, (response) => {
        if (response.status === 0) {
          this.showFolderUpdateStatus(toFolderId, 'success');
          this.moveTopicBetweenFolders(topicId, fromFolderId, toFolderId);
        } else {
          console.error('Failed to move topic between folders:', response.message);
          this.loadFolders();
          this.showFolderUpdateStatus(toFolderId, 'error');
        }
      }, (error) => {
        console.error('API error:', error);
        this.loadFolders();
        this.showFolderUpdateStatus(toFolderId, 'error');
      });
    },

    // #endregion
    // #region Folder functions
    RenameChat(item) {

      item.status = true;
      
      this.SetStatusKeyRename(false);
      this.$nextTick(() => {
        const refName = 'topicRef_' + item.topicID;
        if (this.$refs[refName]) {
            setTimeout(() => {
              const inputElement = document.querySelector(`input[name="topicRef_${item.topicID}"]`) || 
                                  document.querySelector(`.topic-name-input[ref="topicRef_${item.topicID}"] input`);
              if (inputElement) inputElement.focus();
            }, 50);
        }
      });
    },
    async waitForUserId() {
      return new Promise((resolve) => {
        const checkUserId = () => {
          if (this.User_Id && this.User_Id !== '') {
            if (this.isSnippet)
              resolve(this.User_Id_Show);
            else
              resolve(this.User_Id);
          } else {
            setTimeout(checkUserId, 500);
          }
        };
        checkUserId();
      });
    },
    highlightTopic(topic) {
      const activeTopicId = this.Log_History_TopicID;
      if (activeTopicId && activeTopicId === topic.topicID) {
        return 'highlighted-topic';
      }
      return '';
    },
    expandFolderWithActiveTopic() {
      const activeTopicId = this.Log_History_TopicID;

      if (!activeTopicId || activeTopicId === -1) return;

      // ค้นหาโฟลเดอร์ที่มี Topic ที่กำลังเปิดอยู่
      for (let folder of this.folders) {
        if (folder.topics && folder.topics.length > 0) {
          // ตรวจสอบว่า Topic ที่กำลังเปิดอยู่อยู่ในโฟลเดอร์นี้หรือไม่
          const foundTopic = folder.topics.some(topic => topic.topicID === activeTopicId);

          if (foundTopic) {
            // ขยายโฟลเดอร์ที่มี Topic ที่กำลังเปิดอยู่
            folder.expanded = true;
            break; // หยุดเมื่อพบโฟลเดอร์แล้ว
          }
        }
      }
    },
    async loadFolders() {
      try {
        if (this.isSnippet && !this.parameterURL.full) {
          this.flagLoadingFolders = false;
          return;
        }
        this.flagLoadingFolders = true;

        const userId = await this.waitForUserId();

        this.$call.GetFolders(userId, (response) => {
          if (response.status === 0) {
            this.folders = response.data.map(folder => ({
              id: folder.id,
              name: folder.folderName,
              expanded: false,
              edit: false,
              topics: folder.topics ? folder.topics : []
            }));

            this.expandFolderWithActiveTopic();
          } else {
            this.$swal.fire({
              icon: 'error',
              title: this.$t('folderLoadError'),
              text: response.message,
              showConfirmButton: true
            });
          }
          this.flagLoadingFolders = false;
        }, (error) => {
          console.error('Error loading folders:', error);
          this.flagLoadingFolders = false;
        });
      } catch (error) {
        console.error('Error in loadFolders:', error);
        this.flagLoadingFolders = false;
      }
    },
    toggleFolder(folder) {
      folder.expanded = !folder.expanded;
    },
    selectFolder(folderId) {
      if (this.moveToFolderDialog.isLoading || this.moveToFolderDialog.isSuccess) return;

      this.moveToFolderDialog.selectedFolderId = folderId;
    },
    isFolderSelected(folder) {
      return this.moveToFolderDialog.selectedFolderId === folder.id;
    },
    isFolderDisabled(folder) {
      return folder.id === this.moveToFolderDialog.currentFolderId;
    },
    newChat() {
      this.isTextToImage = false;
      try {
        if (typeof this.ResetTextToImageFlagF === 'function') {
          this.ResetTextToImageFlagF();
        } else {
          console.warn('Can not reset TextToImage flag');
        }
      } catch (error) {
        console.error(error);
        // reset helper unavailable or threw, keep existing warning
        console.warn('Can not reset TextToImage flag');
      }
      this.ModelFirst = "-";
      this.Click_History_List(-1, '...', this.ModelFirst, -1, null);
    },
    selectTopic(topic) {
      const parentTopic = this.listTopic.find(t => t.topicID === topic.topicID);
      if (parentTopic) {
        topic.topicModelID = parentTopic.topicModelID;
        topic.topicModelID_long = parentTopic.topicModelID_long;
        topic.llmid = parentTopic.llmid;
        this.isAllowLLMChange = topic.isAllowLLMChange;
        this.updateLastLLMID(topic.llmid);
      }
      this.Click_History_List(topic.topicID, topic.topicName, topic.topicModelID, topic.topicModelID_long, topic.keyTopic)
      this.SetLLMModel();
    },
    selectTopicOutside(topic) {
      this.updateLastLLMID(topic.llmid);
      this.isAllowLLMChange = topic.isAllowLLMChange;
      this.Click_History_List(topic.topicID, topic.topicName, topic.topicModelID, topic.topicModelID_long, topic.keyTopic)
      this.SetLLMModel();
    },
    SetLLMModel(){
      if (this.unwrapInjectedValue(this.isAllowLLMChange) !== true) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
        return;
      }

      const lastLLMID = this.unwrapInjectedValue(this.lastLLMID);
      const selectedModel = this.allLLMModel.find((model) => String(this.getLLMModelId(model)) === String(lastLLMID)) || null;
      this.updateSelectedLLMModel(selectedModel);
    },
    openCreateDialog() {
      this.folderDialogStatus = {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };

      this.folderDialog = {
        visible: true,
        isNew: true,
        id: Date.now(),
        name: ''
      };
    },
    // แทน startEditFolder เดิม
    openRenameDialog(folder, idx) {
      this.folderDialogStatus = {
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };

      this.folderDialog = {
        visible: true,
        isNew: false,
        id: folder.id,
        name: folder.name,
        idx
      };
    },
    closeFolderDialog() {
      this.folderDialog.visible = false;

      setTimeout(() => {
        this.folderDialogStatus = {
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: ''
        };
      }, 300);
    },
    confirmFolderDialog() {
      const { isNew, id, name, idx } = this.folderDialog;
      if (!name.trim()) return;

      this.folderDialogStatus.isLoading = true;
      this.folderDialogStatus.isSuccess = false;
      this.folderDialogStatus.isError = false;
      this.folderDialogStatus.errorMessage = '';

      if (isNew) {
        const folderRequest = {
          folderName: name,
          userID: this.User_Id,
          sortOrder: 0
        };

        this.$call.CreateFolder(folderRequest, (response) => {
          if (response.status === 0) {
            this.loadFolders();

            this.folderDialogStatus.isLoading = false;
            this.folderDialogStatus.isSuccess = true;

            setTimeout(() => {
              this.closeFolderDialog();
            }, 600);
          } else {
            // แสดงสถานะล้มเหลว
            this.folderDialogStatus.isLoading = false;
            this.folderDialogStatus.isError = true;
            this.folderDialogStatus.errorMessage = response.message || 'Failed to create folder';

            // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
            setTimeout(() => {
              this.folderDialogStatus.isError = false;
            }, 1000);
          }
        }, (error) => {
          console.error('Error creating folder:', error);

          // แสดงสถานะล้มเหลว
          this.folderDialogStatus.isLoading = false;
          this.folderDialogStatus.isError = true;
          this.folderDialogStatus.errorMessage = 'Network error occurred';

          // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
          setTimeout(() => {
            this.folderDialogStatus.isError = false;
          }, 1000);
        });
      } else {
        // แก้ไขโฟลเดอร์
        const folderUpdateRequest = {
          id: id,
          folderName: name,
          userID: this.User_Id
        };

        this.$call.UpdateFolder(folderUpdateRequest, (response) => {
          if (response.status === 0) {
            this.folders[idx].name = name;
            this.loadFolders();

            // แสดงสถานะสำเร็จ
            this.folderDialogStatus.isLoading = false;
            this.folderDialogStatus.isSuccess = true;

            // ปิด dialog หลังจากแสดงผลสำเร็จ
            setTimeout(() => {
              this.closeFolderDialog();
            }, 600);
          } else {
            // แสดงสถานะล้มเหลว
            this.folderDialogStatus.isLoading = false;
            this.folderDialogStatus.isError = true;
            this.folderDialogStatus.errorMessage = response.message || 'Failed to update folder';

            // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
            setTimeout(() => {
              this.folderDialogStatus.isError = false;
            }, 1000);
          }
        }, (error) => {
          console.error('Error updating folder:', error);

          // แสดงสถานะล้มเหลว
          this.folderDialogStatus.isLoading = false;
          this.folderDialogStatus.isError = true;
          this.folderDialogStatus.errorMessage = 'Network error occurred';

          // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
          setTimeout(() => {
            this.folderDialogStatus.isError = false;
          }, 1000);
        });
      }
    },
    createFolder() {
      this.openCreateDialog();
    },
    startEditFolder(folder, idx) {
      this.openRenameDialog(folder, idx);
    },
    saveFolderName(folder) {
      folder.edit = false;

      const folderUpdateRequest = {
        id: folder.id,
        folderName: folder.name,
        userID: this.User_Id
      };

      this.$call.UpdateFolder(folderUpdateRequest, (response) => {
        if (response.status !== 0) {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('folderSaveError'),
            text: response.message,
            showConfirmButton: true,
            customClass: {
              popup: 'rounded-popup'
            }
          });
        }
      }, (error) => {
        console.error('Error saving folder name:', error);
        this.$swal.fire({
          icon: 'error',
          title: this.$t('errorOccurred'),
          text: this.$t('folderSaveError'),
          showConfirmButton: true
        });
      });
    },

    openDeleteDialog(folder, idx) {
      this.pendingDeleteTopicIds = folder.topics ? folder.topics.map(topic => topic.topicID) : [];

      this.deleteFolderDialog = {
        visible: true,
        id: folder.id,
        idx,
        name: folder.name,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };
    },
    closeDeleteDialog() {
      this.pendingDeleteTopicIds = [];
      setTimeout(() => {
        this.deleteFolderDialog = {
          visible: false,
          id: null,
          idx: null,
          name: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: '',
          topics: []
        };
      }, 300);
    },
    confirmDeleteDialog() {
      if (this.deleteFolderDialog.isLoading || this.deleteFolderDialog.isSuccess) return;

      const { id, idx } = this.deleteFolderDialog;

      // เก็บค่า pendingDeleteTopicIds ไว้เช็คว่า topic ที่กำลังเปิดอยู่อยู่ใน folder นี้หรือไม่
      const pendingDeleteTopicIds = [...this.pendingDeleteTopicIds];
      const currentActiveTopicId = this.Log_History_TopicID;
      const needToCreateNewChat = pendingDeleteTopicIds.includes(currentActiveTopicId);

      this.deleteFolderDialog.isLoading = true;
      this.deleteFolderDialog.isSuccess = false;
      this.deleteFolderDialog.isError = false;
      this.deleteFolderDialog.errorMessage = '';

      setTimeout(() => {
        const deleteRequest = {
          folderid: id,
          userID: this.User_Id
        };

        this.$call.DeleteFolder(deleteRequest, (response) => {
          if (response.status === 0) {
            if (this.pendingDeleteTopicIds.length > 0) {
              this.listTopic = this.listTopic.filter(
                topic => !this.pendingDeleteTopicIds.includes(topic.topicID)
              );
            }
            this.folders.splice(idx, 1);
            this.pendingDeleteTopicIds = [];
            this.loadFolders();

            if (needToCreateNewChat) {
              setTimeout(() => {
                this.Click_History_List(-1, '...', this.ModelFirst, -1, null);
              }, 300);
            }

            // แสดงสถานะสำเร็จ
            this.deleteFolderDialog.isLoading = false;
            this.deleteFolderDialog.isSuccess = true;

            // ปิด dialog หลังจากแสดงผลสำเร็จ
            setTimeout(() => {
              this.closeDeleteDialog();
            }, 500);
          } else {
            // แสดงสถานะล้มเหลว
            this.deleteFolderDialog.isLoading = false;
            this.deleteFolderDialog.isError = true;
            this.deleteFolderDialog.errorMessage = response.message || 'Failed to delete folder';

            // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
            setTimeout(() => {
              this.deleteFolderDialog.isError = false;
            }, 1000);
          }
        }, (error) => {
          console.error('Error deleting folder:', error);

          // แสดงสถานะล้มเหลว
          this.deleteFolderDialog.isLoading = false;
          this.deleteFolderDialog.isError = true;
          this.deleteFolderDialog.errorMessage = 'Network error occurred';

          // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
          setTimeout(() => {
            this.deleteFolderDialog.isError = false;
          }, 1000);
        });
      }, 600); // หน่วงเวลาเพื่อให้เห็น animation การโหลด
    },
    deleteFolder(id, idx) {
      const deleteRequest = {
        folderid: id,
        userID: this.User_Id
      };

      this.$call.DeleteFolder(deleteRequest, (response) => {
        if (response.status === 0) {
          this.folders.splice(idx, 1);
          this.$swal.fire({
            icon: 'success',
            title: this.$t('folderDeleteSuccess'),
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              popup: 'rounded-popup'
            }
          });
          this.closeDeleteDialog();
          this.isDeleting = false;
        } else {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('folderDeleteError'),
            text: response.message,
            showConfirmButton: true,
            customClass: {
              popup: 'rounded-popup'
            }
          });
          this.closeDeleteDialog();
          this.isDeleting = false;
        }
      }, (error) => {
        console.error('Error deleting folder:', error);
        this.$swal.fire({
          icon: 'error',
          title: this.$t('errorOccurred'),
          text: this.$t('folderDeleteError'),
          showConfirmButton: true
        });
        this.closeDeleteDialog();
        this.isDeleting = false;
      });
    },
    addTopicToFolder(folderId, topic) {
      const request = {
        folderID: folderId,
        topicID: topic.topicID,
        userID: this.User_Id
      };

      this.$call.AddTopicToFolder(request, (response) => {
        if (response.status === 0) {
          // หาโฟลเดอร์และเพิ่มทอปิคเข้าไป
          const folderIndex = this.folders.findIndex(f => f.id === folderId);
          if (folderIndex !== -1) {
            if (!this.folders[folderIndex].topics) {
              this.folders[folderIndex].topics = [];
            }
            this.folders[folderIndex].topics.push({
              topicID: topic.topicID,
              topicName: topic.topicName,
              topicModelID: topic.topicModelID || 1,
              topicModelID_long: topic.topicModelID_long || topic.topicID,
              keyTopic: topic.keyTopic || topic.topicID.toString()
            });
          }

          this.$swal.fire({
            icon: 'success',
            title: this.$t('topicAddToFolderSuccess'),
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              popup: 'rounded-popup'
            }
          });
        } else {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('topicAddToFolderError'),
            text: response.message,
            showConfirmButton: true,
            customClass: {
              popup: 'rounded-popup'
            }
          });
        }
      }, (error) => {
        console.error('Error adding topic to folder:', error);
        this.$swal.fire({
          icon: 'error',
          title: this.$t('errorOccurred'),
          text: this.$t('topicAddToFolderError'),
          showConfirmButton: true
        });
      });
    },
    removeTopicFromFolder(folderId, topicId, topicIndex) {
      const folderIndex = this.folders.findIndex(f => f.id === folderId);
      let topicName = '';
      let folderName = '';

      if (folderIndex !== -1) {
        folderName = this.folders[folderIndex].name;
        if (this.folders[folderIndex].topics && this.folders[folderIndex].topics[topicIndex]) {
          topicName = this.folders[folderIndex].topics[topicIndex].topicName;
        }
      }

      // เปิด Dialog
      this.removeTopicDialog = {
        visible: true,
        folderId: folderId,
        topicId: topicId,
        topicIndex: topicIndex,
        topicName: topicName,
        folderName: folderName,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };
    },
    removeTopicFromFolderBypassDialog(folderId, topicId, topicIndex) {
      this.removeTopicDialog = {
        visible: false,
        folderId: folderId,
        topicId: topicId,
        topicIndex: topicIndex,
        topicName: '',
        folderName: '',
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };
      this.confirmRemoveTopic();
    },

    // เพิ่มเมธอดใหม่
    closeRemoveTopicDialog() {
      this.removeTopicDialog.visible = false;
      // รีเซ็ตค่าหลังจากปิด Dialog (ด้วย delay เล็กน้อย)
      setTimeout(() => {
        this.removeTopicDialog = {
          visible: false,
          folderId: null,
          topicId: null,
          topicIndex: null,
          topicName: '',
          folderName: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: ''
        };
      }, 300);
    },

    // เพิ่มเมธอดใหม่สำหรับการยืนยันการลบ
    confirmRemoveTopic() {
      if (this.removeTopicDialog.isLoading || this.removeTopicDialog.isSuccess) return;

      const { folderId, topicId, topicIndex } = this.removeTopicDialog;

      // เปลี่ยนสถานะเป็นกำลังโหลด
      this.removeTopicDialog.isLoading = true;
      this.removeTopicDialog.isSuccess = false;
      this.removeTopicDialog.isError = false;
      this.removeTopicDialog.errorMessage = '';

      // เรียกใช้ API (ทำงานเหมือนเดิม แต่ปรับปรุงการแสดงผล)
      const request = {
        folderID: folderId,
        topicID: topicId,
        userID: this.User_Id
      };

      // หน่วงเวลาเล็กน้อยเพื่อให้เห็น animation การโหลด
      setTimeout(() => {
        this.$call.RemoveTopicFromFolder(request, (response) => {
          if (response.status === 0 || response.success) {
            // หาโฟลเดอร์และลบทอปิค
            const folderIndex = this.folders.findIndex(f => f.id === folderId);
            if (folderIndex !== -1 && this.folders[folderIndex].topics) {
              // ดึงข้อมูล topic ก่อนลบเพื่อจะนำไปแสดงในรายการหลัก
              const removedTopic = { ...this.folders[folderIndex].topics[topicIndex] };

              // ลบออกจากโฟลเดอร์
              this.folders[folderIndex].topics.splice(topicIndex, 1);

              // นำข้อมูล topic ไปแสดงในรายการหลัก (ถ้ายังไม่มีข้อมูลอยู่แล้ว)
              const existingTopicIndex = this.listTopic.findIndex(t => t.topicID === topicId);
              if (existingTopicIndex === -1) {
                this.listTopic.unshift(removedTopic);
              }
            }

            // แสดงสถานะสำเร็จ
            this.removeTopicDialog.isLoading = false;
            this.removeTopicDialog.isSuccess = true;

            // ปิด dialog หลังจากแสดงผลสำเร็จ
            setTimeout(() => {
              this.closeRemoveTopicDialog();
            }, 600);
          } else {
            // แสดงสถานะล้มเหลว
            this.removeTopicDialog.isLoading = false;
            this.removeTopicDialog.isError = true;
            this.removeTopicDialog.errorMessage = response.message || 'Failed to remove topic from folder';

            // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
            setTimeout(() => {
              this.removeTopicDialog.isError = false;
            }, 1000);
          }
        }, (error) => {
          console.error('Error removing topic from folder:', error);

          // แสดงสถานะล้มเหลว
          this.removeTopicDialog.isLoading = false;
          this.removeTopicDialog.isError = true;
          this.removeTopicDialog.errorMessage = 'Network error occurred';

          // รีเซ็ตสถานะหลังจากแสดงข้อผิดพลาด
          setTimeout(() => {
            this.removeTopicDialog.isError = false;
          }, 1000);
        });
      }, 600); // หน่วงเวลาให้เห็น animation loading
    },
    openMoveToFolderDialog(topic) {
      // ค้นหาว่า topic นี้อยู่ในโฟลเดอร์ใดบ้าง
      let currentFolder = null;
      for (const folder of this.folders) {
        const topicIndex = folder.topics ? folder.topics.findIndex(t => t.topicID === topic.topicID) : -1;
        if (topicIndex !== -1) {
          currentFolder = folder;
          break;
        }
      }

      this.moveToFolderDialog = {
        visible: true,
        topicId: topic.topicID,
        topicName: topic.topicName,
        selectedFolderId: null,
        currentFolderId: currentFolder ? currentFolder.id : null
      };
    },

    closeMoveToFolderDialog() {
      this.moveToFolderDialog = {
        visible: false,
        topicId: null,
        topicName: '',
        selectedFolderId: null,
        currentFolderId: null,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };
    },

    confirmMoveToFolder() {
      if (this.moveToFolderDialog.isLoading || this.moveToFolderDialog.isSuccess) return;
      const { topicId, selectedFolderId, currentFolderId } = this.moveToFolderDialog;

      if (selectedFolderId && selectedFolderId !== currentFolderId) {
        this.setMoveToFolderDialogLoading();
        this.$nextTick(() => {
          if (currentFolderId) {
            this.moveExistingTopicFromDialog(topicId, currentFolderId, selectedFolderId);
          } else {
            this.addExistingTopicToDialog(topicId, selectedFolderId);
          }
        });
      }
    },

    // #endregion

    // #region Delete chat
    openDeleteTopicDialog(item) {
      let realindex = this.listTopic.findIndex(t => t.topicID === item.topicID);

      this.deleteTopicDialog = {
        visible: true,
        topicId: item.topicID,
        keyTopic: item.keyTopic,
        index: realindex,
        topicName: item.topicName,
        isLoading: false,
        isSuccess: false,
        isError: false,
        errorMessage: ''
      };
    },

    closeDeleteTopicDialog() {
      this.deleteTopicDialog.visible = false;

      setTimeout(() => {
        this.deleteTopicDialog = {
          visible: false,
          topicId: null,
          keyTopic: null,
          index: null,
          topicName: '',
          isLoading: false,
          isSuccess: false,
          isError: false,
          errorMessage: ''
        };
      }, 300);
    },

    confirmDeleteTopic() {
      if (this.deleteTopicDialog.isLoading || this.deleteTopicDialog.isSuccess) return;

      const { topicId, keyTopic, index } = this.deleteTopicDialog;

      this.deleteTopicDialog.isLoading = true;
      this.deleteTopicDialog.isSuccess = false;
      this.deleteTopicDialog.isError = false;

      setTimeout(() => {
        try {
          // ก่อนลบ topic ให้ตรวจสอบว่า topic นี้อยู่ใน folder ไหนบ้าง
          let folderContainingTopic = null;
          let topicIndexInFolder = -1;

          // ค้นหาทุก folder ที่มี topic นี้อยู่
          for (const folder of this.folders) {
            if (folder.topics && folder.topics.length > 0) {
              const foundIndex = folder.topics.findIndex(t => t.topicID === topicId);
              if (foundIndex !== -1) {
                folderContainingTopic = folder;
                topicIndexInFolder = foundIndex;
                break;
              }
            }
          }

          // เรียกใช้ฟังก์ชันลบ topic
          this.DeleteTopicStream(topicId, keyTopic, index);

          // ถ้าพบว่า topic อยู่ใน folder ให้ลบออกจาก folder ด้วย
          if (folderContainingTopic && topicIndexInFolder !== -1) {
            folderContainingTopic.topics.splice(topicIndexInFolder, 1);
          }

          // แสดงสถานะสำเร็จ
          this.deleteTopicDialog.isLoading = false;
          this.deleteTopicDialog.isSuccess = true;

          // ปิด dialog หลังจากเสร็จสิ้น
          setTimeout(() => {
            this.closeDeleteTopicDialog();
          }, 1500);
        } catch (error) {
          console.error('Error deleting topic:', error);
          this.deleteTopicDialog.isLoading = false;
          this.deleteTopicDialog.isError = true;
          this.deleteTopicDialog.errorMessage = 'Failed to delete chat';

          setTimeout(() => {
            this.deleteTopicDialog.isError = false;
          }, 3000);
        }
      }, 600);
    },
    // #endregion
    clearSelectedModel(event) {
      this.updateLastLLMID(null);
      this.updateSelectedLLMModel(null);
      if (this.listTopic) {
        this.IsAllowImage = this.listTopic.find(e => e.topicID == this.Log_History_TopicID).isAllowImage;
      }
      if (event?.stopPropagation) {
        event.stopPropagation();
      }
    },
    isActiveModel(item) {
      return this.TopicModelID === item.modelDisplayID;
    },
    selectModel(item) {
      this.Click_History_List(-1, item.modelName, item.modelDisplayID + ' (' + item.modelName + ')', item.modelID, null);
      this.Time_Delay = item.timeDelay;
      this.IsAllowImage = item.isAllowImage;
      this.maximumChatInput = item.maximumChatInput;
      this.IsChainMassage = item.isChainMassage;
      this.FileUploadLimit = item.fileUploadLimit;
      this.isAllowLLMChange = item.isAllowLLMChange;
      if (!item.isAllowLLMChange) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
      }
      this.showMenu = false;
    },
    toggleModelDropdown() {
      if (this.pathUrl == 'FullStream' && this.unwrapInjectedValue(this.isAllowLLMChange) !== true) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
        this.showModelDropdown = false;
        return;
      }

      this.showModelDropdownDialog = false;
      this.showModelDropdown = !this.showModelDropdown;
    },

    closeModelDropdown() {
      this.showModelDropdown = false;
    },
    toggleModelDropdownDialog() {
      if (this.pathUrl == 'FullStream' && this.unwrapInjectedValue(this.isAllowLLMChange) !== true) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
        return;
      }

      this.showModelDropdown = false;
      this.showModelDropdownDialog = true
    },

    closeModelDropdownDialog() {
      this.showModelDropdownDialog = false;
    },
    getModelsByProvider(providerId) {
      return this.allLLMModel.filter(model => {
        if (providerId === 'azure') {
          return model.platform == 'Azure'
        }
        else if (providerId === 'anthropic') {
          return model.platform == 'Anthropic'
        }
        else if (providerId === 'google') {
          return model.platform == "Google"
        }
        else if (providerId === 'others') {
          return model.platform == 'Other'
        }
        return false;
      });
    },
    SelectLLMMdel(model) {
      if (this.pathUrl == 'FullStream' && this.unwrapInjectedValue(this.isAllowLLMChange) !== true) {
        this.updateLastLLMID(null);
        this.updateSelectedLLMModel(null);
        return;
      }

      this.updateLastLLMID(this.getLLMModelId(model));
      this.updateSelectedLLMModel(model);
      this.showModelDropdown = false;
      this.showModelDropdownDialog = false;
      this.showMenu = false;
    },
    GetAllLLMModelData() {
      try {
        this.$call.GetAllLLMModelData(
          this.auth_token,
          (response) => {
            if (response.status === 0) {
              this.allLLMModel = response.data;
            } else {
              console.error('Failed to load models:', response.message || 'Unknown error');
            }
          },
          (error) => {
            console.error('Error loading models:', error);
          }
        );
      } catch (error) {
        console.error('Exception in GetAllModelData:', error);
      }
    },
    handleDrawerScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.isScrolled = scrollTop > 20;
    },
    sidebarClickHandle() {
      this.showSidebarTooltip = !this.showSidebarTooltip;
      this.drawerFull = !this.drawerFull;
    },
    setPathUrl() {
      // ลองหลายวิธีในการดึง route name
      const routeName = 
        this.$route?.name ||
        this.currentRoute?.name ||
        this.currentRouter?.currentRoute?.value?.name;

      if (routeName) {
        this.pathUrl = routeName;
        return true;
      }
      
      // ถ้าไม่มี name ลองใช้ path แทน
      const routePath = 
        this.$route?.path ||
        this.currentRoute?.path ||
        this.currentRouter?.currentRoute?.value?.path;
      
      if (routePath && routePath !== '/') {
        // แปลง path เป็น name (เอา / ออก)
        this.pathUrl = routePath.replace('/', '') || 'dashboard';
        return true;
      }
      
      return false;
    },
    async waitForRouter() {
      let attempts = 0;
      const maxAttempts = 15;

      while (attempts < maxAttempts) {
        if (this.$route?.name || this.$router?.currentRoute?.value?.name) {
          if (this.setPathUrl()) {
            return this.pathUrl;
          }
        }

        // รอ 100ms แล้วลองใหม่
        await new Promise((resolve) => setTimeout(resolve, 100));
        attempts++;
      }

      // ถ้ายังไม่ได้ ให้ใช้ค่า default
      if (!this.pathUrl) {
        this.pathUrl = "dashboard"; // หรือค่า default ที่เหมาะสม
        console.warn("Failed to get route name, using default");
      }
      return this.pathUrl;
    },
    async ManageMights() {
      const roleRights = this.getRightsForRole(this.roleId);
      if (!roleRights) {
        return;
      }

      this.applyRightsToItems(roleRights.rights, roleRights.includeChildren);
      this.applyRightsToProfile(roleRights.rights);
    },
    hasAdminRights(route) {
      if (!route) {
        return false;
      }
      const isProductAdminEnabled =
        import.meta.env.VITE_APP_ProductAdmin == "true" ||
        import.meta.env.VITE_APP_ProductAdmin == true; //NOSONAR
      if (isProductAdminEnabled) {
        if (
          route.meta &&
          route.meta.isProductAdmin
        ) {
          return true;
        }
        if (route.children) {
          return route.children.some((child) => this.hasAdminRights(child));
        }
        return route.path === "";
      } else {
        return true;
      }
    },
    setFullname() {
      this.fullName = Cookies.get("fullName");
    },
    profileImageSync() {
      let tempData = {
        userName: this.username,
        password: this.password,
      };
      axios.post(`${this.url}Login/Login`, tempData).then((response) => {
        this.imageUrl = response.data.data.pathImage;
      });
    },

    changeLocale(localeOrEvent, flag) {
      let locale, selectedFlag;
      
      // ตรวจสอบว่าเป็น object จาก UserProfileMenu component หรือไม่
      if (typeof localeOrEvent === 'object' && localeOrEvent.language && localeOrEvent.flag) {
        locale = localeOrEvent.language;
        selectedFlag = localeOrEvent.flag;
      } else {
        // เรียกแบบเดิมโดยส่ง parameters แยกกัน
        locale = localeOrEvent;
        selectedFlag = flag;
      }

      this.$i18n.locale = locale;
      this.currentflag = selectedFlag;
      i18n.locale = locale;
      localStorage.setItem("flag", selectedFlag);
      localStorage.setItem("locale", locale);
      store.state.languages = locale;
    },
    downloadLink() {
      try {
        this.$call.DownloadUserManual(
          (dataResponse) => {
            const { fileContents, contentType, fileDownloadName } =
              dataResponse.data;
            const blob = this.base64ToBlob(fileContents, contentType);
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
            globalThis.URL.revokeObjectURL(url);
            link.remove();
          },
          (errorResource) => {
            console.error(errorResource);
            this.$swal.fire({
              icon: "error",
              title: this.$t('fileNotFound'),
              text: this.$t('userManualNotFound'),
              showConfirmButton: true,
            });
          }
        );
      } catch (error) {
        console.error(error);
        // download failed, show fallback error dialog
        console.log("Error : File not found");
        this.$swal.fire({
          icon: "error",
          title: this.$t('fileNotFound'),
          text: this.$t('userManualNotFoundError'),
          showConfirmButton: true,
        });
      }
    },
    base64ToBlob(base64, mimeType = "") {
      const binaryStr = atob(base64);
      const len = binaryStr.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryStr.codePointAt(i);
      }
      return new Blob([bytes], { type: mimeType });
    },
    logout() {
      this.resetUnreadNotifications();
      this.unreadCount = 0;

      if (
        Cookies.get("roleId") == 0 ||
        Cookies.get("roleId") == 1 ||
        Cookies.get("roleId") == 6
      ) {
        signalRService.disconnect();
      }
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$call.Logout();
          sessionStorage.removeItem("token_Snippet");
          sessionStorage.removeItem("username_Snippet");
          sessionStorage.removeItem("email_Snippet");
          sessionStorage.removeItem("isSnippet");

          Cookies.remove("token_Snippet");
          Cookies.remove("username_Snippet");
          Cookies.remove("email_Snippet");
          Cookies.remove("isSnippet");
        })

        // eslint-disable-next-line no-console
        .catch((err) => console.log(err));
    },

    chatLogout() {
      this.resetUnreadNotifications();

      // self.$store
      //   .dispatch("logout")
      //   .then(() => {
      //     self.$call.ChatLogout()
      //     self.$parent.$parent.clearInfo();

      this.$swal
        .fire({
          icon: "success",
          title: this.$t('logoutSuccess'),
          showConfirmButton: false,
          timer: 1500,
        })
        .then(() => {
          // self.$nextTick(()=>{
          // Cookies.remove("token");
          // Cookies.remove("email");
          // Cookies.remove("username");
          // Cookies.remove("isSnippet");
          this.mini = true;
          this.User_Id = "";
          this.User_Id_Show = "";
          this.User_Id_Status = false;
          this.Snippet_Username = "";

          clearLineSsoSnippetStorage(Cookies);
          this.showBTNLogin = true;
          this.$router.replace({
            name: "LoginSnippet",
            params: { path: this.pathUrl },
            query: getQueryWithoutLineSso(this.$route.query),
          });
          //  });
        });
      // })
    },
    UserProfile() {
      this.$router.push("/userprofile");
    },
    substring(text) {
      return text;
    },
    homepage() {
      if (this.roleId == 0 || this.roleId == 1) {
        this.$router.push("/dashboard");
      } else {
        this.$router.push("/GPTModelManagement");
      }
    },
    Themecolor() {
      this.selectedColor = this.normalizeThemeColor(this.colorThemeChat, "#F7B34E");
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 20;
    },
    async LoadSnippetLoginStatus() {
      const domainName = this.parameterURL.domainname || sessionStorage.getItem("Domain") || "";
      const token = this.parameterURL.chk_token || this.parameterURL.auth_token || sessionStorage.getItem("tokenParam") || "";

      if (!domainName) {
        this.showBTNLogin = true;
        return;
      }

      await new Promise((resolve) => {
        this.$call.GetSnippetLoginStatus(
          { domainName, token },
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showBTNLogin = dataResponse.data !== false;
            } else {
              this.showBTNLogin = true;
            }
            resolve();
          },
          (errorResource) => {
            this.showBTNLogin = true;
            console.error(errorResource);
            resolve();
          }
        );
      });
    },
    async GetCheckAnonymous() {
      try {
        if (!this.showBTNLogin) {
          return;
        }
        if (
          (Cookies.get("token_Snippet") != null &&
            Cookies.get("username_Snippet") != null &&
            Cookies.get("email_Snippet") != null) ||
          (sessionStorage.getItem("token_Snippet") != null &&
            sessionStorage.getItem("username_Snippet") != null &&
            sessionStorage.getItem("email_Snippet") != null)
        ) {
          return;
        } else {
          this.$call.GetCheckAnonymous(
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data != "1") {
                  this.OpenTabLogin();
                }
              }
            },
            (errorResource) => {
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        console.error(error);
        // request failed, keep existing fallback handling
        console.log("catch : Get");
      }
    },
    async OpenTabLogin() {
      if (!this.showBTNLogin) {
        return;
      }
      this.LeftNavBar = false;
      this.showBTNLogin = false;
      this.mini = true;
      this.drawerFull = false;
      this.flagNav = true;
      if (this.$route.name != "LoginSnippet") {
        this.$router.push({
          name: "LoginSnippet",
          params: { path: this.pathUrl },
          query: this.$route.query,
        });
      }
    },
    GetConsent() {
      this.$call.GetConsentConfig(
        (dataResponse) => {
          if (dataResponse.status == 0 && dataResponse.data) {
            this.dataConsentTH = dataResponse.data.consentTH;
            this.dataConsentEN = dataResponse.data.consentEN;
            this.dataConsent = dataResponse.data.consentEN;
            this.dataVersion = dataResponse.data.showVersion;
            this.flagUpdateVersion = dataResponse.data.flagUpdateVersion;
          } else {
            this.dataConsentTH = "";
            this.dataConsentEN = "";
            this.dataConsent = "";
            this.dataVersion = "";
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async DisAgreeConsent() {
      try {
        // รอให้ router พร้อมก่อน
        if (!this.pathUrl) {
          await this.waitForRouter();
        }
        
        this.$call.Logout(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.$swal.fire({
                icon: "success",
                title: this.$t('logoutSuccess'),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.error('Error in DisAgreeConsent:', error);
      }
    },
    AgreeConsent() {
      let temp = {
        ConsentVersions: this.dataVersion,
      };
      this.$call.SaveAgreeConsent(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.consent_dialog = false;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    formatText(text) {
      return text
        .replaceAll('\n', "<br>")
        .replaceAll('\t', "&emsp;")
        .replaceAll(/ {2} /g, "&nbsp;&nbsp;");
    },
    TopicUnread(notifyOnIncrease = false) {
      this.$call.TopicUnread(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.updateTabSocialUnreadCounts(dataResponse.data, notifyOnIncrease);
          }
        },
        (errorResource) => {
          console.log("errorResource");
          console.error("Error: ", errorResource);
        }
      );
    },
    unlockAudio() {
      const sound = new Audio(this.sound);
      sound
        .play()
        .then(() => {
          this.audioUnlocked = true;
          localStorage.setItem("audioUnlocked", "true");
          console.log("Audio unlocked");
        })
        .catch((err) => {
          console.error("Error unlocking audio:", err);
        });
    },

    // เพิ่มฟังฝ์ชันสำหรับเปิด/ปิดเสียง
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      // บันทึฝฝารตั้งค่าลง localStorage เพื่อเฝ็บฝารตั้งค่าไว้
      localStorage.setItem("soundEnabled", this.soundEnabled);

      // แสดงข้อความแจ้งเตือนฝารเปลี่ยนสถานะ
      this.$swal.fire({
        icon: "success",
        title: this.soundEnabled
          ? this.$t("_InfoNotiOn")
          : this.$t("_InfoNotiOff"),
        showConfirmButton: false,
        timer: 1500,
      });
    },

    // ๝ฝ้ไขฝารเล่นเสียงใน TopicUnread เพื่อตรวจสอบสถานะฝารเปิดเสียง
    playNotificationSound() {
      if (this.soundEnabled) {
        let notificationSound = new Audio(this.sound);
        notificationSound.play().catch((err) => {
          console.error("Audio play error: ", err);
          // หาฝเฝิดข้อผิดพลาด ให้รีเซ็ตค่า audioUnlocked
          this.audioUnlocked = false;
          localStorage.setItem("audioUnlocked", "false");
        });
      }
    },
    localize(text) {
      return this.$t(text);
    },
    getPageTitle(){
      const currentRouteName = this.$route?.name || this.pathUrl;
      const currentPath = this.$route?.path || "";

      // Check if a menu item matches the current route
      const itemMatchesRoute = (menuItem) => {
        if (!menuItem) return false;

        const itemRoute = menuItem.route || "";
        const itemHref = menuItem.href || "";

        if (itemRoute && (itemRoute === currentPath || (itemRoute !== "/" && currentPath.startsWith(itemRoute + "/")))) {
          return true;
        }

        if (itemHref && itemHref === currentRouteName) {
          return true;
        }

        return false;
      };

      // Find deepest matching item and track module parent (first child of top-level)
      const findMatchWithModule = (menuItem, moduleParent = null, isTopLevel = true) => {
        if (!menuItem) return null;

        const currentMatches = itemMatchesRoute(menuItem);
        
        // Check children first (to get deepest match)
        if (Array.isArray(menuItem.children) && menuItem.children.length > 0) {
          for (const child of menuItem.children) {
            // If this is top-level, its first child becomes the module parent
            const newModuleParent = isTopLevel ? menuItem : moduleParent;
            const childMatch = findMatchWithModule(child, newModuleParent, false);
            if (childMatch) return childMatch;
          }
        }

        // If current item matches and no deeper child matched, return it with module info
        if (currentMatches) {
          return { match: menuItem, moduleParent };
        }

        return null;
      };

      // Search through top-level items
      for (const item of this.items) {
        const result = findMatchWithModule(item, null, true);
        if (result) {
          // Return module parent's title if exists, otherwise return match title
          const titleToShow = result.moduleParent ? result.moduleParent.title : result.match.title;
          return this.localize(titleToShow);
        }
      }

      if (this.breadcrumbsList && this.breadcrumbsList.length > 0) {
        if (this.breadcrumbsList.length > 1) {
          const lastBreadcrumb = this.breadcrumbsList[this.breadcrumbsList.length - 1];
          return this.localize(lastBreadcrumb.title);
        }
        const topBreadcrumb = this.breadcrumbsList[0];
        return this.localize(topBreadcrumb.title);
      }

      if (currentRouteName) {
        return this.localize(currentRouteName);
      }

      return this.localize("_Dashboard");
    }
  },
  async beforeMount() {
    // Reset state from the previous authenticated session before loading counts
    // for the user who just logged in.
    this.resetUnreadNotifications();
    this.unreadCount = 0;

    if (!this.pathUrl) {
      await this.waitForRouter();
    }
    try {
      await this.getStartUpImage();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    
    const roleId = Cookies.get("roleId");

    // Refresh independently of SignalR *connection state* (a reconnect can race
    // with logout/login), but keep the same role/path predicate the hub uses:
    // TopicUnread and GetChannelTabs are role 0/1/6 APIs and must not fire on Login/Snippet/FullStream.
    if (signalRService.shouldConnect(roleId, this.pathUrl)) {
      this.loadChannelTabs?.();
      this.TopicUnread();
    }

    // Use centralized SignalR service with role check
    signalRService.connect(roleId, this.pathUrl)
      .then((connection) => {
        if (connection) {
          // Register TopicUnread event handler
          signalRService.on("TopicUnread", "NavBar", () => {
            this.TopicUnread(true);
          });
        }
      })
      .catch((err) => console.log(err));
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    // Unregister NavBar's event handlers (don't disconnect - other components may use it)
    signalRService.offAll("NavBar");

    const drawerContent = document.querySelector(
      "#NavFullStream .v-navigation-drawer__content"
    );
    if (drawerContent) {
      drawerContent.removeEventListener("scroll", this.handleDrawerScroll);
    }
  },
  async mounted() {
    if (!this.pathUrl) {
      await this.waitForRouter();
    }
    this.updateDynamicTitle();
    if (
      this.pathUrl != "FullStream" &&
      this.pathUrl != "Snippet" &&
      this.pathUrl != "LoginSnippet" &&
      this.pathUrl != "Login"
    ) {
      this.GetConsent();
    }
    this.consent_dialog = true;

    this.queryID = store.state.groupSecurityID;
    window.addEventListener("scroll", this.handleScroll);
    await this.ManageMights();

    this.$nextTick(async () => {
      if (!this.pathUrl) {
        this.setPathUrl();
      }

      this.mini = false;
      this.syncParameterURLFromRouteQuery();

      await this.LoadSnippetLoginStatus();

      const currentPath = this.pathUrl || this.$route?.name || "dashboard";

      this.pathUrl = currentPath;
      this.initializeCurrentRouteState();
      this.show = true;
      this.isSnippet = this.parameterURL.snippet;
      await this.loadFolders();
    });
    // เริ่มต้นค่า openMenus ให้ทุกเมนูปิด
    this.items.forEach((item, index) => {
      this.openMenus[index] = false;
    });

    // Auto-expand menus if children are active on page load
    this.autoExpandActiveMenus();

    document.documentElement.style.setProperty(
      "--drawer-width",
      this.mini ? "0px" : "256px"
    );
  },
};
</script>

<style>
:root {
  --drawer-width: 0px;
}

/* Add this to your existing styles */
.v-content__wrap {
  padding-left: var(--drawer-width) !important;
  transition: padding-left 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

/* Set drawer transition for smooth animation */
#NavFullStream {
  transition: width 0.3s cubic-bezier(0.2, 0, 0.4, 1),
    transform 0.3s cubic-bezier(0.2, 0, 0.4, 1) !important;
}

/* Adjust the container width in FullStreamReDesign.vue */
.container-chat {
  width: calc(100% - var(--drawer-width)) !important;
  margin-left: var(--drawer-width) !important;
  transition: width 0.3s cubic-bezier(0.2, 0, 0.4, 1),
    margin-left 0.3s cubic-bezier(0.2, 0, 0.4, 1);
  grid-template-columns: 1fr !important;
}

#Fusion_toolbar_FullStream {
  background-size: unset !important;
  background-repeat: no-repeat !important;
}

#Fusion_Logo_FullStream,
#Fusion_Logo_Header,
#Fusion_Logo_FullStream_Mobile,
#Fusion_Logo_Sidebar {
  margin: auto;
  margin-left: 12px;
  margin-top: 0.2px;
}

.app {
  margin-left: 1rem;
  cursor: pointer;
}

.list {
  cursor: pointer;
}

.tooltip {
  position: relative;
  height: 45px;
  margin-bottom: 2rem;
}

.tooltip .tooltiptext {
  display: none;
}

.tooltip .tooltiptext2 {
  display: block;
}

.tooltip:hover .tooltiptext {
  display: block;
}

.tooltip:hover .tooltiptext2 {
  display: none;
}

#NavFullStream .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0);
}
</style>

<!-- #region style Snippet -->
<style>
#Nav_SnippetFull {
  position: fixed;
  width: 100%;
}

#Nav_SnippetFull .v-overlay {
  position: fixed;
}

#Toolbar_SnippetFull {
  background-size: unset !important;
  background-repeat: no-repeat !important;
  box-shadow: none !important;
  background-color: #ffffff;
  height: 62px !important;
}

#Toolbar_SnippetFull .v-toolbar__content {
  padding-left: 0px;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: #f0f0f7;
}

#Chat_Logo_SnippetFull {
  cursor: unset;
  margin: auto;
  margin-left: 12px;
  margin-top: 0.2px;
}

#NavSnippetFull .v-navigation-drawer__border {
  background-color: rgba(0, 0, 0, 0);
}

.scroll-to-top {
  transition: 0.2s ease !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.scroll-to-top-close {
  transition: 0.2s ease !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  opacity: 0;
}

.no-border-editor .ql-editor {
  border: none !important;
  box-shadow: none !important;
}

.no-border-editor .ql-container {
  border: none !important;
}

.floating-nav-button {
  position: fixed;
  top: 72px;
  left: 20px;
  z-index: 999;
}

.colored-icon {
  /* Adjust these values to achieve the desired color effect */
  filter: brightness(0) saturate(100%) invert(46%) sepia(6%) saturate(515%) hue-rotate(202deg) brightness(93%) contrast(84%) !important;
}

.no-border-editor {
  border: none !important;
  box-shadow: none !important;
  padding: 10px;
}

.no-border-editor .codex-editor__redactor {
  padding: 0 !important;
}

.no-border-editor .ce-block__content {
  max-width: 100% !important;
  margin: 0;
}

.no-border-editor .codex-editor {
  border: none !important;
}

.profile-info {
  display: flex;
  width: 100%;
  gap: 0px;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 12px;
}

.profile-name {
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  line-height: 1.2;
  max-width: 150px;        /* adjust depending on navbar layout */
  white-space: nowrap;     /* keeps the text on one line */
  overflow: hidden;        /* hides overflowing text */
  text-overflow: ellipsis; /* adds the ... */
  display: inline-block;   /* required for ellipsis to work properly */
  vertical-align: middle;
}

.role-chip {
  font-size: 12px !important;
}

.role-text {
  font-size: 11px;
}

.menu-item {
  border-radius: 8px;
  transition: background-color 0.2s ease;
  height: 44px;
  margin-bottom: 4px !important;
}

.menu-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.menu-title {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.01em;
}

.v-list-group__header {
  min-height: 44px !important;
  border-radius: 8px;
}

.v-list-group__header:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.submenu-item {
  min-height: 38px !important;
  padding-left: 12px !important;
  height: 40px !important;
  border-radius: 10px !important;
  transition: all 0.15s ease !important;
  margin: 4px 0 !important;
}

.submenu-title {
  font-size: 0.85rem !important;
  font-weight: 400 !important;
  color: rgba(0, 0, 0, 0.75);
  letter-spacing: 0.0125em;
  opacity: 1;
  transition: all 0.2s ease;
}

.submenu-icon {
  font-size: 18px !important;
  color: rgba(0, 0, 0, 0.6);
}

.menu-group .v-list-group__items {
  padding: 4px 0 4px 16px !important;
}

.v-list-item--active .submenu-title {
  color: #1976d2 !important;
  font-weight: 500;
}

.v-list-item--active .submenu-icon {
  color: #1976d2 !important;
}

.fixed-breadcrumbs {
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 5;
  background-color: white;
  padding-bottom: 0px;
}

.user-profile-button {
  border-radius: 40px !important;
  height: 40px !important;
  padding: 0 14px 0 2px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.user-profile-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15) !important;
}

.user-name {
  font-weight: 500;
  letter-spacing: 0.0125em;
  font-size: 0.9rem;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-menu-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.user-menu-header {
  background: linear-gradient(to right,
      rgba(240, 240, 245, 0.5),
      rgba(240, 240, 245, 0.1));
}

.menu-list-item {
  min-height: 40px !important;
  transition: background-color 0.15s ease, transform 0.15s ease !important;
}

.menu-list-item:hover {
  background-color: rgba(25, 118, 210, 0.08);
  transform: translateX(2px);
}

.menu-item-title {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

/* เพิ่ม styles สำหรับ divider */
.v-divider {
  border-color: rgba(0, 0, 0, 0.05) !important;
}

/* Enhance other nav buttons */
.v-btn.icon {
  border-radius: 12px !important;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.v-btn.icon:hover {
  transform: translateY(-1px);
  opacity: 0.95;
}

/* Tooltip enhancements */
.v-tooltip .v-overlay__content {
  background: rgba(33, 33, 33, 0.9) !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  padding: 6px 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.modern-menu {
  padding-top: 8px !important;
  background: transparent !important;
}

.menu-item,
.menu-group-header {
  border-radius: 12px !important;
  height: 44px !important;
  margin: 6px 0 !important;
  position: relative;
  transition: all 0.2s ease-in-out !important;
}

.menu-item::before,
.menu-group-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 12px;
  opacity: 0;
  background: linear-gradient(90deg,
      rgba(25, 118, 210, 0.05) 0%,
      rgba(25, 118, 210, 0.02) 100%);
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.menu-item:hover::before,
.menu-group-header:hover::before {
  opacity: 1;
}

.icon-container {
  transition: transform 0.2s ease;
  min-width: 24px;
  width: 24px;
}

.menu-item:hover .icon-container,
.menu-group-header:hover .icon-container {
  transform: translateY(-1px);
}

.menu-active {
  background: linear-gradient(90deg,
      #C32E0E 0%,
      #F67760 100%) !important;
}

/* migrated: avoid child combinator '>' */
.v-list-item--active .v-list-item__overlay {
  opacity: 0 !important;
}

.menu-active .menu-title,
.menu-active .icon-container .v-icon {
  color: white !important;
  font-weight: 600 !important;
  opacity: 1 !important;
}

/* Submenu styling */
.submenu-container {
  border-left: 1px dashed rgba(0, 0, 0, 0.1);
  margin-left: 12px !important;
  padding-left: 12px !important;
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.submenu-item:hover .submenu-title {
  transform: translateX(2px);
}

.submenu-active {
  background: linear-gradient(90deg,
      #C32E0E 0%,
      #F67760 100%) !important;
}

.submenu-active .submenu-title {
  color: #FFF !important;
  font-weight: 500 !important;
}

/* Group menu styling */
.menu-group-active .menu-group-header {
  background: linear-gradient(90deg,
      #C32E0E 0%,
      #F67760 100%) !important;
  border-radius: 10px !important;
}

.menu-group-active .menu-group-header .menu-title,
.menu-group-active .menu-group-header .icon-container .v-icon {
  color: white !important;
  font-weight: 600 !important;
  opacity: 1 !important;
}

.v-list-group--active>.v-list-group__header .v-icon {
  transform: rotate(90deg);
  color: var(--v-primary-base) !important;
}

.v-list-group__items {
  margin-bottom: 8px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Badge styling */
.v-badge__badge {
  font-size: 10px !important;
  min-width: 18px !important;
  height: 18px !important;
  font-weight: bold !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
}

.v-list-group--active>.v-list-group__items {
  margin-top: 4px !important;
}

#Fusion_nav_FullStream .v-navigation-drawer .v-list-group__items .v-list-item,
nav .modern-menu .v-list-group__items .v-list-item {
  padding-inline-start: 8px !important;
}

.icon-container .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  /* สีเทากลางแทนสีดำเข้ม */
  font-size: 20px !important;
  /* ลดขนาดไอคอนลงเล็กน้อย */
  opacity: 0.85;
  /* ลดความทึบลงเพื่อให้ดูนุ่มนวล */
  transition: all 0.2s ease;
  /* เพิ่ม transition ให้เคลื่อนไหวนุ่มนวล */
}


/* สีไอคอนเมื่อ active */
.v-list-group--active>.v-list-group__header .icon-container .v-icon {
  color: var(--v-primary-base) !important;
  opacity: 1;
}

.data-consent-text::-webkit-scrollbar {
  width: 10px;
  /* ปรับความกว้างของ scrollbar */
}

.data-consent-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* สีพื้นหลังของ track */
  border-radius: 10px;
}

.data-consent-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  /* สีของตัวเลื่อน (thumb) */
  border-radius: 10px;
}

.data-consent-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
  /* สีของตัวเลื่อนเมื่อ hover */
}

/* For Firefox */
.data-consent-text {
  scrollbar-width: thin;
  /* 'auto', 'thin', 'none' */
  scrollbar-color: #c1c1c1 #f1f1f1;
  /* thumb color track color */
}

.data-consent-text h1,
.data-consent-text h2,
.data-consent-text h3,
.data-consent-text h4,
.data-consent-text h5,
.data-consent-text h6 {
  all: revert !important;
}

.data-consent-text ul,
.data-consent-text ol {
  list-style: initial !important;
  /* ลองใช้ initial หรือ revert */
  padding-left: 20px !important;
  /* ค่ามาตรฐานของ browser */
  margin-left: 20px !important;
  /* หรือปรับตามความเหมาะสม */
  display: block !important;
  /* ตรวจสอบว่าไม่ได้ถูกตั้งเป็น flex หรือ inline */
}

.data-consent-text li {
  /* ใช้ selector ที่ครอบคลุมทั้ง ul li และ ol li */
  display: list-item !important;
  list-style-position: outside !important;
  /* ลองเพิ่ม property นี้ */
  list-style-type: inherit !important;
  /* ให้ li รับค่า style type จาก ul/ol แม่ */
  margin-bottom: 0.3em;
  /* เว้นระยะห่างระหว่างรายการ (ถ้าต้องการ) */
  padding-left: 0 !important;
  /* ป้องกัน padding ที่ไม่ต้องการใน li */
  text-indent: 0 !important;
  /* ป้องกันการเยื้องที่ไม่ต้องการ */
}

/* หาก inherit ไม่ทำงาน ลองกำหนดโดยตรง */
.data-consent-text ul>li {
  list-style-type: disc !important;
  /* หรือ circle, square */
}

.data-consent-text ol>li {
  list-style-type: decimal !important;
  /* หรือ lower-alpha, upper-roman */
}
</style>
<!-- #endregion -->

<style scoped>
.drawer-header-sticky {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  height: 60px !important;
  display: flex !important;
  justify-content: flex-end !important;
  margin: -20px -12px 0px 0px !important;
  transition: all 0.3s ease !important;

  /* Base background */
  background: rgb(236, 240, 244) !important;
}

.drawer-header-sticky.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
  background: rgba(236, 240, 244, .95) !important;
}

.new-chat-fab {
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  box-sizing: content-box;
  opacity: 1 !important;
  width: 22px !important;
  height: 22px !important;
  margin-top: 8px !important;
  border-radius: 12px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: none !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.new-chat-fab:hover {
  transform: scale(1.1) !important;
}

.user-id-badge {
  display: flex;
  align-items: center;
  border-radius: 12px;
  padding: 5px 6px;
}

.user-id-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 8px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.user-id-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.user-id-label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
  font-weight: 500;
}

.user-id-value {
  font-size: 12px;
  color: #1e293b;
  font-weight: 600;
  line-height: 1.2;
  margin-top: 2px;
  line-break: anywhere;
  max-width: 160px;
}

.topic-list-item {
  padding: 0 0 6px 0;
}

.topic-item {
  width: 100%;
  background-color: white;
  border-radius: 14px;
  padding: 3px 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 45px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.topic-item:hover {
  background-color: #f8fafc;
  transform: translateY(-1px);
}

.topic-item--editing {
  width: 100%;
  background-color: #f8fafc;
  cursor: default;
}

.topic-item--clickable {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
}


.topic-item--clickable:active {
  transform: translateY(0);
}

.topic-icon-wrapper {
  flex-shrink: 0;
  opacity: 0.7;
}

.topic-content {
  min-width: 0;
}

.topic-title-wrapper {
  width: 100%;
}

.topic-title {
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  line-height: 1.3;
  display: block;
}

.topic-menu-button {
  border-radius: 50% !important;
  transition: opacity 0.2s ease, background-color 0.2s ease;
  width: 30px !important;
  height: 30px !important;
}

.topic-menu-button:hover {
  opacity: 1 !important;
  background-color: rgba(255, 145, 0, 0.2);
}

.Cls_Text_field_TopicName :deep(.v-input__control) {
  width: 100% !important;
}

/* Menu items */
.v-list-item.text-error:hover {
  background-color: rgba(244, 67, 54, 0.04);
}

/* Scroll container */
.topic-scroll-container {
  padding: 4px 0;
}

.time-delay-input {
  background: white;
  border-radius: 12px;
}

.time-delay-input .v-field {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.time-delay-input:hover .v-field {
  border-color: rgba(25, 118, 210, 0.3);
}

.time-delay-input.v-field--focused .v-field {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.floating-nav-button-div {
  position: fixed;
  top: 70px;
  z-index: 999;
  width: 40px;
  height: 40px;
  margin-right: -8px !important;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.floating-nav-llm-trigger {
  width: auto;
  min-width: 156px;
  max-width: 220px;
  height: 40px;
  padding: 0 12px;
  gap: 6px;
  justify-content: space-between;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  margin-right: 0 !important;
}

.floating-nav-button-div:hover {
  background: rgba(0, 0, 0, 0.05);
}

.floating-nav-llm-trigger:hover {
  background: #ffffff;
  border-color: rgba(15, 23, 42, 0.1);
}

.floating-nav-button-div:active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.fullstream-mobile-sidebar-btn {
  margin-left: 10px !important;
  z-index: 5000 !important;
}

.fullstream-nav-icon,
.fullstream-topic-action-icon {
  width: 22px;
  height: 22px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.fullstream-topic-action-icon {
  width: 20px;
  height: 20px;
}

.fullstream-folder-list-icon,
.fullstream-topic-list-icon {
  transition: color 0.2s ease, opacity 0.2s ease, transform 0.2s ease;
}

.fullstream-topic-list-icon {
  width: 16px;
  height: 16px;
}

.folder-view:hover .fullstream-folder-list-icon,
.topic-item:hover .fullstream-topic-list-icon {
  transform: translateY(-1px);
}

.floating-nav-button-div:hover .fullstream-nav-icon,
.new-chat-fab:hover .fullstream-nav-icon,
.new-chat-fab:hover .fullstream-topic-action-icon {
  transform: translateY(-1px);
}

.floating-nav-dropdown {
  position: fixed;
  top: 70px;
  z-index: 999;
  width: 40px;
  height: 40px;
  margin-right: -8px !important;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.consent-dialog :deep(.v-overlay__content) {
  border-radius: 16px;
  overflow: hidden;
  animation: slideUp 0.3s ease-out;
}

.consent-card {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid #e0e0e0 !important;
  background: white !important;
}

.consent-header {
  background: white;
  color: #000000;
  padding: 15px;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
}

.consent-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1.5" fill="rgba(255,255,255,0.08)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/></svg>'); 
  opacity: 0.3;
}

.header-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
}
.header-text {
  flex: 1;
}
.header-icon {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(10px);
}

.consent-title {
  font-size: 22px;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
  color: #000000;
  letter-spacing: -0.3px;
}

.consent-subtitle {
  font-size: 13px;
  opacity: 1;
  margin: 6px 0 0 0;
  font-weight: 400;
  color: #646464;
}

.version-language-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  background: white;
}

.version-info :deep(.v-chip) {
  font-weight: 500;
  font-size: 11px;
  height: 24px;
  border-radius: 4px;
}


.language-toggle {
  border-radius: 16px !important;
  overflow: hidden;
  border: 1px solid #e0e0e0 !important;
  background: white;
  padding: 8px;
  height: 50px!important;
}

.language-btn {
  border-radius: 16px !important;
  transition: all 0.2s ease;
  font-weight: 600!important;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0;
  border: none !important;
  min-width: 100px;
}


.language-btn:hover {
  background-color: rgba(25, 118, 210, 0.08);
}
.v-btn-group .v-btn--active {
  border-radius: 12px;
  background: var(--Blue-bg, #EFF4FF);
  color: #3859D0 !important;
}
.consent-content {
  padding: 0 !important;
}

.content-wrapper {
  padding: 10px 32px 10px 32px;
}

.content-scroll-area {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px;
  background: white;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 22px 0 rgba(0, 0, 0, 0.16);
}

.consent-text-content {
  font-size: 15px;
  line-height: 1.6;
  color: #374151;
}

/* Enhanced scrollbar */
.content-scroll-area::-webkit-scrollbar {
  width: 8px;
}

.content-scroll-area::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.content-scroll-area::-webkit-scrollbar-thumb {
  background: #C9C9C9;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.content-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #C9C9C9;
}

.consent-actions {
  padding: 24px 32px;
  background: white;
  gap: 16px;
}

.consent-action-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.25px !important;
  min-width: 140px !important;
  height: 48px !important;
  transition: all 0.2s ease !important;
}

.decline-btn {
  border-width: 2px !important;
}

.decline-btn:hover {
  background-color: rgba(244, 67, 54, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.2);
}

.accept-btn {
  color: white !important;
  border-radius: 16px;
  background: var(--btn-bg, linear-gradient(90deg, #C32E0E 0%, #F67760 100%));
  text-transform: none !important;
}

.accept-btn:hover {
  transform: translateY(-1px);
  border-radius: 16px;
  background: var(--tab-gradient-bg, linear-gradient(90deg, #F36243 0%, #FF8E7A 100%));
}

.accept-btn:active {
  transform: translateY(0);
}

/* Content styling enhancements */
.consent-text-content :deep(h1),
.consent-text-content :deep(h2),
.consent-text-content :deep(h3),
.consent-text-content :deep(h4),
.consent-text-content :deep(h5),
.consent-text-content :deep(h6) {
  color: #1f2937;
  margin-top: 24px;
  margin-bottom: 12px;
  font-weight: 600;
}

.consent-text-content h1 {
  font-size: 24px;
}

.consent-text-content h2 {
  font-size: 20px;
}

.consent-text-content h3 {
  font-size: 18px;
}

.consent-text-content p {
  margin-bottom: 16px;
  color: #374151;
}

.consent-text-content :deep(ul),
.consent-text-content :deep(ol) {
  margin: 16px 0 !important;
  padding-left: 32px !important;
}

.consent-text-content li {
  margin-bottom: 8px;
  color: #4b5563;
}

.consent-text-content strong {
  color: #1f2937;
  font-weight: 600;
}

/* Responsive design */
@media (max-width: 768px) {
  .consent-card {
    margin: 16px;
    border-radius: 16px !important;
  }

  .consent-header {
    padding: 20px 24px;
  }

  .consent-title {
    font-size: 20px;
  }

  .version-language-section {
    flex-direction: column;
    gap: 16px;
    padding: 16px 24px;
    text-align: center;
  }

  .content-wrapper {
    padding: 24px;
  }

  .consent-actions {
    flex-direction: column;
    gap: 12px;
    padding: 20px 24px;
  }

  .action-btn {
    width: 100% !important;
  }
}

/* Animation for dialog entrance */
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 100;
  border-radius: 8px;
  animation: dropdownFadeIn 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
}

.custom-dropdown-menu--modern {
  border-radius: 14px;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
}

.custom-model-card {
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
  min-width: 320px;
  max-width: 460px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.custom-model-card--modern {
  min-width: 360px;
  max-width: 480px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: #ffffff;
}

.custom-model-header {
  padding: 12px 16px 8px;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.75);
}

.custom-model-header--modern {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px 12px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.85);
}

.llm-model-card-icon,
.llm-model-dropdown-icon,
.llm-model-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.llm-model-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  color: var(--llm-accent-color);
  background: color-mix(in srgb, var(--llm-accent-color) 12%, white);
}

.llm-model-card-icon svg {
  width: 18px;
  height: 18px;
}

.llm-model-card-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.llm-model-card-title span {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.llm-model-card-title small {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
}

.custom-model-content {
  padding: 0 12px 8px;
  overflow-y: auto; 
  overflow-x: hidden; 
  max-height: calc(100vh - 250px); 
  scrollbar-width: thin; 
  scrollbar-color: #888 #f1f1f1;
}

/* Minimal Expansion Panels */
.minimal-panels {
  box-shadow: none !important;
  background-color: transparent !important;
}

.minimal-panel {
  margin-bottom: 4px !important;
  background-color: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 6px !important;
  overflow: hidden;
}

.custom-model-card--modern .minimal-panel {
  margin: 8px 0 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  border-radius: 12px !important;
  background: #f8fafc !important;
}

.minimal-panel:before {
  box-shadow: none !important;
}

.minimal-header {
  padding: 0 12px !important;
  min-height: 40px !important;
}

.custom-model-card--modern .minimal-header {
  min-height: 46px !important;
}

.provider-name {
  font-weight: 500;
  font-size: 14px;
}

.minimal-chip {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
}

.minimal-content {
  padding: 0 !important;
}

.minimal-list {
  padding: 0 !important;
  background-color: transparent !important;
}

.minimal-list-item {
  border-radius: 4px !important;
  min-height: 40px !important;
  margin: 4px 0 !important;
  padding-left: 12px !important;
  transition: background-color 0.2s;
}

.custom-model-card--modern .minimal-list-item {
  min-height: 52px !important;
  margin: 6px 0 !important;
  border-radius: 10px !important;
  padding-left: 10px !important;
}

.minimal-list-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.selected-model {
  background-color: rgba(var(--v-primary-base), 0.05) !important;
}

.custom-model-card--modern .selected-model {
  background: color-mix(in srgb, var(--llm-accent-color) 10%, white) !important;
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--llm-accent-color) 28%, white);
}

.llm-model-item-icon {
  width: 28px;
  height: 28px;
  border-radius: 9px;
  background: #ffffff;
  margin-right: 10px;
}

.llm-model-item-icon svg,
.llm-selected-check {
  width: 15px;
  height: 15px;
}

.llm-selected-check {
  color: var(--llm-accent-color);
}

/* Dropdown Trigger */
.model-dropdown-mobile {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 32px;
}
.model-dropdown {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 6px;
  background-color: rgb(245, 245, 245);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: border-color 0.2s;
  height: 32px;
}

.llm-model-dropdown-modern {
  min-width: 220px;
  max-width: 320px;
  height: 40px;
  padding: 5px 8px 5px 10px;
  gap: 8px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.38);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

.model-dropdown:hover {
  background-color: rgb(245, 245, 245);
}

.sidebar-llm-selector {
  position: relative;
}

.floating-llm-menu-card {
  min-width: 320px;
  max-width: 400px;
  max-height: 500px;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  border: 1px solid rgba(148, 163, 184, 0.18);
  overflow: hidden;
}

.floating-llm-menu-card .custom-model-content {
  max-height: calc(400px - 56px);
  flex: 1;
  min-height: 0;
}

.sidebar-llm-selector .dropdown-container {
  position: relative;
  width: 100%;
}

.sidebar-llm-selector .model-dropdown {
  min-width: 0;
  max-width: 100%;
  width: 100%;
  justify-content: space-between;
}

.sidebar-llm-selector .model-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar-llm-selector .custom-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 8px;
  right: 8px;
  z-index: 200;
}

.sidebar-llm-selector .custom-model-card {
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.sidebar-llm-selector .custom-model-content {
  max-height: calc(100vh - 320px);
}

.llm-model-dropdown-modern:hover {
  background: color-mix(in srgb, var(--llm-accent-color) 8%, white);
  border-color: color-mix(in srgb, var(--llm-accent-color) 36%, white);
}

.llm-model-dropdown-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: var(--llm-accent-color);
  background: color-mix(in srgb, var(--llm-accent-color) 12%, white);
  flex-shrink: 0;
}

.llm-model-dropdown-icon svg,
.llm-clear-icon,
.llm-chevron-icon {
  width: 16px;
  height: 16px;
}

.llm-chevron-icon {
  color: #64748b;
  flex-shrink: 0;
}

.model-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.8);
}

.llm-model-name-modern {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #111827;
  flex: 1;
}

.floating-nav-llm-trigger .llm-model-name-modern {
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
}

.floating-nav-llm-trigger .llm-chevron-icon {
  color: #71717a;
}

.clear-model-btn {
  opacity: 0.7;
  transition: all 0.2s ease;
  margin-right: 2px;
  background-color: transparent !important;
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
}

.llm-model-dropdown-modern .clear-model-btn {
  color: #64748b;
  margin-left: 0 !important;
  margin-right: 0;
}

.clear-model-btn:hover {
  opacity: 1;
  transform: scale(1.1);
}

.model-avatar {
  background-color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* LLM Dialog Version 2 Styles */
.llm-nav-dropdown-v2 {
  position: fixed;
  top: 70px;
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.2, 0, 0.4, 1);
}

.llm-model-selector-v2 {
  width: auto;
}

.llm-dropdown-container-v2 {
  position: relative;
}

.llm-model-activator-v2 {
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
  min-height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.llm-model-activator-v2:hover {
  background-color: rgba(255, 255, 255, 1);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.llm-model-display-name-v2 {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.llm-clear-btn-v2 {
  opacity: 0.7;
  transition: all 0.2s ease;
  background-color: transparent !important;
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
}

.llm-clear-btn-v2:hover {
  opacity: 1;
  transform: scale(1.1);
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.llm-dialog-card-v2 {
  border-radius: 16px !important;
  overflow: hidden;
  min-width: 450px;
  max-width: 550px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.llm-dialog-header-v2 {
  background: linear-gradient(135deg, #e6f2ff 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 18px 24px !important;
  font-size: 1.2rem !important;
  font-weight: 600;
  color: #1e293b;
}

.llm-dialog-content-v2 {
  padding: 20px 24px !important;
  max-height: 65vh;
  overflow-y: auto;
}

.llm-panels-v2 {
  box-shadow: none !important;
  background-color: transparent !important;
}

.llm-panel-item-v2 {
  margin-bottom: 8px !important;
  background-color: #f8fafc !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.2s ease;
}

.llm-panel-item-v2:hover {
  background-color: #f1f5f9 !important;
  border-color: rgba(25, 118, 210, 0.2) !important;
}

.llm-panel-item-v2:before {
  box-shadow: none !important;
}

.llm-panel-header-v2 {
  padding: 0 16px !important;
  min-height: 44px !important;
  background-color: transparent !important;
}

.llm-provider-name-v2 {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
}

.llm-count-chip-v2 {
  font-size: 11px !important;
  height: 20px !important;
  font-weight: 600;
  border-radius: 10px !important;
}

.llm-panel-content-v2 {
  padding: 0 !important;
  background-color: white !important;
}

.llm-model-list-v2 {
  padding: 8px !important;
  background-color: transparent !important;
}

.llm-model-item-v2 {
  border-radius: 8px !important;
  min-height: 44px !important;
  margin: 2px 0 !important;
  padding: 8px 16px !important;
  transition: all 0.2s ease;
  cursor: pointer;
}

.llm-model-item-v2:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.llm-model-selected-v2 {
  background-color: rgba(25, 118, 210, 0.08) !important;
  border-left: 3px solid var(--v-primary-base) !important;
}

.llm-model-selected-v2:hover {
  background-color: rgba(25, 118, 210, 0.12) !important;
}

/* Dialog transition */
.dialog-transition-enter-active,
.dialog-transition-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dialog-transition-enter-from {
  opacity: 0;
  transform: scale(0.9);
}

.dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* Enhanced scrollbar for dialog content */
.llm-dialog-content-v2::-webkit-scrollbar {
  width: 6px;
}

.llm-dialog-content-v2::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.llm-dialog-content-v2::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.llm-dialog-content-v2::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .llm-dialog-card-v2 {
    margin: 16px;
    min-width: 320px;
    max-width: calc(100vw - 32px);
  }

  .llm-dialog-header-v2 {
    padding: 16px 20px !important;
    font-size: 1.1rem !important;

  }

  .llm-dialog-content-v2 {
    padding: 16px 20px !important;
  }
}


.folder-list-container {
  max-width: 250px;
  background-color: transparent !important;
  max-height: none !important;
  overflow-y: visible !important;
  padding: 10px;
}

.folder-dialog-wrapper {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}

.folder-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.folder-icon-animation {
  animation: bounceIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes bounceIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  60% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.slide-y-transition-enter-active,
.slide-y-transition-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  pointer-events: none;
}

.slide-y-transition-enter,
.slide-y-transition-leave-to {
  opacity: 0;
  transform: translateY(-20px) !important;
}

.dialog-title {
  background-color: #f8f9fa;
  padding: 16px 24px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.dialog-title .headline {
  font-size: 18px !important;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.dialog-content {
  padding: 24px !important;
}

.dialog-content .v-text-field {
  margin-top: 8px;
}

.dialog-actions {
  padding: 8px 24px 16px !important;
}

.dialog-actions .v-btn {
  width: 120px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.25px;
}

.cancel-btn {
  color: rgba(0, 0, 0, 0.6) !important;
  font-weight: 500;
}

.cancel-btn:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.save-btn {
  margin-left: 8px !important;
  min-width: 100px !important;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}
.save-btn:hover {
  box-shadow: none !important;
}

.save-btn:disabled {
  opacity: 0.5;
}

.folder-selector-container {
  max-height: 300px;
  overflow-y: auto;
  margin: 8px 0;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.folder-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #fff;
  position: relative;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.folder-option:last-child {
  border-bottom: none;
}

.folder-option:hover:not(.folder-option-disabled) {
  background-color: rgba(0, 0, 0, 0.03);
}

.folder-option-selected {
  background-color: rgba(250, 169, 27, 0.08) !important;
  border-left: 3px solid var(--v-primary-base, #faa91b);
}

.folder-option-disabled {
  opacity: 0.6;
  background-color: rgba(0, 0, 0, 0.02);
}

.folder-option-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.folder-option-selected .folder-option-icon {
  background-color: rgba(250, 169, 27, 0.15);
  transform: scale(1.1);
}

.folder-option-content {
  flex: 1;
}

.folder-option-name {
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
}

.folder-option-info {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.folder-option-action {
  margin-left: 8px;
}

.delete-folder-dialog {
  transition: all 0.3s ease;
}

.folder-name-active {
  font-weight: 500;
}

.dialog-header {
  padding: 20px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.dialog-header .title {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.folder-name-delete {
  display: inline-block;
}

@keyframes pulse {
  0% {
    background-color: rgba(244, 67, 54, 0.03);
  }

  100% {
    background-color: rgba(244, 67, 54, 0.1);
  }
}

.warning-text {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
}

.hint-text {
  font-size: 13px;
  color: #666666;
  background-color: #f7f7f7;
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid #FFB74D;
}

.delete-btn {
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.25px;
  padding: 0 16px;
  min-width: 140px !important;
  width: auto !important;
  transition: all 0.3s ease;
}

.delete-btn .d-flex {
  width: 100%;
  justify-content: center;
}

.delete-btn .v-btn__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rounded-popup {
  border-radius: 18px !important;
}

.empty-folder-state {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin: 8px 0;
  height: 40px;
}

.empty-folder-text {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  margin: 0;
  margin-bottom: 8px;
}

.folder-view-content {
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 14px;
  color: #71717A;
  overflow: hidden;
  width: 100%;
}

.folder-view-content .folder-name {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.folder-view-content > .v-menu {
  margin-left: auto;
  flex: 0 0 auto;
}
.folder-menu-btn {
  margin-right: -10px;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.folder-menu-btn:hover {
  transform: rotate(90deg);
  background-color: rgba(250, 169, 27, 0.1) !important;
}

.folder-menu-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
}

.folder-menu-card {
  width: 150px !important;
  padding: 3px;
  border-radius: 12px !important;
  border: none !important;
  overflow: hidden;
}

.folder-menu-list {
  padding: 4px !important;
}

.folder-menu-item {
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
}

.folder-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.folder-menu-item .v-list-item__icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 36px !important;
}

.v-list-item-icon {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 100% !important;
}

.v-icon {
  vertical-align: middle !important;
}

/* #region topic menu */

.topic-menu-container {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1) !important;
}

.topic-menu-card {
  border-radius: 12px !important;
  padding: 3px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.14) !important;
  border: none !important;
  overflow: hidden;
}

.topic-menu-list {
  padding: 4px !important;
}

.topic-menu-item {
  display: flex;
  padding-left: 18px !important;
  border-radius: 8px !important;
  min-height: 40px !important;
  transition: background-color 0.2s ease;
}

.topic-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.topic-menu-item .v-list-item__icon {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 36px !important;
}

@keyframes iconPop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.topic-menu-item .v-icon {
  animation: iconPop 0.3s ease forwards;
}

.v-ripple__container {
  opacity: 0.1 !important;
  border-radius: 8px !important;
}

.topic-menu-list .v-divider {
  margin: 4px 0 !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.topic-menu-item:active .v-icon.error--text {
  animation: deleteShake 0.4s ease;
}

@keyframes deleteShake {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-4px);
  }

  40% {
    transform: translateX(4px);
  }

  60% {
    transform: translateX(-2px);
  }

  80% {
    transform: translateX(2px);
  }

  100% {
    transform: translateX(0);
  }
}

/* #endregion */
/* #region move folder anim */
.move-folder-dialog {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease;
}

.move-icon {
  animation: moveIconAnimation .5s ease-in-out;
}

@keyframes moveIconAnimation {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.topic-highlight {
  font-weight: 500;
  color: var(--v-primary-base, #faa91b);
  border-bottom: 1px dashed var(--v-primary-base, #faa91b);
  padding-bottom: 2px;
}

.folder-option::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: rgba(250, 169, 27, 0.08);
  z-index: -1;
  transition: width 0.3s ease;
}

.folder-option-selected::after {
  width: 100%;
}

.folder-option:hover::after {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.03);
}

.folder-option-selected:hover::after {
  background-color: rgba(250, 169, 27, 0.12);
}

.check-animation {
  animation: scaleIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
  }

  70% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.options-loading {
  opacity: 0.7;
  pointer-events: none;
}

.loading-btn {
  position: relative;
  overflow: hidden;
}

.loading-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0) 100%);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  100% {
    left: 100%;
  }
}

.success-btn {
  animation: successPulse 1.5s ease;
}

@keyframes successPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(62, 228, 67, 0.4);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

.error-btn {
  animation: errorShake 0.4s ease;
}

@keyframes errorShake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

.success-icon-animation {
  animation: successIcon 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes successIcon {
  0% {
    transform: scale(0) rotate(-90deg);
  }

  70% {
    transform: scale(1.2) rotate(10deg);
  }

  100% {
    transform: scale(1) rotate(0);
  }
}

.error-icon-animation {
  animation: errorIcon 0.5s ease;
}

@keyframes errorIcon {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
}

.success-animation {
  animation: bounceIn 0.3s;
}

.success-text-animation {
  animation: fadeInRight 0.2s 0.1s both;
}

@keyframes bounceIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  50% {
    transform: scale(1.1);
  }

  70% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeInRight {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* #endregion */

.topic-list-container {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0px;
  padding-right: 10px;
  margin: 0;
  background-color: transparent !important;
}

.topic-view.active-topic .v-label {
  font-weight: 600;
  color: var(--v-primary-base, #faa91b);
}

.topic-item .topic-view {
  background-color: #FFFFFF;
  border-radius: 12px !important;
  padding: 6px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.topic-item .topic-view:hover {
  background-color: #F5F5F5;
}

.topic-item .topic-editable {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  border-radius: 28px;
  padding: 6px 12px;
}

.topic-item .topic-editable .topic-name-input {
  flex: 1;
  margin-right: 10px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}


.folder-subtopics {
  background-color: transparent !important;
  transition: height 0.3s ease, opacity 0.3s ease;
  margin-left: 5px;
  border-left: 2px solid rgba(0, 0, 0, 0.05);
  border-radius: 0 0 0 12px;
}
.folder-view {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 45px;
  border-radius: 10px;
  padding: 2px 12px;
  background-color: #FFFFFF;
  transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s;
}

.folder-updated-success {
  background-color: rgba(76, 175, 80, 0.1) !important;
  transition: background-color 0.3s ease;
}

.folder-updated-error {
  background-color: rgba(244, 67, 54, 0.1) !important;
  transition: background-color 0.3s ease;
}

.folder-status-icon {
  margin-left: 8px;
  margin-right: 4px;
}

.success-bounce {
  animation: successBounce 0.5s ease;
}

.error-shake {
  animation: errorShake 0.5s ease;
}

@keyframes successBounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes errorShake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-4px);
  }

  50% {
    transform: translateX(4px);
  }

  75% {
    transform: translateX(-4px);
  }

  100% {
    transform: translateX(0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.folder-item {
  border-radius: 10px;
  margin-bottom: 8px;
  transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s;
  
}

.topic-item,
.folder-item,
.folder-view,
.topic-view {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}


/* Modern folder input styling */
.input-folder {
  border-radius: 12px;
  transition: all 0.2s ease;
}

.input-folder:deep(.v-field__outline) {
  opacity: 0.7;
}

.input-folder:deep(.v-field--focused .v-field__outline) {
  opacity: 1;
  border-width: 2px;
}

.input-folder:deep(.v-field__input) {
  font-weight: 500;
  letter-spacing: 0.01em;
  padding-top: 10px;
}

.input-folder:deep(.v-field__prepend-inner) {
  padding-right: 12px;
}

.folder-icon-pulse {
  animation: pulse 2s infinite;
  animation-delay: 0.5s;
}

.clear-input-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.2s ease;
}

.clear-input-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}

.input-folder:deep(.v-counter) {
  opacity: 0.7;
}

.dragging-topic {
  cursor: grabbing !important;
}
.dragging-topic .folder-item,
.dragging-topic .folder-view,
.dragging-topic .topic-item,
.dragging-topic .topic-view {
  cursor: grabbing !important;
}
.sortable-ghost {
  opacity: 0.5;
  background-color: #f5f5f5 !important;
  border: 1px dashed var(--v-primary-base, #faa91b) !important;
  border-radius: 12px;
  max-height: 44px;
}

.topic-view.sortable-ghost {
  background-color: rgba(250, 169, 27, 0.1) !important;
}

.folder-view.sortable-ghost {
  background-color: rgba(250, 169, 27, 0.1) !important;
}
.folder-view.drop-target * {
  cursor: copy !important;
}
.folder-view.drop-target {
  background-color: rgba(250, 169, 27, 0.1) !important;
  box-shadow: 0 0 8px rgba(250, 169, 27, 0.3) !important;
  transform: translateY(-2px);
  transition: all 0.2s ease;
  cursor: copy !important;
  border: 1px solid var(--v-primary-base, #faa91b) !important;
}
.drop-target-outside {
  background-color: rgba(250, 169, 27, 0.1) !important;
  box-shadow: 0 0 8px rgba(250, 169, 27, 0.3) !important;
  transform: translateY(-2px);
  transition: all 0.2s ease;
  cursor: copy !important;
  border: 1px solid var(--v-primary-base, #faa91b) !important;
}
.highlighted-topic {
  border-left: 2px solid var(--v-primary-base, #faa91b) !important;
  box-shadow: 0 2px 4px rgb(215 141 12 / 38%) !important;
}

.highlighted-topic .topic-title {
  color: #1e293b !important;
  font-weight: 500 !important;
}
.model-label-fade-in {
  opacity: 0;
  animation: fadeInUp 0.2s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.icon-mask {
  width: 20px;
  height: 20px;
  background-color: currentColor;
  mask: var(--mask-url) no-repeat center / contain;
  -webkit-mask: var(--mask-url) no-repeat center / contain;
}

/* Submenu Card Styles */
.submenu-card {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden;
}

.submenu-card-title {
  background-color: #f8f9fa;
  font-size: 14px !important;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.submenu-card-item {
  transition: all 0.2s ease;
  border-radius: 0 !important;
}

.submenu-card-item:hover {
  background: linear-gradient(90deg, rgba(198, 46, 14, 0.1) 0%, rgba(246, 119, 96, 0.1) 100%);
}

.submenu-card-item:hover .v-list-item-title {
  color: #c32f0ec8 !important;
  font-weight: 500;
}

.submenu-card-item-active {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 0 !important;
}

.submenu-card-item-active .v-list-item-title {
  color: white !important;
  font-weight: 600 !important;
}

.submenu-card-item .v-list-item-title {
  font-size: 13px !important;
  color: #666;
}
.user-profile-section {
  display: flex;
  align-items: center;
  padding: 8px 5px;
  background-color: #FDB8B833;
  border-radius: 12px;
  cursor: default;
  transition: background-color 0.2s ease;
}

/* Navigation drawer override styles to be above app bar */
.v-navigation-drawer {
  z-index: 1300 !important;
}

.v-app-bar {
  z-index: 1200 !important;
}

/* Ensure main content area respects the drawer */
.v-main {
  padding-left: 0 !important;
  transition: padding-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* When drawer is open on desktop, add padding to main content */
@media (min-width: 1024px) {
  .v-application .v-navigation-drawer--is-mobile-variant {
    z-index: 1300 !important;
  }
  
  .v-application:not(.v-application--is-ltr) .v-navigation-drawer--left.v-navigation-drawer--clipped {
    z-index: 1300 !important;
  }
}

/* Mobile responsive adjustments */
@media (max-width: 1023px) {
  .v-navigation-drawer--temporary {
    z-index: 1400 !important;
  }
}

/* Page Header Styles */
.page-header-section {
  max-width: calc(100% - 120px);
}

.page-title-container {
  flex: 1;
  min-width: 0;
}

.page-title {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600 !important;
  line-height: 1.2;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-breadcrumbs {
  min-height: auto !important;
  font-size: 12px;
}

.page-breadcrumbs .v-breadcrumbs-item {
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.6) !important;
  text-decoration: none;
  padding: 0 !important;
  margin: 0 !important;
}

.page-breadcrumbs .v-breadcrumbs-item:hover {
  color: rgba(0, 0, 0, 0.87) !important;
  text-decoration: underline;
}

.page-breadcrumbs .v-breadcrumbs-item:last-child {
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 500;
}

.page-breadcrumbs .v-breadcrumbs-divider {
  margin: 0 4px !important;
  opacity: 0.4;
}

/* Responsive adjustments for page header */
@media (max-width: 768px) {
  .page-header-section {
    max-width: calc(100% - 80px);
  }
  
  .page-title {
    font-size: 18px !important;
  }
  
  .page-breadcrumbs {
    display: none; /* Hide breadcrumbs on mobile to save space */
  }
}

.v-app-bar :deep(.v-toolbar__content){
  align-items: flex-start;
}

.logo-symmetric {
  /* Ensure consistent and symmetric logo display */
  object-fit: contain !important;
  object-position: center !important;
  image-rendering: crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  
  /* Prevent any distortion */
  aspect-ratio: auto;
  max-width: 100%;
  max-height: 100%;
  
  /* Smooth transitions for any size changes */
  transition: all 0.2s ease-in-out;
  
  /* Ensure proper alignment within container */
  display: block;
  margin: auto;
}
/* SVG icons turn white when menu is active */
.menu-active .icon-container img {
  filter: brightness(0) invert(1) !important;
  transition: filter 0.3s ease !important;
}

/* Base transition for all navigation SVG icons */
.icon-container img {
  transition: filter 0.3s ease;
}
/* SVG icons hover effect for submenus */
.submenu-item:hover img {
  filter: brightness(0.8);
  transition: filter 0.2s ease;
}
/* SVG icons turn white when submenu is active */
.submenu-active img {
  filter: brightness(0) invert(1) !important;
  transition: filter 0.3s ease !important;
}
.page-breadcrumbs .last-breadcrumb:hover {
  color: #171717 !important;
  text-decoration: none !important;
}
.page-breadcrumbs .last-breadcrumb {
  font-weight: 600 !important;
  pointer-events: none;
}

.page-breadcrumbs .last-breadcrumb.v-breadcrumbs-item--disabled {
  color: #171717 !important;
  font-weight: 500 !important;
  opacity: 1 !important;
}

.label-version {
  display: flex;
  padding: 6px 12px 4px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--main, #C32E0E);
  font-size: 6px;
  font-style: normal;
  font-weight: 500;
  border-radius: 50px!important;
  background: linear-gradient(91deg, rgba(246, 119, 96, 0.10) 1.14%, rgba(195, 46, 14, 0.10) 46.51%, rgba(246, 119, 96, 0.10) 120.41%);
}
.policy-link {
  color: #3859D0!important;
  text-decoration: underline!important;
  font-size: 14px;
  font-weight: 400;
  transition: color 0.2s ease;
}
/* Flag styling for rounded appearance */
.language-btn :deep(.flag-icon) {
  border-radius: 50% !important;
  width: 20px !important;
  height: 20px !important;
  object-fit: cover;
  display: inline-block;
}

.language-btn :deep(img[class*="flag"]) {
  border-radius: 50% !important;
  width: 20px !important;
  height: 20px !important;
  object-fit: cover;
}
</style>
